import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, throwError, first, defer, of, Subscription, fromEvent, merge, map as map$1, catchError as catchError$1 } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { take, map, catchError, retry, filter, distinct, debounceTime } from 'rxjs/operators';
import * as _ from 'lodash';
import { CommonModule } from '@angular/common';

class DealModel {
    constructor(data) {
        Object.assign(this, data);
    }
}
class DealUpdateModel {
    constructor(data) {
        Object.assign(this, data);
    }
}
class CouponModel {
    constructor(data) {
        this.updBtnText = 'Added';
        this.updBtnMode = true;
        this.offerPrice = '';
        Object.assign(this, data);
    }
}
class ProductModel {
    constructor(data) {
        this.updBtnText = 'Update';
        this.updBtnMode = true;
        this.dispItemPackageUOM = 'ct';
        Object.assign(this, data);
    }
}
class ProductUpdateModel {
    constructor(data) {
        Object.assign(this, data);
    }
}
class SortModel {
    constructor(data) {
        Object.assign(this, data);
    }
}
class CarouselModel {
    constructor(data) {
        Object.assign(this, data);
    }
}
class DealCarouselModel {
    // To be added
    constructor(data) {
        Object.assign(this, data);
    }
}
class AisleCategoryModel {
    constructor(data) {
        this.aisleId = data.id;
        this.aisleName = data.name;
        this.aislePath = data.pagePath;
        if (window.innerWidth < 768) {
            this.fileReference = data.imagePathMobile;
        }
        else {
            this.fileReference = data.imagePath;
        }
        // README: Updating category path url with current branch id
        const startPlaceHolder = this.aislePath.indexOf('.');
        const endPlaceHolder = this.aislePath.indexOf('.html');
        if (startPlaceHolder !== -1
            && endPlaceHolder !== -1) {
            const branchId = window['AB']?.userInfo?.branchId;
            /*
            * README:
            * step 1 - from the link url get the substring between first dot and dot_html
            * step 2 - split string by dot into multiple elements and save into array
            * (second step is required because the substring might contain multiple structures separated by dot)
            * step 3 - the placeHolder we want to replace will always be at the end of the initial substring, before dot_html
            *
            * This way we make sure we dynamically target the piece of the url that we want to replace.
            */
            const placeHolderString = String(this.aislePath).substring(startPlaceHolder + 1, endPlaceHolder);
            const placeHolderElements = placeHolderString.split('.');
            const placeHolder = placeHolderElements[placeHolderElements.length - 1];
            // README: Make sure that we are updating a url that has an id and not something else
            if (!isNaN(Number(placeHolder))) {
                this.aislePath = String(this.aislePath).replace(placeHolder, branchId);
            }
        }
    }
}
class CouponCarouselModel {
    constructor(data) {
        this.includePageName = '';
        this.logoSVGCouponCarouseImageEnable = false;
        this.logoSVGCouponCarouseImage = '';
        this.modelConfigurationId = '';
        this.offers = {};
        this.calledBy = '';
        Object.assign(this, data);
    }
}

/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains utility methods for interacting with Adobe Target

*/
class ABTestService {
    constructor() {
        this._abTargetLoadedState = new BehaviorSubject(false);
        this.abTargetLoadedState$ = this._abTargetLoadedState.asObservable();
        this.setGRSSpecificParamsInLS = function () {
            let disableGrsEndpoint = window['SWY']['CONFIGSERVICE']
                && window['SWY']['CONFIGSERVICE'].featureToggleConfig
                && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableGrsEndpoint')
                ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableGrsEndpoint
                : true;
            if (!disableGrsEndpoint
                && window['analyticsSwy']
                && window['analyticsSwy']['testFlags']
                && window['analyticsSwy']['testFlags']['EOT_1835']
                && window['analyticsSwy']['testFlags']['EOT_1835'].toLowerCase() === 'a') {
                window['AB']['COMMON'].setUpdateVisitorIdForGrs();
                window['AB']['COMMON'].setSessionIdForGrs();
            }
        };
        if (this.isTargetLoadComplete()) {
            this._abTargetLoadedState.next(true);
        }
        else {
            console.warn("========> AB TESTING ====> target flag is not loaded");
            // The flag has not been loaded yet - add a listener and notify
            // all observers when it is loaded.
            window.addEventListener('AdobeTarget-Complete', (e) => {
                console.warn("========> AB TESTING ====> AdobeTarget-Complete event listener called");
                this.setGRSSpecificParamsInLS();
                this._abTargetLoadedState.next(true);
            }, { once: true });
        }
    }
    isTargetLoadComplete() {
        let loaded = false;
        let mboxDisable = window['AB']['COMMON']['getURLParameterByName']('mboxDisable');
        if ((mboxDisable && (mboxDisable === 1 || mboxDisable === true)) ||
            window['analyticsSwy'] &&
                window['analyticsSwy']['testFlags'] &&
                window['analyticsSwy']['testFlags'][`AdobeTarget-Complete`] == true)
            loaded = true;
        return loaded;
    }
    isABTestingDisabled() {
        let abDisabled = false;
        const queryParams = new URLSearchParams(window.location.search);
        const mboxFlag = queryParams.get('mboxDisable');
        if (mboxFlag && (mboxFlag == "1" || mboxFlag.toLowerCase() == "true")) {
            abDisabled = true;
        }
        return abDisabled;
    }
    getTargetFlagValue(targetFlag) {
        return window['analyticsSwy']
            && window['analyticsSwy']['testFlags']
            && window['analyticsSwy']['testFlags'][targetFlag];
    }
    static { this.ɵfac = function ABTestService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ABTestService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ABTestService, factory: ABTestService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ABTestService, [{
        type: Injectable
    }], () => [], null); })();

/**
 * Angular App Config Service.
 *
 * @file Main Angular's application service provider.
 */
class ConfigService {
    setConfig(config) {
        console.log("ConfigService:SetConfig");
        console.log(config);
        this._config = { ...config };
    }
    getProductConfig() {
        return (this._config && this._config.product) ? { ...this._config.product } : {};
    }
    getCookiesConfig() {
        return (this._config && this._config.cookies) ? { ...this._config.cookies } : {};
    }
    constructor() {
    }
    static { this.ɵfac = function ConfigService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfigService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

/*
@file-overview

- This service creates a global instance of the users session object for components and services to use

- This service must be populated with an object that resembles the response from the AEM /userinfo servlet
  - NOTE : The Interface IUserSession strictly contains only the possible response fields from the AEM /userinfo servlet

*/
class UserInfoService {
    constructor() {
        this.cartModified = new Subject();
        this.$cartModified = this.cartModified.asObservable();
        /**
         * Method for getting the user channel based on the session preference
         *
         *  - Each of the  3 preferences maps to a channel :
         *    - Preference : 'delivery':
                Channel  : 'delivery';
      
              - Preference : 'dug':
                Channel  : 'pickup';
      
              - Preference : 'j4u':
                Channel  : 'instore';
        */
        this.getUserChannel = function () {
            let userPreference = this.getPreference();
            userPreference = userPreference ? userPreference.toLowerCase() : undefined;
            switch (userPreference) {
                case 'delivery':
                    return 'delivery';
                case 'dug':
                    return 'pickup';
                case 'j4u':
                    return 'instore';
                default:
                    return '';
            }
        };
        window['userInfoServiceRefAL'] = {
            service: this
        };
    }
    setUserSession(userSession) {
        console.log("UserInfoService : setUserSession");
        console.log(userSession);
        this._userSession = { ...userSession };
    }
    initUserSession() {
        const { branchId, preferenceMode, j4u, zipcode, clubCard } = window['AB']['userInfo'];
        const userInfo = { ...window['AB']['userInfo'], shopStoreId: branchId, shopZipcode: zipcode, preference: preferenceMode, clubCardNumber: clubCard, j4uStoreId: j4u.storeId, j4uZipcode: j4u.zipcode };
        this.setUserSession(userInfo);
    }
    getUserSession() {
        return this._userSession;
    }
    getSWY_SHOP_TOKEN() {
        return this._userSession['SWY_SHOP_TOKEN'];
    }
    setSWY_SHOP_TOKEN(SWY_SHOP_TOKEN) {
        this._userSession['SWY_SHOP_TOKEN'] = SWY_SHOP_TOKEN;
    }
    getUUID() {
        return this._userSession['UUID'];
    }
    getBanner() {
        return this._userSession['banner'];
    }
    getClubCardNumber() {
        return this._userSession['clubCardNumber'];
    }
    getCustomerId() {
        return this._userSession['customerId'];
    }
    getSiteType() {
        return this._userSession['siteType'];
    }
    getDisplayableBanner() {
        return this._userSession['displayableBanner'];
    }
    getEmail() {
        return this._userSession['email'];
    }
    getExpireTime() {
        return this._userSession['expireTime'];
    }
    getFirstName() {
        return this._userSession['firstName'];
    }
    getJ4uStoreId() {
        return this._userSession['j4uStoreId'];
    }
    getJ4uZipcode() {
        return this._userSession['j4uZipcode'];
    }
    getPreference() {
        return this._userSession['preference'];
    }
    getShopStoreId() {
        return this._userSession['shopStoreId'];
    }
    getStoreId() {
        return this._userSession['storeId'];
    }
    getShopZipcode() {
        return this._userSession['shopZipcode'];
    }
    getUserType() {
        return this._userSession['userType'];
    }
    getWfcStoreId() {
        return this._userSession['wfcStoreId'];
    }
    getHouseId() {
        return this._userSession['houseId'];
    }
    getUnattendedDeliveryIsEnabled() {
        return this._userSession['unattendedDeliveryIsEnabled'];
    }
    getCustomerType() {
        return this._userSession?.customerType;
    }
    /**
     * Method for checking if user has authenticated userType : 'R' or 'C'
     *
     *  - user will have userType 'C' if they signed in with credentials within the past 45 minutes
     *  - user will have userType 'R' if they have signed in, but have not used their credentials within the past 45 minutes
    */
    isAuthorized() {
        const userType = this.getUserType().toUpperCase();
        let isAuthorized = userType === 'R' || userType === 'C' ? true : false;
        return isAuthorized;
    }
    static { this.ɵfac = function UserInfoService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserInfoService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserInfoService, factory: UserInfoService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserInfoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

/*
@file-overview

- These methods were taken from AEM WCAX repos

- The methods were copied into this file and cleaned up to work within other
    consuming applications

*/
class UtilService {
    constructor(_configService, _userInfoService) {
        this._configService = _configService;
        this._userInfoService = _userInfoService;
        // is local storage enabled flag
        this._isLSEnabled = undefined;
        this.isCookieEnabled = function () {
            var isEnabled = (navigator.cookieEnabled) ? true : false;
            // if not IE4+ nor NS6+
            if (typeof navigator.cookieEnabled == 'undefined' && !isEnabled) {
                document.cookie = 'testcookie';
                isEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
            }
            // return to see if cookie is enabled from browser
            return isEnabled;
        };
        //-----------------------------------------------------------------------------------------------------
        /*
            DFTA - methods for user session status checking
        */
        this.checkAuthorizedCookie = function () {
            var strSharedSession = this.getCookie('SWY_SHARED_SESSION_INFO');
            var result = false;
            var objSharedSession = {};
            try {
                if (strSharedSession) {
                    objSharedSession = JSON.parse(strSharedSession);
                    result = (typeof objSharedSession == "object") ? true : false;
                }
            }
            catch (e) {
                result = false;
            }
            return result;
        };
        this.updateTokenRefreshProperty = function () {
            var sharedInfo = this.getCookie('SWY_SHARED_SESSION_INFO');
            if (sharedInfo != "") {
                sharedInfo = decodeURI(sharedInfo);
                sharedInfo = JSON.parse(sharedInfo);
                if (!this.isEmpty(sharedInfo.info)) {
                    if (!this.isEmpty(sharedInfo.info.SHOP)) {
                        const shopSharedInfo = sharedInfo.info.SHOP;
                        const userType = (shopSharedInfo.userType !== undefined) ? shopSharedInfo.userType : '';
                        let newSession = {
                            ...this._userInfoService.getUserSession(),
                            userType: userType
                        };
                        if (shopSharedInfo.userData) {
                            const expireTime = (shopSharedInfo.userData.expireTime !== undefined) ? shopSharedInfo.userData.expireTime : '';
                            newSession['expireTime'] = expireTime;
                        }
                        this._userInfoService.setUserSession(newSession);
                    }
                }
            }
        };
        /**
           * Check if user is still logged in.
           */
        this.isTokenActive = function () {
            // declare function variable(s)
            var currentTime = null;
            var expireTime = null;
            var isTokenActive = false;
            if (this._userInfoService.getExpireTime()) {
                currentTime = (new Date()).getTime();
                expireTime = parseInt(this._userInfoService.getExpireTime());
                if (expireTime > currentTime) {
                    isTokenActive = true;
                }
            }
            return isTokenActive;
        };
    }
    isEmpty(obj) {
        // null and undefined are "empty"
        if (obj == null)
            return true;
        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0)
            return false;
        if (obj.length === 0)
            return true;
        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object")
            return true;
        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key))
                return false;
        }
        return true;
    }
    getCookie(cname) {
        var cvalue = '';
        // check if cookie is enabled
        if (this.isCookieEnabled()) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    cvalue = c.substring(name.length, c.length);
                }
            }
        }
        else {
            let cookiesStorage = this._configService.getCookiesConfig().cookiesStorage;
            let cookie = cookiesStorage[cname];
            if (typeof cookie != 'undefined' && this.hasTimeExpired(cookie['expires']) == false) {
                cvalue = decodeURIComponent(cookie['value']);
            }
        }
        return cvalue;
    }
    setCookie(cname, cvalue, exdays, isOktaExpiration) {
        var d = new Date();
        var expires = '';
        var isOkta = false;
        if (isOktaExpiration && isOktaExpiration === 'true') {
            expires = exdays;
            isOkta = true;
        }
        else {
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = 'expires=' + d.toUTCString();
        }
        // check if cookie is enabled
        if (this.isCookieEnabled()) {
            if (exdays > 0 || isOkta) {
                if (this.tagCookiesSecure()) {
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure;";
                }
                else {
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                }
            }
            else {
                if (this.tagCookiesSecure()) {
                    document.cookie = cname + "=" + cvalue + ";path=/;secure;";
                }
                else {
                    document.cookie = cname + "=" + cvalue + ";path=/";
                }
            }
        }
        else {
            let cookiesStorage = this._configService.getCookiesConfig().cookiesStorage;
            cookiesStorage[cname] = { 'value': cvalue, 'expires': d.toUTCString() };
        }
    }
    hasTimeExpired(expiry) {
        var hasExpired = false;
        var currentTime = null;
        var expiryTime = null;
        try {
            if (expiry) {
                currentTime = (new Date()).getTime();
                expiryTime = new Date(expiry).getTime();
                hasExpired = currentTime > expiryTime;
            }
        }
        catch (e) {
            hasExpired = true;
        }
        return hasExpired;
    }
    tagCookiesSecure() {
        let cookiesSecureFlag = this._configService.getCookiesConfig().cookiesSecureFlag;
        return (typeof cookiesSecureFlag !== "undefined" && cookiesSecureFlag !== null &&
            cookiesSecureFlag !== '' && cookiesSecureFlag === 'false') ? false : true;
    }
    isLSEnabled() {
        return this._isLSEnabled;
    }
    setIsLSEnabled(enabled) {
        this._isLSEnabled = enabled;
    }
    isLSCompatible() {
        let test = 'test';
        try {
            if (typeof this.isLSEnabled() == 'undefined') {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                console.log('==== LOCAL STORAGE IS ENABLED ====');
                this.setIsLSEnabled(true);
            }
        }
        catch (e) {
            console.log('==== LOCAL STORAGE IS DISABLED ====');
            this.setIsLSEnabled(false);
        }
        return this.isLSEnabled();
    }
    /**
       * This method will return the url query param value.
       * @param {string} params - The query param that needs to be returned.
      **/
    getParams(params) {
        const param = new URLSearchParams(window.location.search);
        return param.get(params) ? param.get(params) : null;
    }
    /**
     * Returns the queryParam string for GR Search
     * @param {string} channel
     * @returns {string}
     *
     * @memberOf UtilService
     */
    getGRSearchParams(channel) {
        let fqParam = '&fq=inventoryAvailable:"1"OR"2"';
        if (window['analyticsSwy']?.testFlags?.EOT3079) {
            if (channel === 'pickup') {
                fqParam = '&fq=pickupInventory:"1"OR"2"';
            }
            else if (channel === 'delivery') {
                fqParam = '&fq=deliveryInventory:"1"OR"2"';
            }
            fqParam += '&variant=' + window['analyticsSwy']?.testFlags?.EOT3079?.toLowerCase();
            if (window['AB']['COMMON'].getCookie('absVisitorId')) {
                fqParam += '&visitorId=' + window['AB']['COMMON'].getCookie('absVisitorId');
            }
            if (window['AB']['userInfo']['UUID']) {
                fqParam += '&uuid=' + window['AB']['userInfo']['UUID'];
            }
        }
        return fqParam;
    }
    //----------------------------------------------------------------------------
    /**
     * Gets an optional HTML element reference by selector.
     *
     * @param  name  element name/selector
     * @return HTML element reference, null if not found
     */
    //----------------------------------------------------------------------------
    readElement(name) {
        const $element = $(name);
        if ($element && $element.length)
            return $element;
        return null;
    } // readElement
    //----------------------------------------------------------------------------
    /**
     * Gets an first optional HTML element reference by selector.
     *
     * @param  name  element name/selector
     * @return HTML element reference, null if not found
     */
    //----------------------------------------------------------------------------
    readOneElement(name) {
        const $element = $(name);
        if ($element && $element.length)
            return $element[0];
        return null;
    } // readOneElement
    //----------------------------------------------------------------------------
    /**
     * Gets a mandatory HTML element reference by selector.
     *
     * @param  name  element name/selector
     * @return HTML element reference, never null
     */
    //----------------------------------------------------------------------------
    getElement(name) {
        const $element = this.readElement(name);
        if ($element === null) {
            throw new Error("Cannot find element: " + name);
        }
        return $element;
    } // getElement
    //----------------------------------------------------------------------------
    /**
     * Gets a mandatory meta content attribute reference by selector.
     *
     * @param  name  meta name/selector
     * @return HTML meta content attribute, never null
     */
    //----------------------------------------------------------------------------
    getMetaElementContent(name) {
        const $element = $('meta[name=' + name + ']');
        if ($element === null) {
            throw new Error("Cannot find element: " + name);
        }
        return $element.attr('content');
        ;
    }
    nativeFind(collection, eventTracking) {
        let matchingItem = undefined;
        if (typeof eventTracking != 'object')
            return undefined;
        collection.forEach(item => {
            if (this.matches(item, eventTracking)) {
                matchingItem = item;
            }
        });
        return matchingItem;
    }
    // Determines partial equality between two objects. 
    // Object 1 must partially equal object 2, i.e it contains at least all the properties object 2 contains. 
    matches(object1, object2) {
        for (const key in object2) {
            if (object2.hasOwnProperty(key)) {
                if (typeof object2[key] === 'object' && object2[key] !== null) {
                    if (!this.matches(object1[key], object2[key])) {
                        return false;
                    }
                }
                else {
                    if (!object1.hasOwnProperty(key) || object1[key] !== object2[key]) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    static { this.ɵfac = function UtilService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UtilService)(i0.ɵɵinject(ConfigService), i0.ɵɵinject(UserInfoService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UtilService, factory: UtilService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: ConfigService }, { type: UserInfoService }], null); })();

/*
@file-overview

- This service contains a collection of global window methods availible on AEM pages and other SPA applications

- NOTE : None of these functions are currently being used in this abs-ngx-library

*/
class AemService {
    constructor(_configService, _userInfoService, _utilService) {
        this._configService = _configService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
    }
    // AB
    getXPIgalleryPath() {
        return window['AB'].xAPIgalleryPath;
    }
    getInstantAllocation() {
        return window['AB'].instantAllocation;
    }
    getCompanionOffersxAPIHttpOptions() {
        return window['AB'].companionOffersxAPIHttpOptions; //available in fullcart window
    }
    getGalleryRegisterPath() {
        return window['AB'].galleryRegisterPath;
    }
    getJ4uHttpOptions() {
        return window['AB'].j4uHttpOptions;
    }
    getJ4uHttpOptions11() {
        return window['AB'].j4uHttpOptions11;
    }
    getPreUcaHttpOptions() {
        return window['AB']['preUcaHttpOptions'];
    }
    getLoyaltyPartnersPath() {
        return window['AB']['loyaltyPartnersPath'];
    }
    removeHistoryAction() {
        return window['AB']['removeHistoryAction'];
    }
    getSearchRank() {
        return window['AB']['searchRank'];
    }
    setSearchRank(searchRank) {
        window['AB']['searchRank'] = searchRank;
    }
    getDealsFilter() {
        return window['AB']['dealsFilter']; //available in full cart window
    }
    getCartApimKey() {
        return window['AB']['cartapimkey'];
    }
    getCartApimTrace() {
        return window['AB']['cartapimtrace'];
    }
    getCartBaseUrl() {
        return window['AB']['cartbaseurl'];
    }
    getCartUrl() {
        return window['AB']['carturl'];
    }
    getCartByCustUrl() {
        return window['AB']['getcartbycusturl'];
    }
    getAddToCartPath() {
        return window['AB']['addToCartPath']; //available in full cart window
    }
    getDMTProductCard() {
        return this._configService.getProductConfig().productImageUrl;
        // return window['AB']['dMTProductCard'];
    }
    getDMTMiniCart() {
        return window['AB']['dMTMiniCart'];
    }
    getRemoveProductHistoryPath() {
        return window['AB']['removeProductHistoryPath']; //available in full cart window
    }
    getAttendDeliveryTxt() {
        return window['AB']['attendDeliveryTxt']; //available in full cart window
    }
    getCouponClipPath() {
        return window['AB']['couponClipPath']; //available in full cart window
    }
    getCouponUnclipPath() {
        return window['AB']['couponUnclipPath'];
    }
    getMiniCartPath() {
        return window['AB']['miniCartPath'];
    }
    getProductGridPage() {
        return window['AB']['productGridPage'];
    }
    getItemNotAvailableTxt() {
        return window['AB']['itemNotAvailableTxt']; //available in full cart window
    }
    getAvailableSorts() {
        return window['AB']['availableSorts'];
    }
    getHeaderType() {
        return window['AB']['headerType'];
    }
    getDefaultSort() {
        return window['AB']['defaultSort'];
    }
    getOfferId() {
        return window['AB']['offerId'];
    }
    getGridDataURL() {
        return window['AB']['gridDataURL']; //available in full cart window
    }
    getGridDataURLNoParam() {
        return window['AB']['gridDataURLNoParam'];
    }
    getAisleHTMLPath() {
        return window['AB']['aisleHTMLPath'];
    }
    getAisleHTMLTitlePath() {
        return window['AB']['aisleHTMLTitlePath'];
    }
    getLastOrderErumsHttpOptions() {
        return window['AB']['lastOrderErumsHttpOptions'];
    }
    getAemAislePath() {
        return window['AB']['aemAislePath'];
    }
    getErrorText() {
        return window['AB']['errorText'];
    }
    getCatalogXapiProductsBpnEndpoint() {
        return window['AB']['catalogXapiProductsBpnEndpoint'];
    }
    getCatalogXapiProductsUpcEndpoint() {
        return window['AB']['catalogXapiProductsUpcEndpoint'];
    }
    // AB LAZYLOAD
    initLazyLoad() {
        if (window['AB']['LAZYLOAD']) {
            window['AB']['LAZYLOAD'].init(); //available in full cart window
        }
    }
    // AB CART
    mergeCart() {
        window['AB'].CART._mergeCart();
    }
    // AB USERINFO
    getUserInfo() {
        return window['AB'] ? window['AB']['userInfo'] : undefined; //Empty object in full cart window
    }
    getCustomerId() {
        return window['AB']['userInfo'].customerId;
    }
    getBranchId() {
        return window['AB']['userInfo']['branchId'];
    }
    getPreferenceMode() {
        return window['AB']['userInfo']['preferenceMode'];
    }
    getBoxTopAuth() {
        return window['AB'].userInfo.boxTopAuth;
    }
    setBoxTopAuth(auth) {
        window['AB'].userInfo.boxTopAuth = auth;
    }
    getSWY_SHOP_TOKEN() {
        return window['AB']['userInfo']['SWY_SHOP_TOKEN'];
    }
    clubCard() {
        return window['AB']['userInfo']['clubCard'];
    }
    getBanner() {
        return window['AB']['userInfo']['banner'];
    }
    getBoxTopCalled() {
        return window['AB'].userInfo.boxTopCalled;
    }
    setBoxTopCalled(boxTopCalled) {
        window['AB'].userInfo.boxTopCalled = boxTopCalled;
    }
    // AB USERINFO J4U
    getStoreId() {
        return window['AB'].userInfo.j4u.storeId;
    }
    getHouseId() {
        return window['AB']['userInfo'].houseId;
    }
    unattendedDeliveryIsEnabled() {
        return window['AB']['userInfo']['unattendedDeliveryIsEnabled'];
    }
    // AB COMMON
    getURLParameterByName(name, doDecode) {
        return window['AB']['COMMON'].getURLParameterByName(name, doDecode); //COMMON available in full cart window
    }
    authorize() {
        return window['AB']['COMMON'].authorize();
    }
    isProductCardABtestEnabled() {
        return window['AB']['COMMON'] && window['AB']['COMMON'].isProductCardABtestEnbaled ? window['AB']['COMMON'].isProductCardABtestEnbaled() : false;
    }
    sessionNotExpired() {
        return true; // FIX
        //  return window['AB']['COMMON'].sessionNotExpired();
    }
    checkCartId(cartName) {
        return window['AB']['COMMON'].checkCartId(cartName);
    }
    getCartId(cartName) {
        return window['AB']['COMMON'].getCartId(cartName);
    }
    setCartId(cartName, cartId) {
        window['AB']['COMMON'].setCartId(cartName, cartId);
    }
    invalidateCartId() {
        window['AB']['COMMON'].invalidateCartId();
    }
    isLSCompatible() {
        return window['AB'].COMMON.isLSCompatible();
    }
    getStoreStatus() {
        if (window['AB']['COMMON'] && window['AB']['COMMON'].getStoreStatus)
            window['AB']['COMMON'].getStoreStatus();
    }
    ucaAPIPathWithCustomerId(path) {
        return window["AB"].COMMON.ucaAPIPathWithCustomerId(path);
    }
    showCreateAccountModalJ4U(clickSource, modalLink) {
        window['AB']['COMMON'].showCreateAccontModalJ4U(clickSource, modalLink);
    }
    getCookie(cookieName) {
        return window['AB'].COMMON.getCookie(cookieName);
    }
    /**
     * Method to get slotInfo cookie based on site type
     * returns slotInfo cookie
     */
    getSlotIdCookie() {
        if (this._userInfoService.getSiteType() === 'B') {
            return this._utilService.getCookie('B_SlotInfo');
        }
        else {
            return this._utilService.getCookie('SlotInfo');
        }
    }
    getOrderNumberCookie() {
        if (this._userInfoService.getSiteType() === 'B') {
            return this._utilService.getCookie('B_OrderNumber');
        }
        return this._utilService.getCookie('OrderNumber');
    }
    getOrderStoredIdCookie() {
        if (this._userInfoService.getSiteType() === 'B') {
            return this._utilService.getCookie('B_OrderStoreId');
        }
        return this._utilService.getCookie('OrderStoreId');
    }
    setCookie(cookieName, cookieValue, expireDays) {
        window['AB']['COMMON'].setCookie(cookieName, cookieValue, expireDays);
    }
    getUserChannel() {
        return window['AB']['COMMON'] && window['AB']['COMMON'].getUserChannel ? window['AB']['COMMON'].getUserChannel() : '';
    }
    checkUnAttendedDelivery() {
        return window['AB'].COMMON.checkUnAttendedDelivery();
    }
    getBreakpoint() {
        return window['AB']['COMMON'].getBreakpoint();
    }
    getAisleLevel3Id() {
        return window['AB']['aisleLevel3Id'];
    }
    getAvailabilityCheck() {
        const availableItemsOnly = this.getURLParameterByName('availability', true);
        return availableItemsOnly === 'true' ? true : false;
    }
    // AB MINICART
    //Empty object on full cart page
    loadCartPrice() {
        window['AB']['MINICART'].loadCartPrice();
    }
    getBaseURLeRUMS() {
        return window['AB']['MINICART'].getBaseURLeRUMS();
    }
    // AB ALERT
    //Empty object on full cart page
    checkReserveTime() {
        window['AB']['ALERT'].checkReserveTime();
    }
    // SWY ENFORCEMENTUTILS
    //Available on window in full cart page
    updateReInitSite(targetSite) {
        window['SWY'].ENFORCEMENTUTILS.updateReInitSite(targetSite);
    }
    checkAuthorizedCookie() {
        return window['SWY'].ENFORCEMENT.checkAuthorizedCookie();
    }
    isTokenActive() {
        return window['SWY'].ENFORCEMENT.isTokenActive();
    }
    // SWY CONFIGSERVICE
    featureToggleConfig() {
        return window['SWY'].CONFIGSERVICE.featureToggleConfig;
    }
    getProp65Details() {
        return window['SWY']['CONFIGSERVICE'].getProp65Details();
    }
    getDisableInStoreChannelCheck() {
        return window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableInStoreChannelCheck')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableInStoreChannelCheck
            : true;
    }
    getDnfEligilityDisabledCheck() {
        return window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('dnfEligibilityDisabled')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.dnfEligibilityDisabled
            : true;
    }
    // SWY CONFIGSERVICE SEARCHCONFIG
    getApimSubscriptionKey() {
        return window['SWY'] && window['SWY'].CONFIGSERVICE && window['SWY'].CONFIGSERVICE.searchConfig ? window['SWY'].CONFIGSERVICE.searchConfig['apimSubscriptionKey'] : undefined;
        //    return window['SWY'].CONFIGSERVICE.searchConfig.apimSubscriptionKey;
    }
    getApimSearchPath() {
        return window['SWY'].CONFIGSERVICE.searchConfig['apimSearchPath'];
    }
    getApimSearchSponsoredCarouselEndpoint() {
        return window['SWY'].CONFIGSERVICE.searchConfig['apimSearchSponsoredCarouselEndpoint'];
    }
    // SWY CONFIGSERVICE CATALOGCONFIG
    getApimCatalogPath() {
        return window['SWY'].CONFIGSERVICE.catalogConfig['apim.api.catalog.path'];
    }
    getApimCatalogDepartmentsEndpoint() {
        return window['SWY'].CONFIGSERVICE.catalogConfig['apim.api.catalog.departments.endpoint'];
    }
    // SWY CONFIGSERVICE ERUMSCONFIG
    getEditOrderOldVersion() {
        return window['SWY']['CONFIGSERVICE'].erumsConfig['editorder.oldversion'];
    }
    // SWY CONFIGSERVICE NIMBUSCONFIG
    getCouponImageBaseUrl() {
        return window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl;
    }
    getCouponTypes() {
        return window['SWY'].CONFIGSERVICE.nimbusConfig.couponTypes;
    }
    // SWY CONFIGSERVICE WCAXXAPICONFIG
    getXApiKey() {
        return window['SWY'].CONFIGSERVICE.wcaxXapiConfig["wcax.xapi.apim.key"];
    }
    getUidValue() {
        return document.cookie.match('(^|;)\\s*_br_uid_2\\s*=\\s*([^;]+)') || '';
    }
    isAllowWiremockService() {
        return window['AB'].allowWiremockService;
    }
    getWcaxXapiApimKey() {
        return window['AB']['wcaxXapiApimKey'];
    }
    // --------------------------------------------------------------------------
    /**
     *  Returns the base location of the feature flags
     */
    // --------------------------------------------------------------------------
    getFeatureFlagBase() {
        return window['SWY']?.CONFIGSERVICE?.featureToggleConfig;
    }
    /**
    *  DESCRIPTION:  Generic function to retrive all base flags
    *  flagKey - String value of the feature name
    */
    // --------------------------------------------------------------------------
    getFeatureFlagByNameDisable(flagKey) {
        let baseFlags = { ...this.getFeatureFlagBase() };
        return (baseFlags[flagKey] && baseFlags[flagKey]) !== true ? false : true;
    }
    /**
     * Set Domain Cookie
     *
     * @param cookieName
     * @param cookieValue
     * @param expireDays
     */
    setDomainCookie(cookieName, cookieValue, expireDays) {
        window['SWY'].CONFIGSERVICE.setDomainCookie(cookieName, cookieValue, window['SWY'].CONFIGSERVICE.resolvedBanner + '.com', expireDays);
    }
    getArFlag() {
        return window['AB']['arFlag'];
    }
    isArFlagLoaded() {
        return window['AB']['arFlagLoaded'];
    }
    isThemeBuilderEnabled() {
        return window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].isThemeBuilderEnabled;
    }
    getSnsOffer() {
        return window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].bannerConventionsJson
            && window['SWY']['CONFIGSERVICE'].bannerConventionsJson.snsOffer ?
            window['SWY']['CONFIGSERVICE'].bannerConventionsJson.snsOffer : '5%';
    }
    isLSEnabled() {
        return window['AB'].isLSEnabled;
    }
    /**
     * check if Wineshop is enabled for store
     */
    _isWineShopEnabledForStore() {
        const storeFlagsData = window['AB'].storeFlagsData;
        const isWineD2CEnabled = storeFlagsData && storeFlagsData['flags']
            && storeFlagsData['flags']['ecomStore']
            && storeFlagsData['flags']['ecomStore']['storeFeatures']
            && storeFlagsData['flags']['ecomStore']['storeFeatures']['isWineD2CEnabled'] === true ?
            true : false;
        return isWineD2CEnabled;
    }
    static { this.ɵfac = function AemService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AemService)(i0.ɵɵinject(ConfigService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(UtilService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AemService, factory: AemService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AemService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: ConfigService }, { type: UserInfoService }, { type: UtilService }], null); })();

/*
@file-overview

- This file contains the required information for succesful requests for needed services
    within the different enviorments

*/
const EnviormentConfig = {
    dev1: {
        currentEnv: "dev1",
        baseURL: "https://www-dev1.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/qapub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'cb8c6ba089134b799a5892ed7bb5dae9'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/acceptancepub/xapi/search/substitute',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '061d4366162045c6879eca9eab9b7e89'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '282a6d0c0ff142e485e58154cd248c2d'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '051db3bccc0f490aad2be512ca4f4fe2'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/qapub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/qapub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            apimBasePath: '/abs/qapub',
            cartV2API: '/abs/qapub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "acceptance.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/acceptancepub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "061d4366162045c6879eca9eab9b7e89",
            "apim.api.catalog.path": "/abs/acceptancepub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/devpub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "133050c8da964dafb63bcb6c6aba00a0",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
            'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
            'clipPath': '/abs/qa1pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qa1pub/web/j4u/api/offers/unclip'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/acceptancepub/xapi/offers',
            'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "49c7b49a2bf94a5ca7e318c84ca9cbb2",
            snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
            arAuthorizeBasePath: "/abs/acceptancepub",
            arScriptBasePath: "/abs/acceptancepub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
        },
        wiremockAPIDetails: {
            allowWiremockService: true,
            subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
            playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
            recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
        },
        snsConfig: {
            url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
        },
    },
    dev2: {
        currentEnv: "qa1",
        baseURL: "https://www-dev2.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/qapub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'cb8c6ba089134b799a5892ed7bb5dae9'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/acceptancepub/xapi/search/substitute',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '061d4366162045c6879eca9eab9b7e89'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '282a6d0c0ff142e485e58154cd248c2d'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '051db3bccc0f490aad2be512ca4f4fe2'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/qapub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/qapub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            apimBasePath: '/abs/qapub',
            cartV2API: '/abs/qapub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "acceptance.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/acceptancepub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "061d4366162045c6879eca9eab9b7e89",
            "apim.api.catalog.path": "/abs/acceptancepub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "acceptance.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/acceptancepub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "061d4366162045c6879eca9eab9b7e89",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "133050c8da964dafb63bcb6c6aba00a0",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
            'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
            'clipPath': '/abs/qa1pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qa1pub/web/j4u/api/offers/unclip'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/acceptancepub/xapi/offers',
            'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "45000d8081a744fb858f26f463d4f5ae",
            snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
            arAuthorizeBasePath: "/abs/acceptancepub",
            arScriptBasePath: "/abs/acceptancepub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
        },
        wiremockAPIDetails: {
            allowWiremockService: true,
            subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
            playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
            recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
        },
        snsConfig: {
            url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
        }
    },
    dev3: {
        currentEnv: "qa1",
        baseURL: "https://www-dev3.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/qapub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'cb8c6ba089134b799a5892ed7bb5dae9'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/acceptancepub/xapi/search/substitute',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '061d4366162045c6879eca9eab9b7e89'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '282a6d0c0ff142e485e58154cd248c2d'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '051db3bccc0f490aad2be512ca4f4fe2'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/qapub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/qapub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            apimBasePath: '/abs/qapub',
            cartV2API: '/abs/qapub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/devpub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "apim.api.catalog.path": "/abs/devpub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/devpub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "b5d01bd0-3c93-46cb-a63e-7dced08b617d",
            'X-IBM-Client-Secret': "xC6lD4nL7hY4cF6pJ6dO8fV5vM1aA6lL6hT4lX1rV0lV1vQ0hU",
            'clipPath': '/abs/dvpub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/dvpub/web/j4u/api/offers/unclip'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/devpub/xapi/offers',
            'upcsByOfferIds': '/abs/devpub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/devpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "45000d8081a744fb858f26f463d4f5ae",
            snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
            arAuthorizeBasePath: "/abs/acceptancepub",
            arScriptBasePath: "/abs/acceptancepub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "6125bedf8ff9460aa41739349be602db"
        },
        wiremockAPIDetails: {
            allowWiremockService: false,
            subscriptionKey: "",
            playbackBaseUrl: "",
            recorderBaseUrl: ""
        },
        snsConfig: {
            url: '/abs/devpub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
        }
    },
    qa1: {
        currentEnv: "qa1",
        baseURL: "https://www-qa1.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/qapub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '8ca6295a55f54368844b5982edc1cc01'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/qapub/xapi/search/substitute',
            searchParam: 'https://www-qa1.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'a6bbc777a82f45a9b1413af0ce35604f'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/qapub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'ae53203f912448a7a13c70272d5c75fb'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/qapub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '6952f7ab5d204b73a8c514c71fcc68c5'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/qapub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/qapub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            apimBasePath: '/abs/qapub',
            cartV2API: '/abs/qapub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "qa.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/qapub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "b0f931272efc4766a535e6030b79574d",
            "apim.api.catalog.path": "/abs/qapub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "qa.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/qapub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "a6bbc777a82f45a9b1413af0ce35604f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "b0f931272efc4766a535e6030b79574d",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "9b1d97cf-4ddc-4e81-95e5-035c204c4ef6",
            'X-IBM-Client-Secret': "G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6",
            "X-SWY_BANNER": "safeway",
            "x-swy-correlation-id": "01e7b8fd-f501-4519-886c-daf340fa6967",
            "X-SWY_API_KEY": "emjou",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_VERSION_Offers": "1.1",
            'clipPath': '/abs/qapub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qapub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/qapub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/qapub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/qapub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/qapub/xapi/offers',
            'upcsByOfferIds': '/abs/qapub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/qapub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "6173c51c68254b0dada9ce698e96d2f3",
            snsEndpointAllSubscriptionsKey: "267402756dc5413ab6ec8bc403100042",
            arAuthorizeBasePath: "/abs/qapub",
            arScriptBasePath: "/abs/qapub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "b63410670d33422186409d4ad55c9030"
        },
        wiremockAPIDetails: {
            allowWiremockService: true,
            subscriptionKey: "8ca6295a55f54368844b5982edc1cc01",
            playbackBaseUrl: "/abs/qapub/mock-playback/mockinator/playback",
            recorderBaseUrl: "/abs/qapub/mock-recorder/mockinator"
        },
        snsConfig: {
            url: '/abs/qapub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
        }
    },
    qa2: {
        currentEnv: "qa2",
        baseURL: "https://www-qa2.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/acceptancepub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '35570fd5f27f4d69948bafbb4dd4f878'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/acceptancepub/xapi/search/substitute',
            searchParam: 'https://www-qa2.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '061d4366162045c6879eca9eab9b7e89'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/acceptancepub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '282a6d0c0ff142e485e58154cd248c2d'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/acceptancepub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'cbca35c27eab4e57924becd81cee41c9'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/acceptancepub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/acceptancepub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '26dfa6ab7afe4a88805ce9f5351b78b4'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'ab4d24c982614a3ba20e1ae0593ed3b5'
            },
            apimBasePath: '/abs/acceptancepub',
            cartV2API: '/abs/acceptancepub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "acceptance.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/acceptancepub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "061d4366162045c6879eca9eab9b7e89",
            "apim.api.catalog.path": "/abs/acceptancepub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "acceptance.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/acceptancepub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "061d4366162045c6879eca9eab9b7e89",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "133050c8da964dafb63bcb6c6aba00a0",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "652b1bdf-df33-43e2-81e3-278fecf91c5c",
            'X-IBM-Client-Secret': "kY5pU2cW4gS0cF3wD1oF0dT2hX1lL3yP1fT3pY3nB2tH0hU5hY",
            'clipPath': '/abs/qa1pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qa1pub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/qa1pub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/acceptancepub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/acceptancepub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/acceptancepub/xapi/offers',
            'upcsByOfferIds': '/abs/acceptancepub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/acceptancepub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/acceptancepub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "49c7b49a2bf94a5ca7e318c84ca9cbb2",
            snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
            arAuthorizeBasePath: "/abs/acceptancepub",
            arScriptBasePath: "/abs/acceptancepub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "e5b1bf4a9c124561ba364ac53c2cbc66"
        },
        wiremockAPIDetails: {
            allowWiremockService: true,
            subscriptionKey: "35570fd5f27f4d69948bafbb4dd4f878",
            playbackBaseUrl: "/abs/acceptancepub/mock-playback/mockinator/playback",
            recorderBaseUrl: "/abs/acceptancepub/mock-recorder/mockinator"
        },
        snsConfig: {
            url: '/abs/acceptancepub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '64e226bfbc1148d3b3f076a33d654595',
        }
    },
    qa3: {
        currentEnv: "qa3",
        baseURL: "https://www-qa3.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/perfpub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '6eb4decfcd01473aa5ee0a690cc39006'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/perfpub/xapi/search/substitute',
            searchParam: 'https://www-qa3.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '49384d1586e9426ab1ab525c95cf18ff'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/perfpub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'a51715bbe5a64a9bb5c008d80d38e362'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/perfpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '656233f099754e94b1e1e42f71c4677f'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/perfpub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/perfpub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'b029945667514b5a887e4764fa1f6df9'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'abb0423b458e4cf6a1f1dad5666a5127'
            },
            apimBasePath: '/abs/perfpub',
            cartV2API: '/abs/perfpub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "perf.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/perfpub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "49384d1586e9426ab1ab525c95cf18ff",
            "apim.api.catalog.path": "/abs/perfpub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "perf.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/perfpub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "49384d1586e9426ab1ab525c95cf18ff",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "19e5b39b4afc425bba33841a60a9dcd5",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "f537e42e-b56e-4c08-b4cf-159735dc889b",
            'X-IBM-Client-Secret': "eL0uY3yM2lF6kJ7jN2fO5jA0qP3lK2vX3pX5hM1cX3nS7uJ3mA",
            'clipPath': '/abs/qa1pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qa1pub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/qa1pub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/perfpub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/perfpub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/perfpub/xapi/offers',
            'upcsByOfferIds': '/abs/perfpub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/perfpub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/perfpub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "c8a4300d1b5048c5946b6b11e5bd9919",
            snsEndpointAllSubscriptionsKey: "46d30fd9331a4faa9dd20dce1d4db0f3",
            arAuthorizeBasePath: "/abs/perfpub",
            arScriptBasePath: "/abs/perfpub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "2af9cc1fbd3348f1bf4c47ee480542e5"
        },
        wiremockAPIDetails: {
            allowWiremockService: false,
            subscriptionKey: "",
            playbackBaseUrl: "",
            recorderBaseUrl: ""
        },
        snsConfig: {
            url: '/abs/perfpub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '46d30fd9331a4faa9dd20dce1d4db0f3',
        },
    },
    stage: {
        currentEnv: "stage",
        baseURL: "https://www-stage.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/stgpub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'f8bee8d7e7d14a11ac8197d3088cbe3b'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/stgpub/xapi/search/substitute',
            searchParam: 'https://www-stage.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'f42494b71bf94bd1b87f937a60ee990e'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/stagepub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'b47044a7120d4a25aba1738170f979aa'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/stgpub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'e4c13d90a2c04e858e9327d9908caaa0'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/stgpub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/stgpub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'b67277d0d0d04e0da852c5e79b19b025'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '221f4ec2121a4e79a2676ffb0dae44e0'
            },
            apimBasePath: '/abs/stgpub',
            cartV2API: '/abs/stgpub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "stage.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/stagepub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "f42494b71bf94bd1b87f937a60ee990e",
            "apim.api.catalog.path": "/abs/stgpub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "stage.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/stagepub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "f42494b71bf94bd1b87f937a60ee990e",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "f8bee8d7e7d14a11ac8197d3088cbe3b",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "b09e2ed0-494d-44da-bb90-70de110efb31",
            'X-IBM-Client-Secret': "P1wX4nX1dG1iG2kM0sY0sB0rJ4oT0jT2wC1mG1vF7uY7kL3yE7",
            'clipPath': '/abs/stgpub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/stgpub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/stgpub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/stgpub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/stgpub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/stgpub/xapi/offers',
            'upcsByOfferIds': '/abs/stgpub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/stgpub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpc': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "0c289898aecf49079e191d369ac648ae",
            snsEndpointAllSubscriptionsKey: "b47044a7120d4a25aba1738170f979aa",
            arAuthorizeBasePath: "/abs/stagepub",
            arScriptBasePath: "/abs/stgpub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "38c2e3420b8b450d9ffd5564ff22c4f0"
        },
        wiremockAPIDetails: {
            allowWiremockService: false,
            subscriptionKey: "",
            playbackBaseUrl: "",
            recorderBaseUrl: ""
        },
        snsConfig: {
            url: '/abs/stagepub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: 'b47044a7120d4a25aba1738170f979aa',
        }
    },
    betaprod: {
        currentEnv: "prod",
        baseURL: "https://www-beta.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/pub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '7bad9afbb87043b28519c4443106db06'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/pub/xapi/search/substitute',
            searchParam: 'https://www-beta.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'e914eec9448c4d5eb672debf5011cf8f'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/pub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '5e790236c84e46338f4290aa1050cdd4'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'f775c6e1cecf4ec5849ea7fb1add9114'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/pub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/pub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'ce4dc2965ed34e6288cdad05f2ef2ed2'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'c645e9387c654aa8ae253045f648bfac'
            },
            apimBasePath: '/abs/pub',
            cartV2API: '/abs/pub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "prod.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/pub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "e914eec9448c4d5eb672debf5011cf8f",
            "apim.api.catalog.path": "/abs/pub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "prod.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/pub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "e914eec9448c4d5eb672debf5011cf8f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "7bad9afbb87043b28519c4443106db06",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "306b9569-2a31-4fb9-93aa-08332ba3c55d",
            'X-IBM-Client-Secret': "N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5",
            'clipPath': '/abs/pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/pub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/pub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/pub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/pub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/pub/xapi/offers',
            'upcsByOfferIds': '/abs/pub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/pub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABS/",
            arSubscriptionKey: "fee1766a73bf47e49fa1e6a02b53308c",
            snsEndpointAllSubscriptionsKey: "379d5b830a494af18fb37cb379afb675",
            arAuthorizeBasePath: "/abs/pub",
            arScriptBasePath: "/abs/pub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "1d8f9e6f8b0d4ce29468d6d82f5847b8"
        },
        wiremockAPIDetails: {
            allowWiremockService: false,
            subscriptionKey: "",
            playbackBaseUrl: "",
            recorderBaseUrl: ""
        },
        snsConfig: {
            url: '/abs/pub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '379d5b830a494af18fb37cb379afb675',
        }
    },
    prod: {
        currentEnv: "prod",
        baseURL: "https://www.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/pub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '7bad9afbb87043b28519c4443106db06'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/pub/xapi/search/substitute',
            searchParam: 'https://www.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'e914eec9448c4d5eb672debf5011cf8f'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/pub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '5e790236c84e46338f4290aa1050cdd4'
            }
        },
        subscriptionAPIDetails: {
            subscriptionApi: '/abs/pub/erums/subscriptionservice/api/v1/subscription/user/get/{gid}',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'f775c6e1cecf4ec5849ea7fb1add9114'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/pub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/pub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'ce4dc2965ed34e6288cdad05f2ef2ed2'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: 'c645e9387c654aa8ae253045f648bfac'
            },
            apimBasePath: '/abs/pub',
            cartV2API: '/abs/pub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "prod.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/pub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "e914eec9448c4d5eb672debf5011cf8f",
            "apim.api.catalog.path": "/abs/pub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "prod.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/pub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "e914eec9448c4d5eb672debf5011cf8f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "7bad9afbb87043b28519c4443106db06",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "306b9569-2a31-4fb9-93aa-08332ba3c55d",
            'X-IBM-Client-Secret': "N4tK3pW7pP6nB4kL6vN4kW0rS5lE4qH2fY0aB2rK1eP5gK4yV5",
            'clipPath': '/abs/pub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/pub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/pub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/pub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/pub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/pub/xapi/offers',
            'upcsByOfferIds': '/abs/pub/dce/offergallery/J4UProgram1/offer/upcs',
            'offerDetailsPzn': '/abs/pub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/pub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            'coupon.image.base.url': 'https://images.albertsons-media.com/is/image/ABS/',
            arSubscriptionKey: "fee1766a73bf47e49fa1e6a02b53308c",
            snsEndpointAllSubscriptionsKey: "379d5b830a494af18fb37cb379afb675",
            arAuthorizeBasePath: "/abs/pub",
            arScriptBasePath: "/abs/pub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "9e38e3f1d32a4279a49a264e0831ea46"
        },
        wiremockAPIDetails: {
            allowWiremockService: false,
            subscriptionKey: "",
            playbackBaseUrl: "",
            recorderBaseUrl: ""
        },
        snsConfig: {
            url: '/abs/pub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '379d5b830a494af18fb37cb379afb675',
        },
    },
    local: {
        currentEnv: "qa1",
        baseURL: "https://www-qa1.{banner}.com",
        substitutionAPIDetails: {
            substitutionAPI: '/abs/qapub/xapi/pdreco/substitution',
            xtokenHeader: {
                key: 'X-access-token',
                value: ''
            },
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '8ca6295a55f54368844b5982edc1cc01'
            }
        },
        searchAPIDetails: {
            searchAPI: '/abs/qapub/xapi/search/substitute',
            searchParam: 'https://www-qa1.{banner}.com',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: '061d4366162045c6879eca9eab9b7e89'
            }
        },
        searchProductsAPIDetails: {
            searchProductsAPI: 'abs/qapub/xapi/pgmsearch/v1/search/products',
            subscriptionKey: {
                key: 'ocp-apim-subscription-key',
                value: 'ae53203f912448a7a13c70272d5c75fb'
            }
        },
        cartAPIDetails: {
            cartAPI: '/abs/qapub/erums/cartservice/api/v1/cart/',
            editCartAPI: '/abs/qapub/erums/orderservice/api/v2/orders/',
            subscriptionKey: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            subscriptionKeyV2: {
                key: 'Ocp-Apim-Subscription-Key',
                value: '3e4673736413478c8153f99172d30318'
            },
            apimBasePath: '/abs/qapub',
            cartV2API: '/abs/qapub/erums/cartservice/api/v2/cart/',
            guestCartBasePath: '/erums/guestcartservice/api/v2/guest/'
        },
        catalogConfig: {
            "catalog.service.enable": "true",
            "catalog.xapi.enable": "true",
            "swy.api.apim.catalog.service.baseurl": "qa.apim.azwestus.stratus.albertsons.com",
            "swy.api.catalog.service.endpoint": "/abs/qapub/catalog/catalogservice",
            "swy.api.catalog.service.apim.key": "b0f931272efc4766a535e6030b79574d",
            "apim.api.catalog.path": "/abs/qapub/xapi",
            "apim.api.catalog.virtual.shelf.endpoint": "/catalog-deals/virtual-shelf",
            "apim.api.catalog.departments.endpoint": "/catalog-deals/departments",
            "apim.api.catalog.deals.endpoint": "/catalog-deals/deals",
            "apim.api.catalog.product.bpn.endpoint": "/catalog/products-by-bpn",
            "apim.api.catalog.product.upc.endpoint": "/catalog/products-by-upc",
            "apim.api.catalog.increment.price.list.endpoint": "/catalog/incrementPriceList",
            "apim.api.catalog.cba.endpoint": "/catalog-deals/channel-based-availability",
            "mockinator.brand.index.service.baseurl": "dev1.apim.azwestus.stratus.albertsons.com",
            "mockinator.brand.index.service.api.key": "cc18c4fbb7f540099142b1f9adb2558f",
            "mockinator.brand.index.endpoint": "/abs/devpub/mock-playback/mockinator/playback/brandIndexSearch",
            "apim.api.brand.index.service.baseurl": "qa.apim.azwestus.stratus.albertsons.com",
            "apim.api.brand.index.service.path": "/abs/qapub/xapi",
            "apim.api.brand.index.service.endpoint": "/v1/aisles/brandindex",
            "apim.api.brand.index.service.key": "a6bbc777a82f45a9b1413af0ce35604f",
            "api.catalog.timeout.product.by.bpn": "1000",
            "api.catalog.timeout.brand.index": "3000",
            "swy.api.product.service.apim.key": "b0f931272efc4766a535e6030b79574d",
            "api.catalog.timeout.pdp.data": "1500"
        },
        j4uAPIDetails: {
            'X-SWY_VERSION': '1.0',
            'X-IBM-Client-Id': "9b1d97cf-4ddc-4e81-95e5-035c204c4ef6",
            'X-IBM-Client-Secret': "G1oW7jM5jF5nV7lR8rC6dU4wG1qS8uC5iD7rB5eJ0tD4eO0cJ6",
            "X-SWY_BANNER": "safeway",
            "x-swy-correlation-id": "01e7b8fd-f501-4519-886c-daf340fa6967",
            "X-SWY_API_KEY": "emjou",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_VERSION_Offers": "1.1",
            'clipPath': '/abs/qapub/web/j4u/api/offers/clip',
            'unclipPath': '/abs/qapub/web/j4u/api/offers/unclip',
            'galleryPath': '/abs/qapub/web/j4u/api/offers/gallery',
            'instantAllocation': '/abs/qapub/xapi/offers/instantAllocationGallery',
            'companionGalleryApi': '/abs/qapub/xapi/offers/companiongalleryoffer'
        },
        offerDetailAPIDetails: {
            'offerDetailPath': '/abs/qapub/xapi/offers',
            'offerDetailsPzn': '/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail',
            'offersByUpcPath': '/abs/qapub/dce/offergallery/J4UProgram1/erums/services/gallery/offers'
        },
        nimbusConfig: {
            "coupon.image.base.url": "https://images.albertsons-media.com/is/image/ABSStage/",
            arSubscriptionKey: "49c7b49a2bf94a5ca7e318c84ca9cbb2",
            snsEndpointAllSubscriptionsKey: "64e226bfbc1148d3b3f076a33d654595",
            arAuthorizeBasePath: "/abs/acceptancepub",
            arScriptBasePath: "/abs/acceptancepub",
            couponTypes: {
                "PD": "Personalized Deal",
                "MF": "Coupon",
                "SC": "Coupon",
                "CC": "Coupon",
                "GR": "Grocery Reward",
                "TR": "Monopoly Prize",
                "WS": "Weekly Ad"
            },
            couponActionTypes: {
                "CL": "Clip",
                "CLD": "Clipped",
                "AC": "ADD",
                "ADC": "ADDED",
                "CLC": "Clip Coupon",
                "CLCUDC": "Clip Offer",
                "SCC": "Activate",
                "CC": "Bonus Path Completed"
            }
        },
        datapowerConfig: {
            cncSubscriptionKey: "d8c6d7783b604f618dd446e7c39c7c08"
        },
        wiremockAPIDetails: {
            allowWiremockService: true,
            subscriptionKey: "8ca6295a55f54368844b5982edc1cc01",
            playbackBaseUrl: "/abs/qapub/mock-playback/mockinator/playback",
            recorderBaseUrl: "/abs/qapub/mock-recorder/mockinator"
        },
        snsConfig: {
            url: '/abs/qapub/osar/snsorderorch/api/sns',
            apimSubscriptionKeyValue: '267402756dc5413ab6ec8bc403100042',
        }
    },
    userInfoPath: '/bin/safeway/unified/userinfo?rand=659323&banner=safeway',
    offerDisclaimerPath: '/content/experience-fragments/www/Disclaimers/Offer-Disclaimer/offer-disclaimer.content.html'
};

/*
@file-overview

- These methods were brought over from AEM WCAX repos

- NOTE : These methods are not being used in the library currently

*/
class DatalayerService {
    constructor() { }
    setError(id, feature, message) {
        window['AB']['DATALAYER'].setError(id, feature, message);
    }
    getDataLayer() {
        return window['AB'] && window['AB']['DATALAYER'];
    }
    removeItemFromCart(product, searchTerm) {
        window['AB']['DATALAYER'].removeItemFromCart(product, searchTerm);
    }
    addItemToCart(product, searchTerm) {
        window['AB']['DATALAYER'].addItemToCart(product, searchTerm);
    }
    increaseItemQuantity(product, searchTerm) {
        window['AB']['DATALAYER'].increaseItemQuantity(product, searchTerm);
    }
    decreaseItemQuantity(product, searchTerm) {
        window['AB']['DATALAYER'].decreaseItemQuantity(product, searchTerm);
    }
    updateCartId(cartId) {
        window['AB']['DATALAYER'].updateCartId(cartId);
    }
    updateCart(allItems, newItem, wyswygFlag) {
        window['AB']['DATALAYER'].updateCart(allItems, newItem, wyswygFlag);
    }
    updateCartSummary(cartSummary) {
        window['AB'].CART.updateCartSummary(cartSummary);
    }
    recommendationInfo(recommendation) {
        window['AB']['DATALAYER'].recommendationInfo(recommendation);
    }
    productInfo(product) {
        window['AB']['DATALAYER'].productInfo(product);
    }
    setCarouselName(carouselName) {
        window['AB']['DATALAYER'].setCarouselName(carouselName);
    }
    isRecipesPage() {
        return window['AB']['DATALAYER'].isRecipesPage();
    }
    clipCoupon(coupon, analyticsData) {
        window['AB']['DATALAYER'].clipCoupon(coupon, analyticsData);
    }
    unClipCoupon(coupon) {
        window['AB']['DATALAYER'].unClipCoupon(coupon);
    }
    setLinkClickOfferDrawer(linkClicked, offerName) {
        window['AB']['DATALAYER'].setLinkClickOfferDrawer(linkClicked, offerName);
    }
    setLinkClickEvents(linkClicked) {
        window['AB']['DATALAYER'].setLinkClickEvents(linkClicked);
    }
    getDrawerStatus(productID) {
        return window['AB']['DATALAYER'].getDrawerStatus(productID);
    }
    setPastPurchasedImpressions(product) {
        window['AB']['DATALAYER'].setPastPurchasedImpressions('aisles');
    }
    updateCartSavings(total, clipped, response) {
        window['AB'].DATALAYER.updateCartSavings(total, clipped, response);
    }
    updateSearch(searchTerm, numOfResults) {
        window['AB']['DATALAYER'].updateSearch(searchTerm, numOfResults);
    }
    setModalClickEventsSubstitution(modalAction, substitutionObj, substitutionItems, product) {
        if (substitutionObj) {
            substitutionObj.productID = window.sessionStorage.getItem('analytics_subs_prodId') || '';
        }
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalClickEventsSubstitution(modalAction, substitutionObj, substitutionItems, product);
        }
    }
    setSnsLinkClick(snsOffer) {
        window['AB'].DATALAYER.setSnsLinkClick(snsOffer);
    }
    static { this.ɵfac = function DatalayerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatalayerService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DatalayerService, factory: DatalayerService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatalayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

/*
@file-overview

- This service contains a collection of global window methods availible on AEM pages and other SPA applications

- NOTE : many of these methods are NOT used in library, and need to still be cleaned for consuming apps

*/
// Window global declaration
function _window$1() {
    return window;
}
class CommonService {
    constructor(http, zone, _aemService, _datalayerService, _utilService, _userInfoService) {
        this.http = http;
        this._aemService = _aemService;
        this._datalayerService = _datalayerService;
        this._utilService = _utilService;
        this._userInfoService = _userInfoService;
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        this._disableInStoreChannelCheck = window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableInStoreChannelCheck')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableInStoreChannelCheck
            : true;
        this._enableMFC2 = window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('isMFC2disabled')
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.isMFC2disabled === false;
        this._disableMto = window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableMto')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableMto
            : true;
        this.rewardGridPath = '/content/www/{banner}/en/justforyou/rewards/rewards-details';
        this.objCoupons = {};
        this._arrPromoRule = [];
        this.objPageCoupons = {
            'offers': {},
            'offersByUpc': {}
        };
        this.shopCouponRefreshSource = new BehaviorSubject(false);
        this.shopCouponRefresh = this.shopCouponRefreshSource.asObservable();
        this.rewardsRefreshSource = new Subject();
        this.rewardsRefresh = this.rewardsRefreshSource.asObservable();
        this.postUserInfoSource = new Subject();
        this.userInfoRefresh = this.postUserInfoSource.asObservable();
        this._postUserInfoSource = new BehaviorSubject('');
        this._userInfoRefresh = this._postUserInfoSource.asObservable();
        this.manualBootstrapSource = new Subject();
        this.manualBootstrap = this.manualBootstrapSource.asObservable();
        this.hideStepperButtons = new Subject();
        this.$hideStepperButtons = this.hideStepperButtons.asObservable();
        this.rightDrawerSource = new Subject();
        this.$rightDrawerSource = this.rightDrawerSource.asObservable();
        this.upcs = new Subject();
        this.$upcs = this.upcs.asObservable();
        this.bxgyOffer = new Subject();
        this.$bxgyOffer = this.bxgyOffer.asObservable();
        this.arSubscriptions = new BehaviorSubject(null);
        this.$arSubscriptions = this.arSubscriptions.asObservable();
        this.showHeaderTooltip = new BehaviorSubject(false);
        this.crossSellTargetSource = new Subject();
        this.$crossSellTarget = this.crossSellTargetSource.asObservable();
        this.crossSellCloseSource = new Subject();
        this.$crossSellClose = this.crossSellCloseSource.asObservable();
        this._validateSession = new BehaviorSubject({});
        this.validateSession$ = this._validateSession.asObservable();
        this._updateBiaAddAllBtn = new Subject();
        this.updateBiaAddAllBtn$ = this._updateBiaAddAllBtn.asObservable();
        this._cartObjSource = new BehaviorSubject({});
        this.currentCartObj = this._cartObjSource.asObservable();
        this._toasterInteractiveElement = new BehaviorSubject(false);
        this._products = new BehaviorSubject(null);
        this.products$ = this._products.asObservable();
        this.isABFlagDisabledEvent = new Subject();
        this.isABFlagDisabledEvent$ = this.isABFlagDisabledEvent.asObservable();
        //Edit Order Flow
        this.slotDisplay = '#poDeliveryDate';
        this.reviewCTA = '#poCancelLink';
        this.editOrderRowUI = '#pendingOrderAlert';
        this.reserveTimeEl = '#reserveCon';
        this.reserveNavEl = '.reserve-nav';
        this.slotCookie = 'SlotInfo';
        this.orderStoreCookie = 'OrderStoreId';
        this.orderNumberCookie = 'OrderNumber';
        this.isSyndicatedHeader = 'syndicatedHeader';
        this.eRumsDeliveryType = 'eRumsDeliveryType';
        this.checkBoxTopRegistered = function () {
            if (this._aemService.authorize()) {
                this.userInfoRefresh.subscribe((data) => {
                    if (data == 'initFunc') {
                        if (this._aemService.authorize() && (!this._aemService.getBoxTopCalled())) {
                            this._aemService.setBoxTopCalled(true);
                            if (localStorage.getItem('loyaltyPartners')) {
                                const boxtopData = JSON.parse(localStorage.getItem('loyaltyPartners'));
                                if (boxtopData['loyaltyPartners']) {
                                    boxtopData['loyaltyPartners'].forEach(function (loyaltyPartner) {
                                        if ((loyaltyPartner) && (loyaltyPartner.name == 'GeneralMills') && (loyaltyPartner.planNumber) && (loyaltyPartner.planNumber.length > 1)) {
                                            this._aemService.setBoxTopAuth(true);
                                        }
                                    });
                                }
                            }
                            else {
                                this.objBoxTop.getGeneralMillsId().subscribe(boxtopData => {
                                    localStorage.setItem('loyaltyPartners', JSON.stringify(boxtopData));
                                    if (boxtopData['loyaltyPartners']) {
                                        boxtopData['loyaltyPartners'].forEach(function (loyaltyPartner) {
                                            if ((loyaltyPartner) && (loyaltyPartner.name == 'GeneralMills') && (loyaltyPartner.planNumber) && (loyaltyPartner.planNumber.length > 1)) {
                                                this._aemService.setBoxTopAuth(true);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    }
                });
            }
        };
        this.checkPendingOrder = function () {
            let pendingOrderId = this._aemService.getOrderNumberCookie();
            let pendingStoreId = this._aemService.getOrderStoredIdCookie();
            return (pendingStoreId && pendingOrderId) ? true : false;
        };
        // private function for converting a String to Base10.
        this.__encode = function (string) {
            var number = "";
            var length = string.length;
            for (var i = 0; i < length; i++)
                number += string.charCodeAt(i).toString(10);
            return Number(number);
        };
        // -----------------------------------------------------------------------------------------------------
        /*
        *   DFTA - methods below have been moved here during integration phase
        *   check cart id
        */
        this.checkCartId = function (cname) {
            if (this._utilService.isLSCompatible()) {
                if (localStorage.getItem(cname) !== undefined && localStorage.getItem(cname) !== null)
                    return true;
                else
                    return false;
            }
            else {
                if (this._utilService.getCookie(cname) !== undefined && this._utilService.getCookie(cname) !== null)
                    return true;
                else
                    return false;
            }
        };
        /*
            get cart id
        */
        this.getCartId = function (cname) {
            return this.getCartIdV2(cname);
        };
        /* set cart id */
        this.setCartId = function (cname, cid) {
            this.setCartIdV2(cname, cid);
        };
        this.getCartIdV2 = function (cname, sellerId) {
            let cartListObj = this.getCartIdObjV2(cname);
            if (cartListObj) {
                return cartListObj[sellerId ? sellerId : 'abs'];
            }
        };
        this.setCartIdV2 = function (cname, cid, sellerId) {
            let cartListObj = this.getCartIdObjV2(cname);
            cartListObj[sellerId ? sellerId : 'abs'] = cid;
            this.setCartIdObjV2(cname, cartListObj);
        };
        this.getCartIdObjV2 = function (cname) {
            let cartList;
            if (this._utilService.isLSCompatible()) {
                cartList = localStorage.getItem(cname);
            }
            else {
                cartList = this._utilService.getCookie(cname);
            }
            if (cartList) {
                try {
                    return JSON.parse(cartList);
                }
                catch (ex) {
                    console.warn('migrating old cart id', ex);
                    // for old cart ids backward compatability
                    return { abs: cartList };
                }
            }
            return {};
        };
        this.setCartIdObjV2 = function (cname, cartListObj) {
            const cartString = JSON.stringify(cartListObj);
            if (this._utilService.isLSCompatible()) {
                localStorage.setItem(cname, cartString);
            }
            else {
                this._utilService.setCookie(cname, cartString, -1);
            }
        };
        /**
        * Method validating and setting product price value if a promo is currently active or not.
        * Use basePrice prop if promo is not active, otherwise use price prop.
        */
        this.getValidProductPrice = (product) => {
            if (product === null) {
                return 0;
            }
            if (this.hasPromotion(product) === false
                || this.isProductPromoActive(product)) {
                return product.price;
            }
            return product.basePrice;
        };
        this._arrPromoRule = _window$1().SWY.CONFIGSERVICE.getConfigforPromoDesc();
        // this.checkBoxTopRegistered();
    }
    /**
     * Gets all hidden inputs to bring data into Angular application.
     *
     * @see app.module.ts
     */
    getHiddenInputs() {
        const result = '';
        const wrapper = $('.js-gridDataParse');
        $('input[type="hidden"]', wrapper).each(function (i, el) {
            const $el = $(el);
            const val = $el.val();
            const elName = $el.attr('name');
            if (!val)
                return;
            switch (elName) {
                case 'gridDataSource':
                    window['AB'][elName] = JSON.parse(val);
                    break;
                case 'availableSorts':
                    window['AB'][elName] = [];
                    val.split(',').map(function (elVal) {
                        window['AB'][elName].push(elVal.trim());
                    });
                    break;
                default:
                    window['AB'][elName] = val.toString();
                    break;
            }
        });
    }
    getPromorulesArray() {
        return this._arrPromoRule;
    }
    getBogoLabel() {
        return _window$1().SWY.CONFIGSERVICE.getBannerConventions().buy_one_get_one_free;
    }
    getPromoDescription() {
        return _window$1().SWY.CONFIGSERVICE.getBannerConventions().promoDescription;
    }
    getPromoDescriptionAPI(product) {
        if (this.isProductPromoActive(product)) {
            switch (product.promoType) {
                case 'P':
                    product['promoTitle'] = this.getPromoDescription();
                    product['offerText'] = '';
                    break;
                case 'B':
                case 'M':
                    product['promoTitle'] = this.getBogoLabel();
                    product['offerText'] = product['promoText'];
                    break;
            }
        }
    }
    getPromoDescriptionAPIMealsRecipe(product) {
        if (this.isProductPromoActive(product)) {
            switch (product.promoType) {
                case 'P':
                    product['promoTitle'] = this.getPromoDescription();
                    product['offerText'] = '';
                    break;
                case 'B':
                case 'M':
                    product['promoTitle'] = this.getBogoLabel();
                    product['offerText'] = product['promoText'];
                    break;
            }
        }
        return product;
    }
    getAppContext() {
        return _window$1().AB;
    }
    /**
    * returns pdp page path based on program type
    * @param programType
    * **/
    getProductDetailPath(programType) {
        if (programType === 'wineshop') {
            return _window$1().AB.winePdpPath;
        }
        else if (programType === 'mkp') {
            return _window$1().AB.mkpPdpPath;
        }
        else {
            return _window$1().AB.htmlProductDetailPath;
        }
    }
    getCouponDetailPathShop() {
        return _window$1().AB.htmlOfferDetailPathShop;
    }
    getCouponDetailPathWww() {
        return _window$1().AB.htmlOfferDetailPathWww;
    }
    getRewardGridPathWww() {
        return _window$1().AB.htmlRewardDetailPathWww;
    }
    promoDescription(product) {
        const field = 'promoDescription';
        const newField = 'promoDescriptionVal';
        const priceColor = 'priceColor';
        const strPromoDesc = product.promoDescription;
        let found = false;
        if (!strPromoDesc) {
            return;
        }
        console.log('PRODUCT DESCRIPTION - DATA: ' + strPromoDesc);
        for (let i = 0; i < this._arrPromoRule.length && found === false; i++) {
            const objRule = this._arrPromoRule[i];
            if (strPromoDesc.match(objRule['rule'])) {
                product[newField] = objRule['value'];
                product[priceColor] = objRule['priceColor'];
                product['offerText'] = objRule['offerText'];
                found = true;
                objRule['showStrikeThrough'] == true && this.checkStrikeThrough(product);
                console.log('PRODUCT DESCRIPTION - MODIFIED: ' + product[newField]);
            }
        }
        if (found === false) {
            product[newField] = _window$1().SWY.CONFIGSERVICE.getBannerConventions().promoDescription;
            console.log('PRODUCT DESCRIPTION - DEFAULT: ' + product[newField]);
            product[priceColor] = true;
            this.checkStrikeThrough(product);
            product['offerText'] = '';
        }
    }
    checkStrikeThrough(product) {
        if (this.isProductPromoActive(product)
            && product['promoType'] === 'P'
            && product['basePrice'] != null
            && product['price'] > 0.00
            && product['basePrice'] > 0.00
            && product['price'] < product['basePrice']) {
            product['showStrikeThrough'] = true;
        }
        else {
            product['showStrikeThrough'] = false;
        }
    }
    checkStrikeThroughSponsored(product) {
        if (this.isProductPromoActive(product)
            && product['basePrice'] != null
            && product['price'] > 0.00
            && product['basePrice'] > 0.00
            && product['price'] < product['basePrice']) {
            product['showStrikeThrough'] = true;
        }
        else {
            product['showStrikeThrough'] = false;
        }
    }
    getJ4UCoupons() {
        return JSON.parse(localStorage.getItem('abCoupons'));
    }
    getUidValue() {
        return document.cookie.match('(^|;)\\s*_br_uid_2\\s*=\\s*([^;]+)') || '';
    }
    getCoupons(product) {
        let offers = 0, offersClipped = 0;
        let offersNotAvailable = false;
        let offerName = '';
        let offersArray = [], newOffersArray = [];
        if (product['upc'] != undefined) {
            while (product['upc'].split('').shift() === '0') {
                product['upc'] = product['upc'].substring(1, product['upc'].length);
            }
            // console.warn('WINDOW', _window().AB.COUPON.getCouponByUpc);
            // let arrCoupon: any = _window().AB.COUPON.getCouponByUpc(product['upc']);  -- this was the good one with
            // coupon js
            let arrCoupon = this.getCouponByUpc(product['upc']);
            // console.log(arrCoupon);
            if (arrCoupon && arrCoupon.length > 0) {
                for (let i = 0; i < arrCoupon.length; i++) {
                    offers++;
                    offerName = arrCoupon[i];
                    offersArray.push(arrCoupon[i]);
                }
                product['offerCounter'] = offers;
                for (let offer in offersArray) {
                    if (offersArray[0].status == 'C') {
                        offersClipped++;
                        offersClipped < (offersArray.length - 1) ? offersNotAvailable = true : offersNotAvailable = false;
                    }
                }
                product['offersClipped'] = offersClipped;
                if (arrCoupon.length > 1) {
                    product['moreCouponText'] = 'View All Coupons';
                    product['clipStatus'] = arrCoupon[0].status;
                    // product['couponsAvailable'] = "sd";
                }
                else {
                    let couponType = this.getCouponType(arrCoupon[0].offerType);
                    console.log('couponType', couponType);
                    product['couponText'] = couponType + ': ' + arrCoupon[0].offerPrice;
                    product['couponCategory'] = arrCoupon[0].category;
                    product['showJ4U'] = (arrCoupon[0].offerType == 'PD') ? true : false;
                    product['clipStatus'] = arrCoupon[0].status;
                    product['offerId'] = arrCoupon[0].offerId;
                    console.log('PRODUCT COUPON OFFER ID ' + arrCoupon[0].offerId);
                }
            }
        }
    }
    clipCoupon(couponId) {
        console.log('Clip the Coupon');
        _window$1().AB.COUPON.clipCoupon(couponId);
    }
    // LOAD COUPONS
    _loadCoupons() {
        if (this._utilService.isLSCompatible) {
            if (this._hasLSCoupons()) {
                this.objCoupons = this._get();
                console.log('COUPON - FETCHED FROM LOCAL STORAGE');
            }
        }
    }
    _hasLSCoupons() {
        let objCoupons = this._get();
        let response = (objCoupons &&
            objCoupons['offers'] &&
            objCoupons['offersByUpc']) ? true : false;
        if (response) {
            if (objCoupons['updatedTime'] != undefined) {
                let updatedTime = Date.parse(JSON.parse(objCoupons['updatedTime']));
                let currentTime = Date.parse(JSON.parse(JSON.stringify(new Date())));
                let timeDiff = (currentTime - updatedTime) / 60000;
                console.log(updatedTime, response && timeDiff);
                response = (response && timeDiff < 120) ? true : false;
            }
            else {
                response = false;
            }
        }
        return response;
    }
    _hasLSRewards() {
        let objRewards = this._getRewards();
        return (objRewards &&
            objRewards['grOffers']) ? true : false;
    }
    _get() {
        let objCoupons = this.objCoupons;
        if (this._utilService.isLSCompatible() && Object.keys(objCoupons).length === 0) {
            let strCoupons = localStorage.getItem('abCoupons');
            try {
                if (strCoupons) {
                    objCoupons = JSON.parse(strCoupons);
                    this.objCoupons = objCoupons;
                }
            }
            catch (e) {
                console.error('ERROR: COUPON - GETTING FROM LOCAL STORAGE');
                console.error(e);
            }
        }
        return objCoupons;
    }
    _hasLSArSubscriptions() {
        const currentTime = Date.now();
        let objSubscriptions = this._getArSubscriptions();
        return objSubscriptions && objSubscriptions['arSavedTime'] > currentTime;
    }
    _getArSubscriptions() {
        const subsKey = 'abNgSubscriptions';
        let arSubs = localStorage.getItem(subsKey);
        let objSubscriptions = {};
        try {
            objSubscriptions = JSON.parse(arSubs);
        }
        catch (e) {
            console.error('ERROR: AR SUBSCRIPTIONS - GETTING FROM LOCAL STORAGE');
            console.error(e);
        }
        return objSubscriptions;
    }
    _getRewards() {
        let strRewards = localStorage.getItem('abRewards');
        let objRewards = {};
        try {
            objRewards = JSON.parse(strRewards);
        }
        catch (e) {
            console.error('ERROR: REWARDS - GETTING FROM LOCAL STORAGE');
            console.error(e);
        }
        return objRewards;
    }
    _hasLSDeals() {
        let objDeals = this._getDeals();
        return objDeals ? true : false;
    }
    _getDeals() {
        let strDeals = localStorage.getItem('abDeals');
        let objDeals = {};
        try {
            objDeals = JSON.parse(strDeals);
        }
        catch (e) {
            console.error('ERROR: DEAL - GETTING FROM LOCAL STORAGE');
            console.error(e);
        }
        return objDeals;
    }
    loadRemoteCoupons() {
        let couponPath = '';
        if (_window$1().AB.COMMON.authorize()) {
            couponPath = _window$1().AB.offerRegisterPath;
        }
        else {
            couponPath = _window$1().AB.offerGuestPath;
        }
        couponPath += '?offerPgm=PD-CC';
        couponPath += '&storeId=' + _window$1().AB.userInfo.branchId;
        couponPath += '&transformOfferbyUpc=y';
        this.getRemoteCoupons(couponPath).pipe(take(1))
            .subscribe((objResponse) => {
            console.log('REMOTE COUPONS - ', objResponse);
            let objCoupons = objResponse;
            objCoupons['branchId'] = _window$1().AB.userInfo.branchId;
            this._set(objCoupons);
            console.log('COUPON - FETCHED REMOTE STORAGE AND ADDED LOCAL STORAGE');
            if (window['AB']?.DATALAYER) {
                window['AB'].DATALAYER.setP13nImpressions(objResponse, 'deals');
            }
            this.initCouponRelatedFunc();
        });
    }
    getRemoteCoupons(couponPath) {
        let httpOptions = { headers: new HttpHeaders(_window$1().AB.j4uHttpOptions) };
        return this.http.get(couponPath, httpOptions);
    }
    isStoreChange() {
        let objCoupon = this._get();
        return (objCoupon['branchId'] == undefined || objCoupon['branchId'] != _window$1().AB.userInfo.branchId);
    }
    _set(coupons, setDate = true) {
        if (setDate) {
            coupons['updatedTime'] = JSON.stringify(new Date());
        }
        if (this._utilService.isLSCompatible()) {
            localStorage.setItem('abCoupons', JSON.stringify(coupons));
        }
        this.objCoupons = coupons;
    }
    initCouponRelatedFunc() {
        this.displayCouponInFullCart();
        this.shopCouponRefreshSource.next(true);
    }
    isEmpty(obj) {
        // null and undefined are "empty"
        if (obj == null)
            return true;
        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0)
            return false;
        if (obj.length === 0)
            return true;
        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object")
            return true;
        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key))
                return false;
        }
        return true;
    }
    ///////////Get COUPON by UPC
    getCouponByUpc(upc) {
        var arrCoupons = [];
        if (this._hasLSCoupons()) {
            let objCoupons = this._get();
            var arrCouponId = objCoupons.offersByUpc[upc];
            if (arrCouponId != undefined) {
                for (var index in arrCouponId) {
                    var strCouponId = arrCouponId[index];
                    var objCoupon = undefined;
                    if (objCoupons && objCoupons.offers) {
                        objCoupon = objCoupons.offers[strCouponId];
                    }
                    if (objCoupon != undefined && !this.isCouponExpired(objCoupon)) {
                        objCoupon['offerPgmLabel'] = this.getCouponType(objCoupon.offerPgm);
                        objCoupon['offerId'] = objCoupon.offerId;
                        objCoupon['status'] = (objCoupon['deleted']) ? 'U' : objCoupon['status'];
                        arrCoupons.push(objCoupon);
                    }
                }
            }
        }
        return arrCoupons;
    }
    isCouponExpired(coupon) {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const dateString = `${month}/${day}/${year}`;
        const finalDate = new Date(dateString);
        const endDateMilliSeconds = parseInt(coupon.endDate);
        const endDate = new Date(endDateMilliSeconds);
        const endDay = endDate.getDate();
        const endMonth = endDate.getMonth() + 1;
        const endYear = endDate.getFullYear();
        const couponendDateString = `${endMonth}/${endDay}/${endYear}`;
        const couponEndDate = new Date(couponendDateString);
        return couponEndDate < finalDate;
    }
    /**
     * Check Unattended Delivery and restricted items.
     *
     * @returns {boolean} It's true if item is restricted and false if it's not restricted.
     */
    checkUnAttendedDelivery(product) {
        if (this.checkPendingOrder() && this._aemService.checkUnAttendedDelivery() && product['restrictedValue'] && product['restrictedValue'] > 0)
            return true;
        else
            return false;
    }
    /**
     * Check if provided UPC has coupons in LocalStorage and returns true or folse
     *
     * @param {string} upc Product unique upc code.
     */
    checkHasCouponsByUPC(upc) {
        if (!upc)
            return false;
        let couponsInLStorage = '';
        let couponsThisUpc = '';
        couponsInLStorage = this._get();
        if (!couponsInLStorage || !couponsInLStorage['offersByUpc'])
            return false;
        couponsThisUpc = couponsInLStorage['offersByUpc'][upc];
        if (!couponsThisUpc)
            return false;
        return (couponsThisUpc.length > 0);
    }
    /**
     *
     *
     *
     */
    getCouponByAisleName(aisleName) {
        let arrCoupons = [];
        let objCoupons = this._get();
        if (!this.isEmpty(aisleName) && objCoupons && objCoupons.offers) {
            aisleName = aisleName.toLowerCase();
            for (let index in objCoupons.offers) {
                let objOffer = objCoupons.offers[index];
                if (objOffer && objOffer.category && objOffer.category.toLowerCase() === aisleName && !this.isCouponExpired(objOffer)) {
                    objOffer['offerPgmLabel'] = this.getCouponType(objOffer.offerPgm);
                    arrCoupons.push(objOffer);
                }
            }
        }
        return arrCoupons;
    }
    getClippedCouponByUpc(upc) {
        let allCoupons = [];
        let clippedCoupons = [];
        console.log('UPC: ' + upc);
        let objCoupons = this._get();
        if (objCoupons && objCoupons.offersByUpc && objCoupons.offers) {
            let couponIds = objCoupons.offersByUpc[upc];
            if (couponIds != undefined) {
                allCoupons = couponIds.map(x => {
                    let objCoupon = objCoupons.offers[x];
                    objCoupon['offerPgmLabel'] = this.getCouponType(objCoupon['offerPgm']);
                    return objCoupon;
                }).filter(x => x != undefined);
                clippedCoupons = allCoupons.filter(x => x.status == 'C');
            }
        }
        return {
            totalCoupons: allCoupons.length,
            totalClippedCoupons: clippedCoupons.length,
            clippedCoupons: clippedCoupons,
        };
    }
    isClipped(offerId) {
        let response = false;
        console.log('Offer: ' + offerId);
        if (this._hasLSCoupons()) {
            let objCoupons = this._get();
            if (objCoupons && objCoupons.offers && objCoupons.offers[offerId]) {
                let objCoupon = objCoupons.offers[offerId];
                objCoupon.status = objCoupon.deleted == true ? 'U' : objCoupon.status; //get status using the deleted flag
                response = (objCoupon != undefined && objCoupon.status == 'C');
            }
        }
        return response;
    }
    displayCouponInFullCart() {
        let fullCartTotalCoupons = 0;
        let fullCartClippedCoupons = 0;
        let that = this;
        $('.j4u-clippedcoupons').each(function (index) {
            let strUpc = $(this).attr('data-upc');
            let objCoupon = that.getClippedCouponByUpc(strUpc);
            let arrCoupon = objCoupon.clippedCoupons;
            fullCartTotalCoupons += objCoupon.totalCoupons;
            fullCartClippedCoupons += objCoupon.totalClippedCoupons;
            if (arrCoupon.length > 0) {
                $('.id-cartimage').eq(index).prepend(`
                <svg class="svg-icon just-for-you-16px icon-u-absolute-full-cart" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <g fill="none" fill-rule="evenodd">
                    <path fill="#FDDF58" d="M12.8586538,14.7401923 C12.31,15.4461538 11.5919231,16.0034615 10.7,16.4088462 C9.81153846,16.8165385 8.87173077,17.0188462 7.88153846,17.0188462 C6.87326923,17.0188462 5.96788462,16.8240385 5.17019231,16.4346154 C4.36653846,16.0438462 3.78865385,15.4959615 3.43192308,14.7894231 C3.07346154,14.0846154 2.895,13.1078846 2.895,11.8638462 L2.895,3.49442308 L6.865,3.49442308 L6.865,9.57192308 C6.865,11.4317308 6.93826923,12.5715385 7.08326923,12.9901923 C7.23,13.4096154 7.49384615,13.7413462 7.88153846,13.9869231 C8.26634615,14.2325 8.75826923,14.3542308 9.35192308,14.3542308 C10.0303846,14.3542308 10.6361538,14.1911538 11.1736538,13.8628846 C11.7111538,13.5348077 12.0801923,13.1276923 12.2769231,12.6430769 C12.4744231,12.1563462 12.5732692,10.9661538 12.5732692,9.07423077 L12.5732692,3.49442308 L16.5438462,3.49442308 L16.5438462,16.7211538 L12.8586538,16.7211538 L12.8586538,14.7401923 Z M16.5294231,0 L3.33134615,0 C1.49846154,0 0,1.49961538 0,3.33134615 L0,16.53 C0,18.3617308 1.49846154,19.8607692 3.33134615,19.8607692 L16.5294231,19.8607692 C18.3617308,19.8607692 19.86,18.3617308 19.86,16.53 L19.86,3.33134615 C19.86,1.49961538 18.3617308,0 16.5294231,0 Z"/>
                    <path fill="#BC2533" d="M12.8586538,14.7401923 C12.31,15.4461538 11.5919231,16.0034615 10.7,16.4088462 C9.81153846,16.8165385 8.87173077,17.0188462 7.88153846,17.0188462 C6.87326923,17.0188462 5.96788462,16.8240385 5.17019231,16.4346154 C4.36653846,16.0438462 3.78865385,15.4959615 3.43192308,14.7894231 C3.07346154,14.0846154 2.895,13.1078846 2.895,11.8638462 L2.895,3.49442308 L6.865,3.49442308 L6.865,9.57192308 C6.865,11.4317308 6.93826923,12.5715385 7.08326923,12.9901923 C7.23,13.4096154 7.49384615,13.7413462 7.88153846,13.9869231 C8.26634615,14.2325 8.75826923,14.3542308 9.35192308,14.3542308 C10.0303846,14.3542308 10.6361538,14.1911538 11.1736538,13.8628846 C11.7111538,13.5348077 12.0801923,13.1276923 12.2769231,12.6430769 C12.4744231,12.1563462 12.5732692,10.9661538 12.5732692,9.07423077 L12.5732692,3.49442308 L16.5438462,3.49442308 L16.5438462,16.7211538 L12.8586538,16.7211538 L12.8586538,14.7401923 Z"/>
                    </g>
                </svg>`);
            }
            for (let cIndex in arrCoupon) {
                let hCoupon = $('<div></div>');
                hCoupon.addClass('clipped-coupon-wrapper');
                hCoupon.append('<span class="svg-icon coupon-tick-mark"></span>');
                hCoupon.append('<span class="clipped-coupon-text">' + arrCoupon[cIndex].offerPgmLabel + ': ' + arrCoupon[cIndex].offerPrice + '</span>');
                $(this).append(hCoupon);
            }
        });
        if (this._datalayerService.getDataLayer()) {
            this._datalayerService.updateCartSavings(fullCartTotalCoupons, fullCartClippedCoupons);
        }
    }
    getUpcByOffers(offerId) {
        let arrUpc = [];
        let objCoupons = this._get();
        if (objCoupons && objCoupons['offers'] && objCoupons['offers'] != null && objCoupons['offers'][offerId]) {
            for (let index in objCoupons['offersByUpc']) {
                let arrOfferId = objCoupons['offersByUpc'][index];
                if (arrOfferId.indexOf(offerId) != -1) {
                    arrUpc.push(index);
                }
            }
        }
        console.log('getUpcByOffers: Returning array of UPC ', arrUpc);
        return arrUpc;
    }
    getOffer(offerId) {
        let objOffers = '';
        let objCoupons = this._get();
        if (objCoupons && objCoupons.offers && objCoupons.offers[offerId]) {
            objOffers = objCoupons.offers[offerId];
        }
        return objOffers;
    }
    /*
       * Method checking and returning product offers by product upc code.
       *
       * @param product
       * @param allOffers
       */
    getOffersByUpc(product, allOffers) {
        const upc = product.upc;
        const offers = allOffers ? (allOffers['offers'] ? allOffers['offers'][upc] : allOffers[upc] ? allOffers[upc] : null) : null;
        return offers ? offers : {};
    }
    /**
     * Get coupon type mapping.
     *
     * @param {string} type Coupon type: MF, PD, CC, SC.
     */
    getCouponType(type) {
        let couponTypes = this._aemService.getCouponTypes();
        return (couponTypes[type] == undefined) ? '' : couponTypes[type];
    }
    prop65WarningMessage(product) {
        let prop65Details = (this._aemService.getProp65Details());
        product['prop65WarningTextDetails'] = '';
        if (prop65Details.prop65Flag) {
            product['prop65Title'] = '';
            product['prop65PdpTitle'] = '';
            if (product['prop65WarningText'] != null && product['prop65WarningText'] != '') {
                product['prop65Title'] = prop65Details.prop65Title;
                product['prop65PdpTitle'] = prop65Details.prop65PDPTitle;
                product['prop65WarningTextDetails'] = product['prop65WarningText'];
            }
        }
    }
    initServiceCall() {
        console.log('ANGULAR - REQUESTED SERVICE CALL');
        this.postUserInfoSource.next('initAngular');
    }
    initJ4UModal() {
        console.log('ANGULAR - OPENING THE J4U MODAL');
        const objData = {
            manualComponentId: 'j4uModal',
            contextId: 'offerDetailModal'
        };
        this.manualBootstrapSource.next(objData);
    }
    clipEcomGalleryCoupon(couponId) {
        let objOffer = this.getOffer(couponId);
        if (objOffer != '') {
            let allCoupons = JSON.parse(localStorage.getItem('abCoupons'));
            if (allCoupons && allCoupons.offers && allCoupons.offers[couponId]) {
                allCoupons.offers[couponId].status = 'C';
                allCoupons.offers[couponId].deleted = false; //set deleted flag in localStorage
                this._set(allCoupons, false);
                this.shopCouponRefreshSource.next(true);
            }
        }
    }
    unclipEcomGalleryCoupon(couponId) {
        let objOffer = this.getOffer(couponId);
        if (this._utilService.isLSCompatible() && localStorage && objOffer != '') {
            let allCoupons = JSON.parse(localStorage.getItem('abCoupons'));
            if (allCoupons && allCoupons.offers && allCoupons.offers[couponId]) {
                allCoupons.offers[couponId].status = 'U';
                allCoupons.offers[couponId].deleted = true; //set deleted flag in localStorage
                this._set(allCoupons, false);
                this.shopCouponRefreshSource.next(true);
            }
        }
    }
    isProductPromoActive(product) {
        let check = false;
        if (product.hasOwnProperty('promoEndDate')
            && product.promoEndDate) {
            const today = new Date();
            const day = today.getDate();
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            const dateString = `${month}/${day}/${year}`;
            const finalDate = new Date(dateString);
            const promoEndDateTime = new Date(product.promoEndDate);
            if (finalDate < promoEndDateTime) {
                check = true;
            }
        }
        return check;
    }
    hasPromotion(product) {
        let check = false;
        if (product.hasOwnProperty('promoType')
            && product.promoType
            && (product.promoType === 'P'
                || product.promoType === 'B'
                || product.promoType === 'M')) {
            check = true;
        }
        return check;
    }
    showCrossSell(bpn, aisleId, productsInCart, crossSellType) {
        const storeId = this._aemService.getBranchId();
        if (aisleId && storeId && bpn) {
            const searchConfig = this._aemService.getApimSearchPath();
            const endpoint = this._aemService.getApimSearchSponsoredCarouselEndpoint();
            let elevateSessionId = encodeURIComponent(this._aemService.getCookie('_elevaate_session_id'));
            const width = $(window).width();
            let userId = (this._aemService.clubCard()) ? encodeURIComponent(this._aemService.clubCard()) : '';
            let banner = this._aemService.getBanner();
            let excludedBpns = bpn;
            let url = '';
            if (!crossSellType)
                crossSellType = "cross-sell";
            if (productsInCart.length > 0) {
                productsInCart.forEach(function (product) {
                    excludedBpns = excludedBpns + ',' + product;
                });
            }
            url = `${window.location.origin}${searchConfig}${endpoint}`
                + `?storeid=${storeId}`
                + `&featuredsessionid=${elevateSessionId}`
                + `&screenwidth=${width}`
                + `&userid=${userId}`
                + `&banner=${banner}`
                + `&max-result=8`
                + `&pagename=${crossSellType}`
                + `&exclude-bpn=${excludedBpns}`
                + `&bpn=${bpn}`
                + `&category-id=${aisleId}`;
            url = this.generateCBAUrl(url);
            const httpOptions = { headers: new HttpHeaders({
                    'Ocp-Apim-Subscription-Key': this._aemService.getApimSubscriptionKey()
                }) };
            this.http.get(url, httpOptions).subscribe((objResponse) => {
                if (objResponse['response']?.docs) {
                    const formattedResponse = { 'products': objResponse['response']?.docs, 'bpn': bpn };
                    this.sendSponsoredProductsOnloadEvent(objResponse['response']?.docs, 'crossSellComponent');
                    this.crossSellTargetSource.next(formattedResponse);
                }
            });
        }
    }
    closeCrossSell(bpn) {
        let crossSellCheck = document.getElementsByClassName('cross-sell-product-' + bpn)[0];
        if (crossSellCheck) {
            this.crossSellCloseSource.next(true);
        }
    }
    isGuestUser() {
        const featureFlagConfig = this._aemService.featureToggleConfig();
        const isGuestCartFlagConfigDisabled = featureFlagConfig && featureFlagConfig.hasOwnProperty('disableGuestCart')
            ? featureFlagConfig.disableGuestCart
            : true;
        return String(_window$1().AB.userInfo.userType).toLowerCase() == 'g' && !isGuestCartFlagConfigDisabled;
    }
    /**
     * Method validating the CBA flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
    isItemAvailable(product) {
        // README: Flag used to validate Angular template content based on inStore feature validity
        product['disableInStoreUICheck'] = true;
        /*
        * README:
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._aemService.getUserChannel();
        const channelKeyName = (() => {
            switch (true) {
                case userChannelChoice === 'pickup':
                    return 'pickUp';
                case userChannelChoice === 'delivery':
                    return 'delivery';
                case (!this._disableInStoreChannelCheck
                    && userChannelChoice === 'instore'):
                    return 'inStore';
                default:
                    return '';
            }
        })();
        // FIXME: Remove this when the disableInStoreChannelCheck feature flag will be removed
        if (this._disableInStoreChannelCheck && userChannelChoice === 'instore') {
            userChannelChoice = '';
        }
        // README: Check the appropriate channeel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;
        switch (true) {
            // README: Scenario 1 - If user sets instore channel
            case (!this._disableInStoreChannelCheck
                && userChannelChoice === 'instore'):
                if (isProductEligible) {
                    // README: The product must not be eligible for delivery or pickup either
                    if (!channelEligibilityObject['delivery']
                        && !channelEligibilityObject['pickUp']) {
                        product['disableInStoreUICheck'] = false;
                    }
                    // README: Scenario 1A - if product is eligible
                    return this.checkItemAvailability(product, userChannelChoice);
                }
                else {
                    // README: Scenario 1B - if product is not eligible
                    product['itemNotAvailableTxt'] = 'This item is not offered for in-store.';
                }
                return false;
            // README: Scenario 2 - If user sets pickup or delivery channel
            case ['pickup', 'delivery'].includes(userChannelChoice):
                if (isProductEligible) {
                    // README: Scenario 2A/B - if product is eligible
                    return this.checkItemAvailability(product, userChannelChoice);
                }
                else {
                    // README: Scenario 2C/D - if product is not eligible
                    product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                }
                return false;
            // README: Scenario 3 - If channel is not set by user
            case !userChannelChoice:
                return this.checkItemAvailability(product, userChannelChoice);
            // README: Scenario 4 (default) - By default the product is treated as not available
            default:
                return false;
        }
    }
    /**
     * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
     * It returns true/false based on product stock availability.
     *
     * @param {any} product - Object of the product on which the availability check is being done
     * @param {string} userChannelChoice - Label for the user channel
     * @return {boolean}
     */
    checkItemAvailability(product, userChannelChoice) {
        if (product) {
            switch (true) {
                // README: Scenario 1 - When user sets instore channel and product is valid
                case (!this._disableInStoreChannelCheck
                    && userChannelChoice === 'instore'
                    && product.price > 0):
                // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
                case (['pickup', 'delivery'].includes(userChannelChoice)
                    && product.price > 0
                    && product.inventoryAvailable === '1'):
                // README: Scenario 3 - When channel is not set and product is valid
                case (!userChannelChoice
                    && product.price > 0):
                    product['itemAvailable'] = true;
                    return true;
                // README: Scenario 5 (default) - When product is not valid / if product price <= 0
                default:
                    product['itemAvailable'] = false;
                    product['itemNotAvailableTxt'] = 'This item is out of stock';
                    product['disableInStoreUICheck'] = true;
                    return false;
            }
        }
        return false;
    }
    /**
     * This Method appends the channel as a param and forms a new url (Needed for Channel Eligibility)
     *
     * @param {string} strUrl This is the Url.
     */
    generateCBAUrl(strUrl) {
        if (strUrl !== '') {
            let url = '';
            let channel = this._aemService.getUserChannel();
            if (this._disableInStoreChannelCheck && channel === 'instore') {
                channel = '';
            }
            switch (true) {
                case channel === 'delivery':
                case channel === 'pickup':
                case !this._disableInStoreChannelCheck && channel === 'instore':
                    const idx = strUrl.indexOf('?');
                    if (idx < 0) {
                        url = `${strUrl}?channel=${channel}`;
                    }
                    else {
                        url = `${strUrl}&channel=${channel}`;
                    }
                    break;
                default:
                    url = strUrl;
                    break;
            }
            return url;
        }
    }
    /**
     * This is a helper function for checking if an object not empty and has valid data.
     *
     * @param {object} objectToCheck Object to check.
     */
    isObjectValid(objectToCheck) {
        return objectToCheck && objectToCheck.constructor === Object && !!Object.keys(objectToCheck).length;
    }
    // AR - Project : Will return true if
    // 1. Query Param has offerType='SAS'
    // 2. AR feature flag is ON
    // 4. User is logged-in
    canTriggerProductsCall() {
        const featureFlagConfig = window['SWY'].CONFIGSERVICE.featureToggleConfig;
        const isArEnabled = featureFlagConfig && featureFlagConfig.arEnable;
        return isArEnabled && window['AB']['COMMON'].authorize();
    }
    /**
     * Method validating the CBA flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
    isItemAvailable_v2(product, programType) {
        // README: Flag used to validate Angular template content based on inStore feature validity
        product['disableInStoreUICheck'] = true;
        /*
        * README:
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._userInfoService.getUserChannel();
        userChannelChoice = (programType === 'wineshop' || programType === 'wine-carousel') ? 'shipping' : userChannelChoice;
        const channelKeyName = (() => {
            switch (true) {
                case userChannelChoice === 'shipping':
                    return 'shipping';
                case userChannelChoice === 'pickup':
                    return 'pickUp';
                case userChannelChoice === 'delivery':
                    return 'delivery';
                case userChannelChoice === 'instore':
                    return 'inStore';
                default:
                    return '';
            }
        })();
        // README: Check the appropriate channeel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;
        if (typeof product.status != "undefined" && product.status == "inactive") {
            product['itemAvailable'] = false;
            product['itemNotAvailableTxt'] = 'This item is out of stock';
            product['disableInStoreUICheck'] = true;
        }
        else {
            switch (true) {
                // README: Scenario 1 - If user sets instore channel
                case userChannelChoice === 'instore':
                    if (isProductEligible) {
                        // README: The product must not be eligible for delivery or pickup either
                        if (!channelEligibilityObject['delivery']
                            && !channelEligibilityObject['pickUp']) {
                            product['disableInStoreUICheck'] = false;
                        }
                        // README: Scenario 1A - if product is eligible
                        return this.checkItemAvailability_v2(product, userChannelChoice);
                    }
                    else {
                        // README: Scenario 1B - if product is not eligible
                        product['itemNotAvailableTxt'] = 'This item is not offered for in-store.';
                    }
                    return false;
                // README: Scenario 2 - If user sets pickup or delivery channel
                case ['pickup', 'delivery', 'shipping'].includes(userChannelChoice):
                    if (isProductEligible) {
                        // README: Scenario 2A/B - if product is eligible
                        return this.checkItemAvailability_v2(product, userChannelChoice);
                    }
                    else {
                        // README: Scenario 2C/D - if product is not eligible
                        product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                    }
                    return false;
                // README: Scenario 3 - If channel is not set by user
                case !userChannelChoice:
                    return this.checkItemAvailability_v2(product, userChannelChoice);
                // README: Scenario 4 (default) - By default the product is treated as not available
                default:
                    return false;
            }
        }
    }
    /**
     *  ** Handles giving the correct out of stock messaging for BIA OOS redesign
     *
     * Method validating the Channel Based Availibility flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
    isItemAvailable_v3(product, programType, isPcRedesign = false) {
        product['disableInStoreUICheck'] = true;
        let isOutOfStock = false;
        const outOfStockMessage = isPcRedesign ? 'Out of stock' : 'Out of Stock';
        const pickupOnlyText = isPcRedesign ? 'Pickup only' : 'Only Available for Drive-up and go.';
        const inStoreOnlyText = isPcRedesign ? 'In-store only' : 'Only Available In-Store.';
        const deliveryOnlyText = isPcRedesign ? 'Delivery only' : 'Only Available for Delivery.';
        const deliveryAndPickupText = isPcRedesign ? 'Delivery and Pickup only' : 'Only Available for Delivery or Drive-up and go.';
        const inStoreAndDeliveryText = isPcRedesign ? 'In-store and Delivery only' : 'Only Available In-Store or for Delivery.';
        const inStoreAndPickupText = isPcRedesign ? 'In-store and Pickup only' : 'Only Available In-Store or for Drive-up and go.';
        /*
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._userInfoService.getUserChannel();
        userChannelChoice = (programType === 'wineshop' || programType === 'wine-carousel') ? 'shipping' : userChannelChoice;
        const channelKeyName = (() => {
            switch (true) {
                case userChannelChoice === 'shipping':
                    return 'shipping';
                case userChannelChoice === 'pickup':
                    return 'pickUp';
                case userChannelChoice === 'delivery':
                    return 'delivery';
                case userChannelChoice === 'instore':
                    return 'inStore';
                default:
                    return '';
            }
        })();
        // Check the appropriate channel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;
        if (typeof product.status != "undefined" && product.status == "inactive") {
            product['itemAvailable'] = false;
            product['itemNotAvailableTxt'] = outOfStockMessage;
            product['disableInStoreUICheck'] = true;
        }
        else {
            switch (true) {
                // Scenario 1 - If user sets instore channel
                case userChannelChoice === 'instore':
                    if (isProductEligible) {
                        // README: The product must not be eligible for delivery or pickup either
                        if (!channelEligibilityObject['delivery']
                            && !channelEligibilityObject['pickUp']) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        }
                        return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);
                    }
                    else {
                        // if product is not eligible for instore
                        // check if item is availible for delivery or DUG
                        let deliveryAvailbile = (channelEligibilityObject?.['delivery'] && this.checkItemAvailability_v3(product, 'delivery', outOfStockMessage));
                        let dugAvailbile = (channelEligibilityObject?.['pickUp'] && this.checkItemAvailability_v3(product, 'pickup', outOfStockMessage));
                        if (deliveryAvailbile && dugAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryAndPickupText;
                        }
                        else if (!deliveryAvailbile && dugAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = pickupOnlyText;
                        }
                        else if (deliveryAvailbile && !dugAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryOnlyText;
                        }
                        else {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }
                    return false;
                // Scenario 2 - If user sets pickup channel
                case userChannelChoice === 'pickup':
                    if (isProductEligible) {
                        return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);
                    }
                    else {
                        // if product is not eligible for pickup
                        // check if item is availible for delivery or instore
                        let deliveryAvailbile = (channelEligibilityObject?.['delivery'] && this.checkItemAvailability_v3(product, 'delivery', outOfStockMessage));
                        let instoreAvailbile = (channelEligibilityObject?.['inStore'] && this.checkItemAvailability_v3(product, 'instore', outOfStockMessage));
                        if (deliveryAvailbile && instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreAndDeliveryText;
                        }
                        else if (!deliveryAvailbile && instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        }
                        else if (deliveryAvailbile && !instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryOnlyText;
                        }
                        else {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }
                    return false;
                // Scenario 3 - If user sets delivery channel
                case userChannelChoice === 'delivery':
                    if (isProductEligible) {
                        return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);
                    }
                    else {
                        // if product is not eligible for delivery
                        // check if item is availible for pickup or instore
                        let dugAvailbile = (channelEligibilityObject?.['pickUp'] && this.checkItemAvailability_v3(product, 'pickup', outOfStockMessage));
                        let instoreAvailbile = (channelEligibilityObject?.['inStore'] && this.checkItemAvailability_v3(product, 'instore', outOfStockMessage));
                        if (dugAvailbile && instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreAndPickupText;
                        }
                        else if (dugAvailbile && !instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = pickupOnlyText;
                        }
                        else if (!dugAvailbile && instoreAvailbile) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        }
                        else {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }
                    return false;
                case userChannelChoice === 'shipping':
                    if (isProductEligible) {
                        // README: Scenario 2A/B - if product is eligible
                        return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);
                    }
                    else {
                        // README: Scenario 2C/D - if product is not eligible
                        product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                    }
                // Scenario 4 - If channel is not set by user
                case !userChannelChoice:
                    return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);
                // Scenario 5 (default) - By default the product is treated as not available
                default:
                    return false;
            }
        }
    }
    /**
 * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
 * It returns true/false based on product stock availability.
 *
 * @param {any} product - Object of the product on which the availability check is being done
 * @param {string} userChannelChoice - Label for the user channel
 * @return {boolean}
 */
    checkItemAvailability_v2(product, userChannelChoice) {
        if (product && product.channelInventory && product.channelInventory[userChannelChoice]) {
            //product.channelInventory[userChannelChoice] will be used instead of product.inventoryAvailable since isMFC2disabled is no longer available
            let inventoryAvailable = product.channelInventory[userChannelChoice];
            switch (true) {
                // README: Scenario 1 - When user sets instore channel and product is valid
                case (userChannelChoice === 'instore'
                    && product.price > 0):
                // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
                case (['pickup', 'delivery', 'shipping'].includes(userChannelChoice)
                    && product.price > 0
                    && !['', null, undefined, '0'].includes(inventoryAvailable)):
                // README: Scenario 3 - When channel is not set and product is valid
                case (!userChannelChoice
                    && product.price > 0):
                    if (product.isMtoProduct
                        && product.preparationTime) {
                        if (Number(product.preparationTime) > 0) {
                            const mtoDisplyableTime = this.prepTimeMinToHoursMins(product.preparationTime);
                            product['mtoDisplyableTime'] = mtoDisplyableTime;
                            product['mtoText'] = 'Takes ' + mtoDisplyableTime + ' to prepare';
                        }
                        else {
                            product['mtoDisplyableTime'] = null;
                            product['mtoText'] = null;
                        }
                    }
                    product['itemAvailable'] = true;
                    return true;
                // README: Scenario 4 - When item is not available
                case product.price <= 0:
                case (['', null, undefined, '0'].includes(inventoryAvailable)
                    && ['pickup', 'delivery', 'shipping'].includes(userChannelChoice)):
                    product['itemAvailable'] = false;
                    product['itemNotAvailableTxt'] = 'This item is out of stock';
                    product['disableInStoreUICheck'] = true;
                    return false;
                // README: Scenario 5 (default) - Handle here all unimplemented cases
                default:
                    return true;
            }
        }
        return false;
    }
    /**
 * Helper method which determines whether to get the inventory availability flag from the old
 * "inventoryAvailable" flag or, if enabled by the feature flag, returns the appropriate channel inventory
 *
 * @param {any} product - Object of the product on which the availability check is being done
 * @param {string} userChannelChoice - Label for the user channel
 */
    getProductInventoryAvailability(product, userChannelChoice) {
        let inventoryAvailability;
        if (this._enableMFC2 && product.channelInventory && userChannelChoice)
            inventoryAvailability = product.channelInventory[userChannelChoice];
        else
            inventoryAvailability = product.inventoryAvailable;
        return inventoryAvailability;
    }
    /**
 * This is a helper function for checking if a product is active or not.
 *
 * @param product
 */
    isActiveProduct(product) {
        if (product['status'] && product['status'] === 'inactive') {
            return false;
        }
        else {
            return true;
        }
    }
    // check is user has active signed in session
    isLoggedIn() {
        return (window['AB']['COMMON'].sessionNotExpired() && window['AB']['COMMON'].authorize());
    }
    // checks if window['analyticsSwy'] object has been processed / populated
    checkAnalyticsSwyObject() {
        return window['analyticsSwy'] ? (window['analyticsSwy'].storedData ? (window['analyticsSwy'].storedData.ids ? true : false) : false) : false;
    }
    async validateSession(callBackFn) {
        // check if user is logged in
        if (this._userInfoService.isAuthorized()) {
            // check if access token is active
            if (this._utilService.isTokenActive() && this._userInfoService.getSWY_SHOP_TOKEN()) {
                if (callBackFn) {
                    callBackFn();
                }
                // check if swy_shared_session_info cookie is present
            }
            else if (this._utilService.checkAuthorizedCookie()) {
                try {
                    // DFTA - @@TODO -- need to setup userInfo path in config
                    const objPromise = await this.http.get(this.config.userInfoPath).toPromise();
                    // updating with the new token
                    this._userInfoService.setSWY_SHOP_TOKEN(objPromise['SWY_SHOP_TOKEN']);
                    this._utilService.updateTokenRefreshProperty();
                    if (this._utilService.isTokenActive()) {
                        if (callBackFn) {
                            callBackFn();
                        }
                    }
                    else {
                        $('#sessionTimeoutModal').modal({ 'show': true });
                    }
                }
                catch (e) {
                    console.error('qty-stepper', e);
                    $('#sessionTimeoutModal').modal({ 'show': true });
                }
            }
            else {
                // session expired
                $('#sessionTimeoutModal').modal({ 'show': true });
            }
        }
    }
    /**
     * This method will generate UUID ver 4, with Timestamp and Random Number.
     * @param strHHID optional Customer HHID
     * @param strName optional Customer name.
     * @returns {string} returns the unique UUID ver 4.
     */
    generateUUID(strHHID, strName) {
        var dateTimeMillis = new Date().getTime();
        var random = Math.floor(performance.now() * dateTimeMillis);
        // Get the number from HHID.
        if (strHHID && strHHID.length > 0 && !isNaN(strHHID)) {
            random += Number(strHHID);
        }
        // Generate the Base 10 of that string.
        if (strName && strName.length > 0) {
            random += this.__encode(strName);
        }
        // Generate the UUID ver 4 using the Random Seed.
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/([xy])/g, function (character) {
            // Get the Randomized integer from 0 to 16.
            var randomized = (random + Math.random() * 16) % 16 | 0;
            random = Math.floor(random / 16);
            // replace tht character base 16 if it is x
            // else replace it with 8, 9, a or b
            return (character === 'x' ? randomized : (randomized & 0x3 | 0x8)).toString(16);
        });
    }
    // get the current enviorment to be used with the wcax-env-config.ts values
    getCurrentEnviorment() {
        let env = '';
        if (window.location.origin.indexOf('dev1') > 0 || window.location.origin.indexOf('dev2') > 0 || window.location.origin.indexOf('dev3') > 0 || window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 || window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0) {
            env = window.location.host.split('-')[1].split('.')[0];
        }
        else if (window.location.origin.indexOf('localhost') > 0 || window.location.origin.indexOf('local-origin') > 0) {
            env = 'qa1';
        }
        else if (window.location.origin.indexOf('beta') > 0) {
            env = 'betaprod';
        }
        else {
            env = 'prod';
        }
        return env;
    }
    getWineShopSearchResultsPage() {
        return _window$1().AB.wineShopSearchResultsPath;
    }
    getMarketPlaceCrossSellerSearchResultsPath() {
        return _window$1().AB.marketPlaceCrossSellerSearchResultsPath;
    }
    /**
     * returns seller landing page url
     * @param sellerId
    **/
    getSellerLandingPath(sellerId) {
        const finalSellersUrl = $('.menu-nav__wrapper').attr('data-mktp-sellers-url');
        try {
            const objMkpSellersUrl = JSON.parse(finalSellersUrl);
            return objMkpSellersUrl[sellerId] ? objMkpSellersUrl[sellerId] : '';
        }
        catch (e) {
            return '';
        }
    }
    /**
     * This function is called during the initial flow for cart.service.ts . If all three ERUMs
     * edit order cookies are present, hide the reserve time navbar, and show the edit order messaging in
     * the header.
     * Then calls the ERUMs order summary service, passing in the orderNumber from the ERUMs cookie
     */
    checkPendingOrderAlert() {
        let reserveNav = this._utilService.readElement(this.reserveNavEl);
        const orderNumber = this._aemService.getOrderNumberCookie();
        if (orderNumber !== '' && this._aemService.authorize()) {
            if (reserveNav && reserveNav.length > 0) {
                reserveNav = this._utilService.getElement(this.reserveNavEl);
                reserveNav.hide();
            }
            if (this.checkForEditOrderMode()) {
                const syndicatedHeader = this._utilService.getMetaElementContent(this.isSyndicatedHeader);
                if (syndicatedHeader !== 'true') {
                    const alertSlotInfo = this._utilService.getElement(this.slotDisplay);
                    const alertCancelLink = this._utilService.getElement(this.reviewCTA);
                    const alertHeaderRowUI = this._utilService.getElement(this.editOrderRowUI);
                    alertCancelLink && alertCancelLink.attr('href', _window$1().SWY.CONFIGSERVICE.erumsConfig["spa.editorder.endpoint"] + "/cart/"
                        + this.orderStoreId + '/' + orderNumber);
                    alertSlotInfo && alertSlotInfo.html(this.slotInfo);
                    alertCancelLink && alertCancelLink.prop("onclick", null).off("click");
                    // show edit order header row
                    alertHeaderRowUI && alertHeaderRowUI.removeClass("mask");
                }
                this.eRumsDeliveryCheckCall(orderNumber);
            }
            else {
                this.eRumsDeliveryCheckCall(orderNumber);
            }
        }
        else {
            // To clear the Erums delivery type if OrderNumber Cookie is not present
            if (localStorage.getItem(this.eRumsDeliveryType)) {
                localStorage.removeItem(this.eRumsDeliveryType);
            }
            // show reserve time link on the header
            const reserveTimeEl = $(this.reserveTimeEl);
            if (reserveTimeEl) {
                reserveTimeEl.show();
            }
            else {
                console.error('reserve-nav class not found');
            }
        }
    }
    // ----------------------------------------------------------------------------
    /**
     * This function checks for two cookies that are set by ERUMs when a user chooses the
     * "shop" link on the edit order page.
     *
     * The two cookies checked for are : 'OrderStoreId' & 'OrderNumber'
     *
     *
     * @returns boolean
     */
    // -----------------------------------------------------------------------------
    checkForEditOrderMode() {
        let result = false;
        const slotInfo = this._aemService.getSlotIdCookie();
        const orderStoreId = this._aemService.getOrderStoredIdCookie();
        // check for edit order cookies set by ERUMS page, OrderStoreId & SlotInfo
        if (slotInfo !== 'undefined' && orderStoreId !== 'undefined' && slotInfo !== '' && orderStoreId !== '') {
            this.slotInfo = slotInfo;
            this.orderStoreId = orderStoreId;
            result = true;
        }
        return result;
    }
    // ----------------------------------------------------------------------------
    /**
     * Need function to replace AB.ALERT.checkPendingOrderAlert()
     *
     */
    // -----------------------------------------------------------------------------
    eRumsDeliveryCheckCall(pendingOrderId) {
        const $this = this;
        let orderDetails = '';
        // check for order details in local storage
        if (localStorage.getItem(this.eRumsDeliveryType)) {
            orderDetails = JSON.parse(localStorage.getItem(this.eRumsDeliveryType));
        }
        if (orderDetails != "" && orderDetails.orderId == pendingOrderId && orderDetails.deliveryType == 'Unattended') {
            this.unattendedDeliveryWrapper(orderDetails.deliveryType);
        }
        else {
            // check if erums order api v1 is being used
            const baseDomainUrl = this.config[this.getCurrentEnviorment()]?.baseURL?.replace("{banner}", this._userInfoService.getBanner());
            if (this._aemService.getEditOrderOldVersion() === true) {
                // if no order details in local storage, call ERUMs order summary service and set local storage
                const url = baseDomainUrl + _window$1().AB.erumsOrderDelivery;
                const eRumsHeaders = _window$1().AB.ecommHttpOptionsErums;
                $.ajax({
                    headers: eRumsHeaders,
                    url: url + pendingOrderId,
                    dataType: "json",
                    success: function (data) {
                        localStorage.setItem($this.eRumsDeliveryType, JSON.stringify({
                            'orderId': data.order.orderId,
                            'deliveryType': data.order.deliveryType
                        }));
                        $this.setABCartLS(data);
                        $this.unattendedDeliveryWrapper(data.order.deliveryType);
                    },
                    error: function (jqXHR, text, error) {
                        //console.log(error);
                    }
                });
            } // check if erums order api v1 is NOT being used
            else if (this._aemService.getEditOrderOldVersion() === false) {
                // get edit order store id
                this.orderStoreId = this._aemService.getOrderStoredIdCookie();
                // if no order details in local storage, call ERUMs order summary service and set local storage
                const url = baseDomainUrl + _window$1().AB.erumsOrderDelivery;
                const eRumsHeaders = _window$1().AB.ecommHttpOptionsErums;
                $.ajax({
                    headers: eRumsHeaders,
                    url: url + this.orderStoreId + '/' + pendingOrderId,
                    dataType: "json",
                    success: function (data) {
                        localStorage.setItem($this.eRumsDeliveryType, JSON.stringify({
                            'orderId': data.orderId,
                            'deliveryType': data.deliveryType
                        }));
                        $this.setABCartLS(data);
                        let timeSlot;
                        let slotId;
                        if (data && data.deliveryInfo && data.deliveryInfo.slotInfo) {
                            const slotInfo = data.deliveryInfo.slotInfo;
                            if (slotInfo.displayStartTS) {
                                timeSlot = slotInfo.displayStartTS;
                                timeSlot = Date.parse(timeSlot);
                            }
                            if (slotInfo.slotId) {
                                slotId = slotInfo.slotId;
                            }
                        }
                        let serviceType;
                        if (data && data.serviceType) {
                            serviceType = data.serviceType.toLowerCase();
                            serviceType = (serviceType === 'dug') ? 'pickup' : 'delivery';
                        }
                        localStorage.setItem('abSlotEditOrder', JSON.stringify({ 'timeSlot': timeSlot, 'slotId': slotId, 'serviceType': serviceType }));
                        // update local session's zipcode with the order's store zipcode
                        $this.editOrderZipCodeUpdate(data.customerInfo.zipCode);
                        // update local session's preference based on pending order delivery type
                        $this.editOrderPreferenceUpdate(data.deliveryType);
                        $this.unattendedDeliveryWrapper(data.deliveryType);
                    },
                    error: function (jqXHR, text, error) {
                        //console.log(error);
                    }
                });
            }
        }
    }
    //----------------------------------------------------------------------------
    /**
     * This function updates the local session's zipcode to the one of the order that is currently
     * being edited. The updateUserSession() is used to update the SWY session cookies, but does not update UCA
     *
     * We get the pending order store's zipcode via the erums orderservice API response
     *
     * @returns void
     */
    //-----------------------------------------------------------------------------
    editOrderZipCodeUpdate(orderZipCode) {
        let sessionObj = { 'info': { 'COMMON': {}, 'J4U': {}, 'SHOP': {} } };
        // set zipcode to J4U / SHOP and COMMON
        sessionObj.info.COMMON.zipcode = orderZipCode;
        sessionObj.info.J4U.zipcode = orderZipCode;
        sessionObj.info.SHOP.zipcode = orderZipCode;
        // update session for AEM pages cookies - no reload - no UCA update
        _window$1().AB.COMMON.updateUserSession(sessionObj, false);
        //Update user session in angular library
        this._userInfoService.setUserSession({ ...this._userInfoService.getUserSession(), shopZipcode: orderZipCode, j4uZipcode: orderZipCode });
    }
    editOrderPreferenceUpdate(deliveryType) {
        let sessionObj = { 'info': { 'COMMON': {}, 'J4U': {}, 'SHOP': {} } };
        let preference = '';
        // check if delivery type has value -- meaning it's either Attended or Unattended
        if (deliveryType) {
            preference = 'delivery';
        }
        else { // no delivery type means it's dug order
            preference = 'dug';
        }
        // update AB user info preference mode
        _window$1().AB.userInfo.preferenceMode = preference;
        // update the cookie with the right preference
        sessionObj.info.COMMON.preference = preference;
        // update session cookies - no reload - no UCA update
        _window$1().AB.COMMON.updateUserSession(sessionObj, false);
        //Update user session in angular library
        this._userInfoService.setUserSession({ ...this._userInfoService.getUserSession(), preference: preference });
    }
    unattendedDeliveryWrapper(DeliveryType) {
        this.checkUnAttendedEditOrderDelivery(DeliveryType);
    }
    checkUnAttendedEditOrderDelivery(deliveryType) {
        if (deliveryType == 'Unattended') {
            _window$1().AB.unattendedDeliveryIsEnabled = true;
            this.updateProductRelatedComponents();
        }
    }
    ;
    updateProductRelatedComponents() {
        if (window['productGenericGridCompRef'] != undefined) {
            window['productGenericGridCompRef'].zone.run(function () {
                window['productGenericGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productSearchGridCompRef'] != undefined) {
            window['productSearchGridCompRef'].zone.run(function () {
                window['productSearchGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productHybridGridCompRef'] != undefined) {
            window['productHybridGridCompRef'].zone.run(function () {
                window['productHybridGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productDynamicGridCompRef'] != undefined) {
            window['productDynamicGridCompRef'].zone.run(function () {
                window['productDynamicGridCompRef'].component.checkRestrictedItems();
            });
        }
        $('product-carousel, product-detail').each(function () {
            var id = $(this).attr('id');
            if (window[id + '_CompRef'] != undefined) {
                window[id + '_CompRef'].zone.run(function () {
                    window[id + '_CompRef'].component.checkRestrictedItems();
                });
            }
        });
    }
    ;
    setABCartLS(abCartObj) {
        localStorage.setItem('abCart', JSON.stringify({
            branchId: abCartObj.storeId ? abCartObj.storeId : '',
            cartItems: abCartObj.orderItems ? abCartObj.orderItems : [],
            cartPrice: abCartObj.orderSummary?.estimatedSubTotal || abCartObj.wysiwygOrderSummary?.estimatedSubTotal || '',
            cartQty: abCartObj.orderSummary?.totalItemQuantity || abCartObj.wysiwygOrderSummary?.totalItemQuantity || 0,
            erumsStore: true,
            isWYSIWYGEnabled: abCartObj.isWYSIWYGEnabled,
            orderNumber: abCartObj.orderId ? abCartObj.orderId : ''
        }));
        this.loadPendingOrderData();
    }
    loadPendingOrderData() {
        if (window['cartServiceRefAL'] != undefined) {
            window['cartServiceRefAL'].zone.run(function () {
                window['cartServiceRefAL'].service.loadPendingOrderData();
            });
        }
    }
    /**
   * ** Handles giving the correct out of stock messaging for BIA OOS redesign
   *
   * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
   * It returns true/false based on product stock availability.
   *
   * @param {any} product - Object of the product on which the availability check is being done
   * @param {string} userChannelChoice - Label for the user channel
   * @return {boolean}
   */
    checkItemAvailability_v3(product, userChannelChoice, outOfStockMessge = 'Out of Stock') {
        if (product && product.channelInventory && product.channelInventory[userChannelChoice]) {
            //product.channelInventory[userChannelChoice] will be used instead of product.inventoryAvailable since isMFC2disabled is no longer available
            let inventoryAvailable = product.channelInventory[userChannelChoice];
            switch (true) {
                // README: Scenario 1 - When user sets instore channel and product is valid
                case (userChannelChoice === 'instore'
                    && product.price > 0):
                // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
                case (['pickup', 'delivery', 'shipping'].includes(userChannelChoice)
                    && product.price > 0
                    && !['', null, undefined, '0'].includes(inventoryAvailable)):
                // README: Scenario 3 - When channel is not set and product is valid
                case (!userChannelChoice
                    && product.price > 0):
                    if (product.isMtoProduct
                        && product.preparationTime) {
                        if (Number(product.preparationTime) > 0) {
                            const mtoDisplyableTime = this.prepTimeMinToHoursMins(product.preparationTime);
                            const mtoTagText = this.prepTimeMinToHoursMins(product.preparationTime, true);
                            product['mtoDisplyableTime'] = mtoDisplyableTime;
                            product['mtoText'] = 'Takes ' + mtoDisplyableTime + ' to prepare';
                            product['mtoTagText'] = mtoTagText;
                        }
                        else {
                            product['mtoDisplyableTime'] = null;
                            product['mtoText'] = null;
                            product['mtoTagText'] = null;
                        }
                    }
                    product['itemAvailable'] = true;
                    return true;
                // README: Scenario 4 - When item is not available
                case product.price <= 0:
                case (['', null, undefined, '0'].includes(inventoryAvailable)
                    && ['pickup', 'delivery', 'shipping'].includes(userChannelChoice)):
                    product['itemAvailable'] = false;
                    product['itemNotAvailableTxt'] = outOfStockMessge;
                    product['disableInStoreUICheck'] = true;
                    return false;
                // README: Scenario 5 (default) - Handle here all unimplemented cases
                default:
                    return true;
            }
        }
        return false;
    }
    /**
 * Convert minutes in hours minutes format
 *
 * @param string prepareTimeInMinutes
 * @returns string format in hours minutes format
 */
    prepTimeMinToHoursMins(prepareTimeInMinutes, isTagText = false) {
        const timeInMinutes = Number(prepareTimeInMinutes);
        const hrs = Math.floor(timeInMinutes / 60);
        const minutes = timeInMinutes % 60;
        if (isTagText) {
            if (hrs > 0)
                return hrs + (hrs > 1 ? " hrs" : " hr") + (minutes > 0 ? " " + minutes + " mins" : "");
            return minutes + " mins";
        }
        if (hrs > 0)
            return hrs + (hrs > 1 ? " Hours" : " Hour") + (minutes > 0 ? " " + minutes + " Minutes" : "");
        return minutes + " Minutes";
    }
    /* get cart id */
    removeCartId(cname, sellerId) {
        if (sellerId) {
            let cartListObj = this.getCartIdObjV2(cname);
            if (cartListObj.hasOwnProperty(sellerId)) {
                delete cartListObj[sellerId];
            }
            this.setCartIdObjV2(cname, cartListObj);
        }
        else {
            if (this._aemService.isLSCompatible()) {
                localStorage.removeItem(cname);
            }
            else {
                document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
    }
    getB2BCartList() {
        return _window$1().SWY.CONFIGSERVICE?.bannerConventionsJson?.B2BCartList;
    }
    getCartList() {
        return _window$1().SWY.CONFIGSERVICE?.bannerConventionsJson?.cartList;
    }
    getParams(params) {
        const param = new URLSearchParams(window.location.search);
        return param.get(params) ? param.get(params) : null;
    }
    /**
     * Method for showing the substituions api driven cross sell component on BIA landing page
     *
     */
    showBiaLPCrossSell(bpn) {
        let relevancyUrl = '';
        let httpOptions;
        // @@TODO - change back to dyncamic xAPIBasePath after testing on QA1
        let xAPIBasePath = window.location.origin + this._aemService.getApimSearchPath();
        //let xAPIBasePath = 'https://www.safeway.com/abs/pub/xapi';
        let hhid = this._userInfoService.getHouseId() ? this._userInfoService.getHouseId() : '';
        let storeId = this._userInfoService.getShopStoreId()
            ? this._userInfoService.getShopStoreId() : '';
        let channel = this._userInfoService.getUserChannel();
        // encode _br_uid_2 when passed as query param - when added to payload do not encode
        let brUid = encodeURIComponent(this._aemService.getCookie('_br_uid_2'));
        let pageUrl = window.location.hostname;
        if (bpn && hhid && storeId && channel) {
            relevancyUrl = `${xAPIBasePath}/pdreco/substitution?bpn=${bpn}&storeId=${storeId}&hhid=${hhid}&channel=${channel}&bruid=${brUid}&pageurl=${pageUrl}&availabilityCheck=true&placement=bia`;
            // @@TODO - change back to dyncamic Key after testing on QA1
            httpOptions = {
                headers: new HttpHeaders({
                    'Ocp-Apim-Subscription-Key': this._aemService.getXApiKey(),
                    'accept': 'application/json'
                })
            };
            if (this._userInfoService.getSiteType() && this._userInfoService.getSiteType().toUpperCase() === 'B') {
                httpOptions.headers = httpOptions.headers.set('pgm', '1P_B2B');
            }
            this.http.get(relevancyUrl, httpOptions).subscribe((objResponse) => {
                if (objResponse && objResponse['productsinfo']) {
                    const formattedResponse = { 'products': objResponse?.['productsinfo'], 'bpn': bpn };
                    formattedResponse['placement'] = 'bia-lp';
                    this.crossSellTargetSource.next(formattedResponse);
                    if (window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].getBiaOosAdobeMetrics(objResponse['productsinfo']);
                    }
                }
                else {
                    // send empty response to show empty state UI
                    const formattedResponse = { 'products': [], 'bpn': bpn };
                    formattedResponse['placement'] = 'bia-lp';
                    this.crossSellTargetSource.next(formattedResponse);
                }
            }, error => {
                // send empty response to show empty state UI
                const formattedResponse = { 'products': [], 'bpn': bpn };
                formattedResponse['placement'] = 'bia-lp';
                this.crossSellTargetSource.next(formattedResponse);
            });
        }
    }
    recordRelevanceImpression(product, component, context) {
        if (this.isSearchPage()) {
            const amcSessionId = this._utilService.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg');
            let relevanceObj = {
                "item": product.id,
                "price": product.price,
                "quantity": "1",
                "environment": "d",
                "retailer-visitor-id": amcSessionId ? amcSessionId?.match(/MCMID\|\d+(?=\|)/)[0]?.split('|')[1] : null
            };
            if (context == "viewProductDetails") {
                relevanceObj = {
                    ...relevanceObj,
                    "page-id": "viewItem_API_desktop",
                    "event-type": "viewItem",
                    "availability": "1",
                    "category": product?.aisleId?.replaceAll('_', '>')
                };
            }
            else {
                relevanceObj = {
                    ...relevanceObj,
                    "page-id": "viewSearchResult_API_desktop",
                    "event-type": "addToCart"
                };
            }
            if (relevanceObj &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {
                window['citrusAdTracker'](relevanceObj, 'AD_RELEVANCE', {
                    component,
                    context
                });
            }
        }
    }
    isSearchPage() {
        return window.location.pathname?.toLowerCase().indexOf('shop/search-results') != -1;
    }
    sendSponsoredProductsOnloadEvent(products, component, context) {
        if (products && products.length > 0) {
            const productTrackingList = products.map(x => x.eventTracking).filter(x => x != undefined);
            if (productTrackingList && productTrackingList.length > 0 &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {
                window['citrusAdTracker'](productTrackingList, 'AD_ONLOAD', {
                    component: component,
                    context: context ? context : 'sponsoredProductsLoaded'
                });
            }
        }
    }
    sendSponsoredProductClickEvent(product, component, context) {
        const productTracking = product['adId'] || product.eventTracking;
        if (productTracking && window['citrusAdTracker'] && typeof window['citrusAdTracker'] === 'function') {
            window['citrusAdTracker'](productTracking, 'AD_CLICK', {
                component: component,
                context: context
            });
        }
    }
    // delay the function calling for 600 milliseconds
    debounce(func, delay = 600) {
        let timeoutId;
        let shouldExecute = false;
        return function (...args) {
            const context = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (shouldExecute) {
                    func.apply(context, args);
                    shouldExecute = false;
                }
            }, delay);
            shouldExecute = true;
        };
    }
    /*
      * Dispatch SNS one time event
      * @Param {string} couponType , type of event that has happened
      * @Param {any} payloadData payload data to be sent with snsOneTime event
    */
    dispatchSnsOneTimeEvent(type, payloadData) {
        window.dispatchEvent(new CustomEvent('snsOneTime', {
            detail: {
                type,
                ...payloadData
            }
        }));
    }
    // --------------------------------------------------------------------------
    /**
     *  FLAG:         hasPageV2Theme
     *  DESCRIPTION:  Used to determine whether the displayed page supports
     *                v2 theme.
     */
    // --------------------------------------------------------------------------
    hasPageV2Theme() {
        const pageV2ThemAttribute = "data-enablev2theme";
        let hasV2Theme = false;
        if (this.getPageAttribute(pageV2ThemAttribute) === 'true')
            hasV2Theme = true;
        return hasV2Theme;
    }
    // --------------------------------------------------------------------------
    /**
     *  FLAG:         getPageAttribute
     *  DESCRIPTION:  Returns the specified attribute value from the header
     *                element.
     */
    // --------------------------------------------------------------------------
    getPageAttribute(pageAttribute) {
        return this.getHeaderElement().attr(pageAttribute);
    }
    // --------------------------------------------------------------------------
    /**
     *  FLAG:         getHeaderElement
     *  DESCRIPTION:  Returns the header element which contains the page-specific
     *                attributes.
     */
    // --------------------------------------------------------------------------
    getHeaderElement() {
        const headerSelector = '.main-wrapper.www-wrapper';
        return $(headerSelector);
    }
    handleTabFocus(e, modelId, nativeElement, focusableElements) {
        const focusableContent = nativeElement.querySelector(modelId).querySelectorAll(focusableElements);
        const visibleFocusableElement = [];
        focusableContent.forEach((focusable) => {
            if ($(focusable).is(':visible')) {
                visibleFocusableElement.push(focusable);
            }
        });
        const firstFocusableElement = visibleFocusableElement[0]; // get first element to be focused inside modal
        const lastFocusableElement = visibleFocusableElement[visibleFocusableElement.length - 1]; // get last element to be focused inside modal
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        }
        else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    }
    /**
         * Checks if the preparation time of an MTO product exceeds the Prebooked time
         *
         * @param product - the product to be added to cart
         *
         * @param slot - key for local storage
     */
    preparationTimeExceedsPrebook(product, slot) {
        const slotDetails = JSON.parse(localStorage.getItem(slot));
        const prebookedTime = parseInt(slotDetails.timeSlot, 0);
        if (prebookedTime && product.preparationTime) {
            const timeUntilPrebook = prebookedTime - Date.now();
            const preparationTime = product.preparationTime * 60 * 1000;
            return preparationTime > timeUntilPrebook;
        }
        return false;
    }
    /**
    * Method to check for the AB flag and give subscribers of isABFlagDisabledEvent the value of the flag
    * @param lsFlagName localStorage flag name that is set for AB test
    * @param featureFlagName feature flag name that is set in Author
    * @param windowFlagName window flag name that is set by analytics team
    * @param timeoutValue timeout value in milliseconds to wait for the event to be triggered
    */
    listenToABXTestingFlag(lsFlagName, featureFlagName, windowFlagName, timeoutValue = 5000) {
        if (this._aemService.getFeatureFlagByNameDisable(featureFlagName)) {
            localStorage.removeItem(lsFlagName);
            this.isABFlagDisabledEvent.next({ flagName: featureFlagName, testValue: 'a' });
        }
        else {
            const lsFlagValue = localStorage.getItem(lsFlagName);
            if (lsFlagValue) {
                this.isABFlagDisabledEvent.next({ flagName: featureFlagName, testValue: lsFlagValue });
            }
            else {
                if (window?.["analyticsSwy"]?.["testFlags"]?.[windowFlagName]) {
                    const windowFlagValue = window["analyticsSwy"]["testFlags"][windowFlagName];
                    this.isABFlagDisabledEvent.next({ flagName: featureFlagName, testValue: windowFlagValue });
                }
                else {
                    let timeoutId;
                    const eventHandler = (event) => {
                        clearTimeout(timeoutId);
                        const value = event['detail'][windowFlagName];
                        this.isABFlagDisabledEvent.next({ flagName: featureFlagName, testValue: value });
                    };
                    // Add the event listener
                    //The once: true option ensures that the event listener is removed after it is triggered
                    window.addEventListener(windowFlagName, eventHandler, { once: true });
                    // Function to remove the event listener
                    const removeEventListener = () => {
                        window.removeEventListener(windowFlagName, eventHandler);
                        this.isABFlagDisabledEvent.next({ flagName: featureFlagName, testValue: 'a' });
                    };
                    // Set a timeout to remove the event listener after 5000 milliseconds if the event is not triggered
                    timeoutId = setTimeout(removeEventListener, timeoutValue);
                }
            }
        }
    }
    /**
     * Method to check if the offer is NDC and eligible to BXGY offer
     * @param offer
     */
    getIsOfferEligibleBXGY(offer) {
        return offer?.offerProtoType === 'BUYX_GETY' && !offer?.offerDetail?.isClippable && offer?.offerDetail?.promoType !== 'M' && offer?.offerDetail?.promoType !== 'B';
    }
    /**
     * This method will return if product is eligible for customizable product
     * @param product
     * @returns boolean true/false
     */
    isCustomizableProduct(product) {
        return !!(product.isMtoProduct && product.isCustomizable);
    }
    /**
     * This method will return if user store is eligible for ecomm deli
     * @param storeFlags
     * @returns boolean true/false
     */
    isProductEligibleForCustomization(storeFlags, product) {
        const departmentArray = storeFlags?.flags?.departmentsDetail;
        return this.isCustomizableProduct(product) && (departmentArray?.[0]?.acuview1POrderprep ?? false);
    }
    static { this.ɵfac = function CommonService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CommonService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(AemService), i0.ɵɵinject(DatalayerService), i0.ɵɵinject(UtilService), i0.ɵɵinject(UserInfoService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CommonService, factory: CommonService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: i0.NgZone }, { type: AemService }, { type: DatalayerService }, { type: UtilService }, { type: UserInfoService }], null); })();

/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for adding/Updating/Removing products from /cart

*/
class CartV2Service {
    constructor(_http, _commonService, _aemService, _userInfoService, _utilService, zone) {
        this._http = _http;
        this._commonService = _commonService;
        this._aemService = _aemService;
        this._userInfoService = _userInfoService;
        this._utilService = _utilService;
        this.cartbaseUrl = '';
        this.cartEditOrderUrl = '';
        this.config = EnviormentConfig;
        // this variable will be used when local storage is disabled
        this._abCart = '';
        this.currentEnv = '';
        this.setCartIdObjV2 = function (cname, cartListObj) {
            const cartString = JSON.stringify(cartListObj);
            if (this._utilService.isLSCompatible()) {
                localStorage.setItem(cname, cartString);
            }
            else {
                this._utilService.setCookie(cname, cartString, -1);
            }
        };
        this.mapErumsItems = function (items) {
            return items
                ? items.map((item) => ({
                    id: item.itemId,
                    name: item.name,
                    quantity: item.qty,
                    price: item.price,
                    basePrice: item.basePrice,
                    pricePerUnit: item.unitPrice,
                    unitType: item.unitQuantity,
                    totalPrice: item.totalPrice,
                    clubCardSaving: item.clubCardSaving ? item.clubCardSaving : 0,
                    isAvailable: item.isAvailable ? item.isAvailable : '',
                    isFound: item.isFound ? item.isFound : '',
                    savings: item.savings ? item.savings : [],
                    clipped: item.clipped ? item.clipped : [],
                    maxPurchaseQty: item.maxPurchaseQty,
                    departmentName: item.departmentName
                }))
                : [];
        };
        /**
         * Method to update store id for existing cart using Cart v2 preference API
         *
         * **/
        this.updateStoreForExistingCartV2 = function (storeId, serviceType, zipcode, isGuestAddToCart = false) {
            const apiType = 'preferences';
            const url = this.generateApiUrl(apiType, false, '1P', isGuestAddToCart);
            const reqBody = this.getRequestPayLoad('wineshop', null, isGuestAddToCart, apiType);
            return this._http.put(url, reqBody, {
                ...this.getHeaders(this._commonService.getParams('mode'), '1P', isGuestAddToCart),
                ...this.getParams(null, false, '', storeId, serviceType, zipcode, isGuestAddToCart, apiType)
            })
                .pipe(map((multicartApiResponse) => {
                return this.transformMulticartResponse(multicartApiResponse, storeId, serviceType);
            }), catchError(this.handleError));
        };
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.cartUrl = this.config[this.currentEnv].cartAPIDetails.cartV2API;
        this.guestCartUrl = this.config[this.currentEnv].cartAPIDetails.apimBasePath + this.config[this.currentEnv].cartAPIDetails.guestCartBasePath;
        this.cartEditOrderUrl = this.config[this.currentEnv]?.cartAPIDetails?.editCartAPI;
        this.itemsUrl = 'items';
        this.orderItemsUrl = 'orderItems';
    }
    /*
    * This function returns headers common for all the cart v2 api calls
    */
    getHeaders(mode, programType, isGuestAddToCart) {
        let subscriptionKey = '';
        const _this = this;
        if (this._aemService.isAllowWiremockService() && (mode === 'record' || mode === 'playback')) {
            subscriptionKey = this._aemService.getWcaxXapiApimKey();
        }
        else if (programType === '1P_SNS') {
            subscriptionKey = _this.config[this.currentEnv]?.snsConfig.apimSubscriptionKeyValue;
        }
        else {
            subscriptionKey = _this.config[this.currentEnv]['cartAPIDetails']['subscriptionKeyV2']['value'];
        }
        const defaultHeaders = {
            'ocp-apim-subscription-key': subscriptionKey,
            'Authorization': 'Bearer ' + _this._userInfoService.getSWY_SHOP_TOKEN(),
        };
        let additionalHeaders = {};
        if (programType === '1P_SNS') {
            additionalHeaders = {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'Accept': 'application/vnd.safeway.v1+json',
                'x-swy-date': new Date().toUTCString(),
                'x-swy-banner': _this._userInfoService.getBanner(),
                'x-swy-client-name': 'web-portal/mobile',
                'subscriptionsource': 'onetimeadd',
                'x-swy-correlation-id': _this._userInfoService.getUUID() ?? '',
            };
        }
        else if (isGuestAddToCart) {
            delete defaultHeaders['Authorization'];
            additionalHeaders = {
                'Sort-Order': 'date',
                'x-swy-client-id': 'web-portal',
            };
        }
        else {
            additionalHeaders = {
                'Content-Type': 'application/json',
                'Sort-Order': 'date',
                'ocp-apim-trace': `${this._aemService.getCartApimTrace()}`
            };
        }
        return { headers: new HttpHeaders({ ...defaultHeaders, ...additionalHeaders }) };
    }
    /**
     * This function generates abs cart with additional properties for viewModel
     * @param response
     * @param storeId
     * @param channel
     **/
    generateAbsCart(response, storeId, channel) {
        let cartItems, cartPrice, cartQty;
        let _this = this;
        const isWYSIWYGEnabled = response['isWYSIWYGEnabled'];
        if (response['cartItemsList']) {
            cartItems = response['cartItemsList'];
        }
        else if (response['orderItems']) {
            cartItems = response['orderItems'];
        }
        else {
            cartItems = undefined;
        }
        if (response['wysiwygOrderSummary']) {
            cartPrice = _this._commonService.isEmpty(response['wysiwygOrderSummary'].totalEstimatedPrice) === false
                ? 0.00 : response['wysiwygOrderSummary'].totalEstimatedPrice;
            cartQty = !_this._commonService.isEmpty(response['wysiwygOrderSummary'].totalItemQuantity) ? 0 : response['wysiwygOrderSummary'].totalItemQuantity;
        }
        else {
            cartPrice = _this._commonService.isEmpty(response['summary'] && response['summary'].transactionTotal) === false
                ? 0.00 : response['summary'].transactionTotal;
            cartQty = !_this._commonService.isEmpty(response['summary'] && response['summary'].totalItemQuantity) ? 0 : response['summary'].totalItemQuantity;
        }
        const { cartItemsList, ...otherCartProperties } = response;
        const objCart = {
            ...otherCartProperties,
            'cartItems': cartItems,
            'branchId': storeId ? storeId : _this._userInfoService.getShopStoreId(),
            ...(response['guestCartId'] ? { 'guestCartId': response['guestCartId'] } : {}),
            'orderNumber': _this._commonService.checkPendingOrder() ? _this._aemService.getOrderNumberCookie() : '',
            'isWYSIWYGEnabled': isWYSIWYGEnabled,
            'channel': channel ? (channel.toString() === 'dug' ? 'pickup' : channel) : _this._userInfoService.getUserChannel(),
            erumsStore: true,
            cartPrice,
            cartQty
        };
        if (response.hasOwnProperty('isMTOOrder')) {
            objCart['isMTOOrder'] = response['isMTOOrder'];
            if (objCart['isMTOOrder']) {
                objCart['mtoMaxPrepTime'] = response['mtoMaxPrepTime'];
            }
        }
        return objCart;
    }
    /**
     * This function updates cartId in cartId local storage
     * if cartId object empty them invalidatesCartId (deletes cartId local storage)
     **/
    updateCartIdFromResponse(cartIdObj) {
        cartIdObj && Object.keys(cartIdObj).length > 0 ? this.setCartIdObjV2('cartId', cartIdObj)
            : this.invalidateCartId();
    }
    /* invalidate cart id */
    invalidateCartId() {
        this._commonService.removeCartId('cartId');
    }
    /**
     * This method will return the final API url based on the mockinator flag and its respective modes.
     * @param endpoint - The endpoint to be called.
     * @param isEditOrderFlow - boolean value to check edit order flow
     * @param programType - current programType
    **/
    generateApiUrl(endpoint, isEditOrderFlow = false, programType, isGuestAddToCart, isGuestCartCall) {
        let url;
        const baseDomain = programType === 'weeklyAd' ? this.config[this.currentEnv]?.baseURL?.replace('{banner}', this._userInfoService.getBanner()) : '';
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        if (wiremockAPIDetails?.allowWiremockService) {
            const mockinatorRecorderBaseUrl = wiremockAPIDetails?.recorderBaseUrl;
            const mockinatorplaybackBaseUrl = wiremockAPIDetails?.playbackBaseUrl;
            const mockinatorRecorderUrl = `${programType === '1P_SNS' ? mockinatorRecorderBaseUrl + this.config[this.currentEnv]?.snsConfig.url + endpoint : mockinatorRecorderBaseUrl + (isGuestAddToCart ? this.guestCartUrl + 'cart/' : this.cartUrl) + endpoint}`;
            const mockinatorplaybackUrl = `${programType === '1P_SNS' ? mockinatorplaybackBaseUrl + this.config[this.currentEnv]?.snsConfig.url + endpoint : mockinatorplaybackBaseUrl + (isGuestAddToCart ? this.guestCartUrl + 'cart/' : this.cartUrl) + endpoint}`;
            switch (true) {
                case !isEditOrderFlow && this._utilService.getParams('mode') === 'record':
                    url = mockinatorRecorderUrl;
                    break;
                case isEditOrderFlow && this._utilService.getParams('mode') === 'record':
                    url = `${mockinatorRecorderBaseUrl}${this.cartEditOrderUrl}${endpoint}`;
                    break;
                case !isEditOrderFlow && this._utilService.getParams('mode') === 'playback':
                    url = mockinatorplaybackUrl;
                    break;
                case isEditOrderFlow && this._utilService.getParams('mode') === 'playback':
                    url = `${mockinatorplaybackBaseUrl}${this.cartEditOrderUrl}${endpoint}`;
                    break;
                default:
                    url = isEditOrderFlow ? `${this.cartEditOrderUrl}${endpoint}` : programType === '1P_SNS' ? `${this.config[this.currentEnv]?.snsConfig.url}${endpoint}` : `${(isGuestAddToCart ? (endpoint === 'preferences' || isGuestCartCall) ? this.guestCartUrl : this.guestCartUrl + 'cart/' : this.cartUrl)}${endpoint}`;
                    break;
            }
        }
        else {
            url = isEditOrderFlow ? `${this.cartEditOrderUrl}${endpoint}` : programType === '1P_SNS' ? `${this.config[this.currentEnv]?.snsConfig.url}${endpoint}` : `${(isGuestAddToCart ? (endpoint === 'preferences' || isGuestCartCall) ? this.guestCartUrl : this.guestCartUrl + 'cart/' : this.cartUrl)}${endpoint}`;
        }
        return baseDomain ? baseDomain + url : url;
    }
    /*
     * Creates a cart if it doesnt exists and adds a product or updates the quantuty of user cart for marketplace
     * and non marketplace products
     */
    addOrUpdateProductQuantity(product, pId, quantity, isBiaAddAll, sellerId, isDropdown = false, snsInfoObj, programType, isGuestAddToCart = false) {
        let cartItemsList;
        let reqBody;
        const isEditOrderFlow = this._commonService.checkPendingOrder() ? true : false;
        if (isBiaAddAll) {
            cartItemsList = quantity;
        }
        else {
            let obj = { itemId: pId, [isDropdown ? 'selectedWeight' : 'qty']: quantity };
            if (!this._commonService.isEmpty(snsInfoObj)) {
                const { isChecked, selectedFrequency, isFirstTimeSnsSub } = snsInfoObj;
                switch (isChecked) {
                    case true:
                        obj = { ...obj, isFirstTimeSnsSub: isFirstTimeSnsSub, isSnsSub: true, snsFrequency: { unit: "WEEK", count: selectedFrequency } };
                        break;
                    case false:
                        obj = { ...obj, isSnsSub: false };
                        break;
                    default:
                        break;
                }
            }
            cartItemsList = [obj];
        }
        if (isEditOrderFlow) {
            reqBody = JSON.stringify({
                [isDropdown ? 'selectedWeight' : 'quantity']: quantity
            });
        }
        else {
            reqBody = this.getRequestPayLoad(programType, cartItemsList, isGuestAddToCart);
        }
        let endpoint = '';
        const uuid = this._userInfoService.getUUID() ?? '';
        if (isEditOrderFlow) {
            const orderStoreId = this._aemService.getOrderStoredIdCookie();
            const orderNumber = this._aemService.getOrderNumberCookie();
            endpoint = `${orderStoreId}/${orderNumber}/${this.orderItemsUrl}/${pId}`;
        }
        else if (programType === '1P_SNS') {
            endpoint = `/${uuid}/oneTimeItems`;
        }
        else {
            endpoint = this.itemsUrl;
        }
        const cartItemsUrl = this.generateApiUrl(endpoint, isEditOrderFlow, programType, isGuestAddToCart);
        return this._http.post(cartItemsUrl, reqBody, {
            ...this.getHeaders(this._utilService.getParams('mode'), programType, isGuestAddToCart),
            ...this.getParams(sellerId, isEditOrderFlow, programType, '', '', '', isGuestAddToCart)
        })
            .pipe(map((multicartApiResponse) => {
            return this.transformMulticartResponse(multicartApiResponse);
        }), catchError(error => this.handleError(error, programType)));
    }
    /**
     * This method will return the request payload that needs to be sent to the cart v2 APIs (Based on some enabled features)
     * @@NOTE: For now, getRequestPayLoad method is only called when wine program
     * feature is enabled i.e supports only cartCategory '1P_WINE' (For Wine Program).
     * @@TODO: If some contract changes, going forward we have to change this method to support multiple features.
     */
    getRequestPayLoad(programType = 'abs', cartItemsList, isGuestAddToCart, apiType) {
        let payload;
        let cartCategory = '';
        let storeId = '';
        const guestCartId = this.getCartDetail()?.guestCartId ?? '';
        const isB2BSite = this._userInfoService.getSiteType() === 'B';
        if (isGuestAddToCart && apiType === 'preferences') {
            return {
                preferenceList: [
                    {
                        cartCategory: "1P",
                        guestCartId
                    }
                ]
            };
        }
        if (isB2BSite && programType === '1P_B2B') {
            cartCategory = programType;
            storeId = this._userInfoService.getShopStoreId();
        }
        else {
            cartCategory = '1P_WINE';
            storeId = this._userInfoService.getWfcStoreId();
        }
        let arrPreferenceList = [];
        const defaultPreferenceList = {
            cartCategory: cartCategory,
            storeId: storeId
        };
        arrPreferenceList = [defaultPreferenceList];
        if (cartItemsList) {
            payload = {
                preferenceList: arrPreferenceList,
                cartItemsList
            };
            if (programType === '1P_SNS' || isGuestAddToCart) {
                delete payload.preferenceList;
            }
            payload['cartCategory'] = programType === 'wineshop' ? cartCategory : isGuestAddToCart ? '1P' : (programType ? programType : '');
        }
        else {
            if (isGuestAddToCart || guestCartId) {
                const guestAddToCartPreferenceList = {
                    cartCategory: '1P',
                    ...this._userInfoService.isAuthorized() && { storeId: this._userInfoService.getShopStoreId() },
                    guestCartId
                };
                arrPreferenceList = [guestAddToCartPreferenceList, defaultPreferenceList];
            }
            payload = {
                preferenceList: arrPreferenceList
            };
        }
        return payload;
    }
    /*
     * Removes product from the user cart both for marketplace and non marketplace item
     */
    removeProduct(product, productId, sellerId, programType, isGuestAddToCart = false) {
        // if an erums store or user is in edit order flow for erums store, use eRUMS API
        let reqBody;
        const isEditOrderFlow = this._commonService.checkPendingOrder() ? true : false;
        const cartItemsList = [
            {
                itemId: productId
            }
        ];
        if (isEditOrderFlow) {
            reqBody = null;
        }
        else {
            reqBody = this.getRequestPayLoad(programType, cartItemsList, isGuestAddToCart);
        }
        let endpoint = '';
        const uuid = this._userInfoService.getUUID() ?? '';
        if (isEditOrderFlow) {
            const orderStoreId = this._aemService.getOrderStoredIdCookie();
            const orderNumber = this._aemService.getOrderNumberCookie();
            endpoint = `${orderStoreId}/${orderNumber}/${this.orderItemsUrl}/${productId}`;
        }
        else if (programType === '1P_SNS') {
            endpoint = `/${uuid}/oneTimeItems`;
        }
        else {
            endpoint = this.itemsUrl;
        }
        const deleteItemUrl = this.generateApiUrl(endpoint, isEditOrderFlow, programType, isGuestAddToCart);
        return this._http.request('delete', deleteItemUrl, {
            ...this.getHeaders(this._utilService.getParams('mode'), programType, isGuestAddToCart),
            ...this.getParams(sellerId, isEditOrderFlow, programType, '', '', '', isGuestAddToCart),
            body: reqBody
        })
            .pipe(map((multicartApiResponse) => {
            return this.transformMulticartResponse(multicartApiResponse);
        }), catchError(error => this.handleError(error, programType)));
    }
    /*
     * Updates cart summary based on the response from the server
     */
    updateCartSummary(response) {
        const allItems = this.mapErumsItems(response['cartItems']);
        // @@TODO - method for updating subtotal in header - not required for DFTA
        // window['AB'].CART.updateCartSummary(response['summary']);
        // @@TODO - datalayer setup
        // if (window['AB']['DATALAYER'] && !response['seller']) {
        //     window['AB']['DATALAYER'].updateCartId(response['cartId']);
        // }
        return allItems;
    }
    /*
     * This function returns common query string parameters for the api calls like serviceType, storeId, sellerId
     */
    getParams(sellerId = null, isEditOrderFlow, programType, storeId, serviceType, zipcode, isGuestAddToCart, apiType) {
        //NOTE:: We will append params only to the cart APIs if the user is not in edit order flow.
        if (!isEditOrderFlow) {
            if (programType === '1P_SNS') {
                return { params: { banner: this._userInfoService.getBanner() } };
            }
            serviceType = serviceType ? serviceType : this._userInfoService.getPreference().toLowerCase() === 'dug' ? 'Dug' : 'Delivery';
            const params = {
                'storeId': storeId ? storeId : this._userInfoService.getShopStoreId(),
                serviceType,
            };
            params['zipCode'] = zipcode ? zipcode : this._userInfoService.getShopZipcode();
            if (isGuestAddToCart) {
                const abCartObj = this.getCartDetail();
                if (apiType !== 'preferences') {
                    params['guestCartId'] = abCartObj?.['guestCartId'] ?? '';
                }
                return { params };
            }
            if (sellerId) {
                params['sellerId'] = sellerId;
            }
            const isB2BSite = this._userInfoService.getSiteType() === "B";
            let cartCategoryList = '1P,3P_MARKETPLACE,1P_Wine';
            if (isB2BSite) {
                cartCategoryList = this._commonService.getB2BCartList() ?? '1P_B2B';
            }
            else {
                cartCategoryList = this._commonService.getCartList() ?? cartCategoryList;
            }
            params['cartCategoryList'] = cartCategoryList;
            return {
                params
            };
        }
    }
    /*
     * This function generates new properties for pending orders from server response
     */
    // @@TODO - do we need handle for pending Order ?
    handleResponseForPendingOrder(response) {
        if (this._commonService.checkPendingOrder() && !this._aemService.getEditOrderOldVersion()) {
            const order = {
                ...response
            };
            if (order.hasOwnProperty('orderSummary')) {
                delete order['orderSummary'];
            }
            return {
                ...order,
                totalAmount: response['orderSummary'] ? response['orderSummary']['totalEstimatedPrice'] : null,
                subscriptionDetails: response['orderSummary'] ? response['orderSummary']['subscriptionDetails'] : null,
                totalOfferSavings: response['orderSummary'] ? response['orderSummary']['totalSavings'] : null,
                payments: response['payments'] && response['payments'].length ? order['payments'].map(payment => {
                    // subType needs to change the key name to subtype
                    const subtype = payment.subType;
                    delete payment.subType;
                    return {
                        ...payment,
                        subtype
                    };
                }) : response['payments'],
                orderSummary: {
                    ...response['orderSummary']
                },
                isWYSIWYGEnabled: response['isWYSIWYGEnabled'],
                wysiwygOrderSummary: {
                    ...response['wysiwygOrderSummary']
                }
            };
        }
        return response;
    }
    /**
     * This function serializes the multicart response into backward compatible abCart object
     * @param response
     * @param storeId
     * @param serviceType
     **/
    transformMulticartResponse(response, storeId, serviceType) {
        let abCartV2;
        const cartIdObj = {};
        if ((response.carts && response.carts.length !== 0) || response.hasOwnProperty('orderItems')) {
            const carts = {};
            let arrRes = [];
            arrRes = response.hasOwnProperty('orderItems') ? [{ ...response }] : response.carts;
            arrRes.forEach((cart) => {
                switch (true) {
                    case (cart.cartSource === 'ABS' && (cart.cartCategory ? cart.cartCategory === '1P' : true)) || cart.hasOwnProperty('orderItems'):
                        const absCart = this.generateAbsCart(cart, storeId, serviceType);
                        carts['abs'] = absCart;
                        // push abs cartId to cartId obj
                        cartIdObj['abs'] = absCart.cartId;
                        break;
                    case (cart.cartCategory && cart.cartCategory !== '1P') || cart.hasOwnProperty('seller'):
                        const { cartItemsList, ...otherCartProperties } = cart;
                        let key = '';
                        if (cart.cartCategory === '3P_MARKETPLACE' || cart.hasOwnProperty('seller')) {
                            key = cart.seller.sellerId;
                        }
                        else {
                            key = cart.cartCategory;
                        }
                        carts[key] = {
                            ...otherCartProperties,
                            cartItems: cartItemsList
                        };
                        // push individual seller cartId to cartId obj
                        cartIdObj[key] = cart.cartId;
                        break;
                    default:
                        console.warn('CART V2: transformMulticartResponse -- Malformed cart response');
                        break;
                }
            });
            // call updateCartIdFromResponse and pass cartIdObj to set cartId local storage
            this.updateCartIdFromResponse(cartIdObj);
            const { multiCartSummary, cart, ...otherEmpCartProperties } = this.getV2EmptyCartsLSObj(storeId, serviceType);
            abCartV2 = {
                cart: carts,
                ...(carts['abs'] ? carts['abs'] : { ...otherEmpCartProperties })
            };
            // we are setting multisummary obj only when the user is not in edit order flow.
            if (!this._commonService.checkPendingOrder()) {
                const multiCartSummaryObj = {
                    finalTransactionTotal: response['multiCartSummary']['finalTransactionTotal']
                        ? response['multiCartSummary']['finalTransactionTotal'] : 0.00,
                    totalAvailableCarts: response['multiCartSummary']['totalAvailableCarts']
                        ? response['multiCartSummary']['totalAvailableCarts'] : 0,
                    totalAvailableItems: response['multiCartSummary']['totalAvailableItems']
                        ? response['multiCartSummary']['totalAvailableItems'] : 0,
                    totalAvailableQuantity: response['multiCartSummary']['totalAvailableQuantity']
                        ? response['multiCartSummary']['totalAvailableQuantity'] : 0
                };
                abCartV2['multiCartSummary'] = multiCartSummaryObj;
            }
        }
        else {
            abCartV2 = this.getV2EmptyCartsLSObj();
            // call updateCartIdFromResponse and pass cartIdObj to set cartId local storage
            this.updateCartIdFromResponse(cartIdObj);
        }
        return abCartV2;
    }
    /*
     * This method is used to fetch specific cart from multicart response of the apis
     */
    fetchCartDetailsFromResponse(cartDetails, cartName) {
        if (cartDetails.cart && cartDetails.cart[cartName]) {
            return cartDetails.cart[cartName];
        }
        else {
            if (cartName === 'abs' || (cartName === '1P_B2B' && this._commonService.checkPendingOrder())) {
                return cartDetails;
            }
            else {
                console.warn('Seller cart is not available');
                return {};
            }
        }
    }
    /*
       * This method is used to get V2 empty cart obj
       */
    getV2EmptyCartsLSObj(storeId, channel) {
        return {
            multiCartSummary: {
                finalTransactionTotal: 0.00,
                totalAvailableCarts: 0,
                totalAvailableItems: 0,
                totalAvailableQuantity: 0
            },
            cart: {},
            cartItems: [],
            branchId: storeId ? storeId : this._aemService.getBranchId(),
            channel: channel ? (String(channel === 'dug' ? 'pickup' : channel)) : this._aemService.getUserChannel(),
            orderNumber: this._aemService.getOrderNumberCookie(),
            erumsStore: true,
            cartPrice: 0.00,
            cartQty: 0,
            isMTOOrder: false,
            isWYSIWYGEnabled: true
        };
    }
    /*
     * Loads and populates all the cart details from the api
     */
    getCartV2(customerId, programType, isGuestAddToCart) {
        let obs;
        const newProgramType = programType === '1P_B2B' ? programType : 'wineshop';
        const reqBody = this.getRequestPayLoad(newProgramType, undefined, isGuestAddToCart);
        const endpoint = isGuestAddToCart ? `carts` : `customer/${customerId}`;
        obs = this._http.post(this.generateApiUrl(endpoint, false, programType, isGuestAddToCart, true), reqBody, {
            ...this.getHeaders(this._commonService.getParams('mode'), programType, isGuestAddToCart),
            ...this.getParams(null, false, programType)
        });
        return obs.pipe(map((multicartApiResponse => this.transformMulticartResponse(multicartApiResponse))), catchError(this.handleError));
    }
    // --------------------------------------------------------------------------
    /**
     * Error Handling for Methods. Returns an error when the call is not passed.
     */
    // --------------------------------------------------------------------------
    handleError(errorResponse, programType) {
        if (programType === '1P_SNS') {
            // Call dispatchSnsOneTimeEvent with appropriate data
            this._commonService.dispatchSnsOneTimeEvent('productQtyUpdateError', {});
        }
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            const errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
            return throwError(errMsg);
        }
    }
    /**
     * Returns cartName based on the programType and sellerId
     *
     * **/
    getCartName(programType, sellerId) {
        let cartName;
        switch (true) {
            case (programType === 'mkp' || programType === 'mkp-carousel') && sellerId?.length > 0:
                cartName = sellerId;
                break;
            case programType === 'wineshop':
                cartName = '1P_WINE';
                break;
            case programType === '1P_SNS':
            case programType === '1P_B2B':
                cartName = programType;
                break;
            default:
                cartName = 'abs';
        }
        return cartName;
    }
    /**
    * Retrieves the increment price list for a given UPC.
    * @param upc The UPC of the product.
    * @returns An Observable that emits the increment price list.
    * **/
    getIncrementPriceList(upc) {
        const wiremockAPIDetails = this.config[this.currentEnv]?.wiremockAPIDetails;
        const catalogConfig = this.config[this.currentEnv]?.catalogConfig;
        const mode = this._utilService.getParams('mode');
        let path = catalogConfig['apim.api.catalog.path'] + catalogConfig['apim.api.catalog.increment.price.list.endpoint'];
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            if (mode === 'record') {
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            }
            else if (mode === 'playback') {
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
        }
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ocp-apim-subscription-key': (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : catalogConfig['apim.api.brand.index.service.key']
            })
        };
        const incrementPriceListPath = path + `?upcIds=${upc}&storeId=${this._userInfoService.getShopStoreId()}`;
        return this._http.get(incrementPriceListPath, httpOptions).pipe(retry(1));
    }
    ;
    getCartDetail() {
        const abCartString = localStorage.getItem('abCart');
        return abCartString ? JSON.parse(abCartString) : null;
    }
    static { this.ɵfac = function CartV2Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CartV2Service)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(AemService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(UtilService), i0.ɵɵinject(i0.NgZone)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CartV2Service, factory: CartV2Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartV2Service, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: AemService }, { type: UserInfoService }, { type: UtilService }, { type: i0.NgZone }], null); })();

/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for adding/Updating/Removing products from /cart

*/
class CartService {
    constructor(configObjFromModule, _http, _commonService, _aemService, _userInfoService, _cartV2Service, zone) {
        this.configObjFromModule = configObjFromModule;
        this._http = _http;
        this._commonService = _commonService;
        this._aemService = _aemService;
        this._userInfoService = _userInfoService;
        this._cartV2Service = _cartV2Service;
        // this variable will be used when local storage is disabled
        this._abCart = '';
        this._eventDispatched = false;
        this.CONST_WEEKLYAD = 'weeklyAd';
        this.CONST_CART = 'cart';
        this.rightDrawerEvent = new Subject();
        this.$rightDrawerEvent = this.rightDrawerEvent.asObservable();
        this.isGuestAddToCartTestValue = 'a';
        /**
        * Method to update store for existing cart
        * calls v2 of cart API if disableCartV2 === false else calls v1 of cart API
        */
        this.updateStoreForExistingCart = function (storeId, serviceType, deliveryType, offbanner, callback, zipcode) {
            this.processStoreUpdateV2(storeId, serviceType, offbanner, callback, zipcode);
        };
        this.refreshCart = function (objCart) {
            console.log('CART Refresh by: ', objCart);
            this.rightDrawerEvent.next({
                'event': 'refreshCart',
                'data': objCart
            });
            switch (true) {
                case objCart !== undefined && objCart.hasOwnProperty('cart'):
                case objCart !== undefined && Array.isArray(objCart['cartItems']):
                    this._set(objCart);
                    this.setAriaLiveCart('idAriaCartMsg', objCart);
                    break;
                case !this._commonService.checkPendingOrder():
                    console.log('REFRESH CART - REMOTE ERUMS CART');
                    this._loadERUMSRemoteCart();
                    break;
                default:
                    console.log('REFRESH CART - REMOTE ECOM CART');
                    this._loadRemoteCart();
                    break;
            }
        };
        this.mapErumsItems = function (items) {
            return items
                ? items.map((item) => ({
                    id: item.itemId,
                    name: item.name,
                    quantity: item.qty,
                    price: item.price,
                    basePrice: item.basePrice,
                    pricePerUnit: item.unitPrice,
                    unitType: item.unitQuantity,
                    totalPrice: item.totalPrice,
                    clubCardSaving: item.clubCardSaving ? item.clubCardSaving : 0,
                    isAvailable: item.isAvailable ? item.isAvailable : '',
                    isFound: item.isFound ? item.isFound : '',
                    savings: item.savings ? item.savings : [],
                    clipped: item.clipped ? item.clipped : [],
                    maxPurchaseQty: item.maxPurchaseQty,
                    departmentName: item.departmentName
                }))
                : [];
        };
        this.updateCartHeader = (cartCount, cartPrice, multiCartSummary) => {
            // if it is enabled (disableCartv2 === false) and seller Cart if one or more
            let isNavigationEngineEnabled = false;
            if (window['SWY'] && window['SWY']['CONFIGSERVICE']?.featureToggleConfig) {
                isNavigationEngineEnabled =
                    window['SWY'] && window['SWY']['CONFIGSERVICE']?.featureToggleConfig?.isNavigationEngineDisabled ? false : true;
            }
            else if (window['SWY'].configService?.isNavigationEngineDisabled && window['SWY'].configService?.isNavigationEngineDisabled === 'false') {
                isNavigationEngineEnabled = true;
            }
            if (multiCartSummary && Object.keys(multiCartSummary).length > 0) {
                if (multiCartSummary?.totalAvailableQuantity) {
                    if (multiCartSummary?.totalAvailableQuantity <= 99) {
                        $('.badge-icon').removeClass('d-none badge-icon-plus');
                        $('.badge-text').removeClass('badge-text-plus').text(`${multiCartSummary?.totalAvailableQuantity}`);
                        if (isNavigationEngineEnabled) {
                            $('.badge-icon').removeClass('s_badge-icon-plus');
                            $('.badge-text').removeClass('s_badge-text-plus');
                        }
                    }
                    else if (multiCartSummary?.totalAvailableQuantity > 99) {
                        $('.badge-icon').removeClass('d-none').addClass('badge-icon-plus');
                        $('.badge-text').addClass('badge-text-plus').text('99+');
                        if (isNavigationEngineEnabled) {
                            $('.badge-icon').addClass('s_badge-icon-plus');
                            $('.badge-text').addClass('s_badge-text-plus');
                        }
                    }
                }
                else {
                    $('.badge-text').text('');
                    $('.badge-icon').addClass('d-none');
                }
            }
            else {
                if (cartCount) {
                    if (cartCount <= 99) {
                        $('.badge-icon').removeClass('d-none badge-icon-plus');
                        $('.badge-text').removeClass('badge-text-plus').text(`${cartCount}`);
                        if (isNavigationEngineEnabled) {
                            $('.badge-icon').removeClass('s_badge-icon-plus');
                            $('.badge-text').removeClass('s_badge-text-plus');
                        }
                    }
                    else if (cartCount > 99) {
                        $('.badge-icon').removeClass('d-none').addClass('badge-icon-plus');
                        $('.badge-text').addClass('badge-text-plus').text('99+');
                        if (isNavigationEngineEnabled) {
                            $('.badge-icon').addClass('s_badge-icon-plus');
                            $('.badge-text').addClass('s_badge-text-plus');
                        }
                    }
                }
                else {
                    $('.badge-text').text('');
                    $('.badge-icon').addClass('d-none');
                }
            }
        };
        this._loadCartPrice = function () {
            let cartPrice = '0.00';
            let cartCount = 0;
            const objCart = this._get();
            if (objCart.cartPrice) {
                cartPrice = Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(objCart.cartPrice);
            }
            if (objCart.cartQty) {
                cartCount = objCart.cartQty;
            }
            if (this._userInfoService.getPreference().toUpperCase() !== 'J4U') {
                $('.ab-cart a').attr('aria-label', `Shopping Cart, ${cartCount} items, Total ${cartPrice}`);
                this.updateCartHeader(cartCount, cartPrice, objCart['multiCartSummary']);
            }
        };
        window['cartServiceRefAL'] = {
            zone: zone,
            service: this,
        };
        this._commonService._userInfoRefresh.subscribe(data => {
            if (data === 'initFunc') {
                this.configObj = this.configObjFromModule ? this.configObjFromModule : {};
                const isB2BSite = this._userInfoService.getSiteType() === 'B';
                this.configObj.programType = isB2BSite ? '1P_B2B' : this.configObj?.programType;
                this._init();
            }
        });
    }
    _init() {
        this._aemService.getStoreStatus();
        const objCart = this._get();
        this.isGuestAddToCartABSubscription = this._commonService.isABFlagDisabledEvent$.pipe(first(event => event.flagName === 'isGuestAddToCartDisabled')).subscribe((event) => {
            this.isGuestAddToCart = event.testValue !== 'a' && !this._userInfoService.isAuthorized() && (!this.configObj.programType || this.configObj.programType === 'abs');
            this.isGuestAddToCartTestValue = event.testValue;
        });
        this._commonService.listenToABXTestingFlag('abACIP295974', 'isGuestAddToCartDisabled', 'ACIP295974');
        if (this._aemService.isLSCompatible() && this._lsHasValidErumsData(objCart) &&
            !(this._userInfoService.isAuthorized() && objCart['guestCartId'])) {
            // added for slice 3, checks 2 conditions :
            // 1. If on slice 1 banner and on SHOP side , 2. If on slice 3 banner and preference is not j4u
            if (this._userInfoService.getPreference() !== 'J4U') {
                if (this._userInfoService.isAuthorized() && !this._commonService.checkPendingOrder()
                    && (!this.configObj?.appName || this.configObj?.appName !== 'dnf')) {
                    this._aemService.checkReserveTime();
                }
                this._commonService.checkPendingOrderAlert();
            }
            // trigger cartObjSource observer and loadCartPrice only if preference not J4U
            if (this._userInfoService.getPreference().toLowerCase() !== 'j4u') {
                this._commonService._cartObjSource.next(objCart);
                this._loadCartPrice();
            }
        }
        else {
            // added for slice 3, checks 2 conditions :
            // 1. If on slice 1 banner and on SHOP side , 2. If on slice 3 banner and preference is not j4u
            if (this._userInfoService.getPreference() !== 'J4U') {
                if (this._userInfoService.isAuthorized() && !this._commonService.checkPendingOrder()
                    && (!this.configObj?.appName || this.configObj?.appName !== 'dnf')) {
                    this._aemService.checkReserveTime();
                }
                this._commonService.checkPendingOrderAlert();
            }
            if (!this._commonService.checkPendingOrder()) {
                this._loadERUMSRemoteCart();
            }
        }
        if (this.objRefreshInterval) {
            clearInterval(this.objRefreshInterval);
        }
        this.objRefreshInterval = setInterval(() => {
            console.log('CART - INIIATING THE CART REFRESH');
            if (this._aemService.checkAuthorizedCookie()
                && this._aemService.isTokenActive()
                && this._aemService.authorize()
                && this._aemService.isLSCompatible()
                && this._userInfoService.getPreference() !== 'J4U') {
                console.log('CART - REFRESH CART');
                this.refreshCart();
            }
            else {
                console.log('CART - TIMER IS NOT REQUIRED');
                clearInterval(this.objRefreshInterval);
            }
        }, 900000);
    }
    _loadRemoteCart() {
        if (this._aemService.authorize() && this._aemService.checkAuthorizedCookie()) {
            let strRequest = `?rand=${(Math.floor((Math.random() * 1000000)))}`;
            const orderNumber = this._aemService.getOrderNumberCookie();
            strRequest += (orderNumber !== '' && orderNumber != null) ? `&id=${orderNumber}` : '';
            const objHttp = this._http.get(`${this._aemService.getMiniCartPath()}${strRequest}`);
            console.log('CART ANGULAR: INITIATED');
            objHttp.subscribe((objResponse) => {
                if (!objResponse['ack']) {
                    const cartPrice = !this._commonService.isEmpty(objResponse['cartSummary'].cost)
                        ? 0.00
                        : objResponse['cartSummary'].cost;
                    const cartQty = !this._commonService.isEmpty(objResponse['cartSummary'].itemsCount)
                        ? 0
                        : objResponse['cartSummary'].itemsCount;
                    const objCart = {
                        cartItems: objResponse['cartItems'],
                        branchId: this._userInfoService.getShopStoreId(),
                        channel: this._userInfoService.getUserChannel(),
                        orderNumber: orderNumber,
                        erumsStore: false,
                        isWYSIWYGEnabled: objResponse['isWYSIWYGEnabled'],
                        cartPrice,
                        cartQty
                    };
                    if (objResponse.hasOwnProperty('isMTOOrder')) {
                        objCart['isMTOOrder'] = objResponse['isMTOOrder'];
                        if (objCart['isMTOOrder']) {
                            objCart['mtoMaxPrepTime'] = objResponse['mtoMaxPrepTime'];
                        }
                    }
                    console.log('CART ANGULAR: RESPONSE RECEIVED', objResponse['cartItems']);
                    this._set(objCart);
                    this._loadCartPrice();
                }
            });
        }
    }
    /**
     * Method to trigger Cart get API
     * **/
    _loadERUMSRemoteCart() {
        this.processGetCartV2();
    }
    /**
     * Method calls V2 of cart API using cart v2 service
     * on Success calls set method to ypdate cart LS with updated response
     * on Failure calls set method to updated cart LS with empty obj
     * set method will trigger cart observable to update quantity steppers
     * **/
    processGetCartV2() {
        if (this.isGuestAddToCartTestValue === 'a' && this._get()['guestCartId']) {
            localStorage.removeItem('abCart');
        }
        if (this._aemService.authorize() || (this.isGuestAddToCart && this._get()['guestCartId'])) {
            const custId = this._userInfoService.getCustomerId();
            if (custId || this.isGuestAddToCart) {
                const dataObs = this._cartV2Service.getCartV2(custId, this.configObj?.programType ? this.configObj?.programType : this.configObj?.appName, this.isGuestAddToCart);
                this.processObsResponse(dataObs);
            }
        }
    }
    /**
     * Method which checks the user channel and return the intent preference parameter accordingly
     * @return {​string}​
     */
    getIntendPreferenceParam() {
        const userChannelChoice = this._userInfoService.getUserChannel();
        let intentPreferenceParam = '';
        switch (userChannelChoice) {
            case 'pickup':
                intentPreferenceParam = '&serviceType=DUG';
                break;
            case 'delivery':
                const deliveryType = this._userInfoService.getUnattendedDeliveryIsEnabled() === true ? 'Unattended' : 'Attended';
                intentPreferenceParam = `&serviceType=Delivery&deliveryType=${deliveryType}`;
                break;
            case 'instore':
                intentPreferenceParam = '&serviceType=inStore';
                break;
            default:
                break;
        }
        return intentPreferenceParam;
    }
    _set(objCart) {
        objCart['updatedTime'] = JSON.stringify(new Date());
        const objCartJSONstr = JSON.stringify(objCart);
        if (this._aemService.isLSCompatible()) {
            localStorage.setItem('abCart', objCartJSONstr);
            if (!this._eventDispatched) {
                const cartSavedToLS = new Event('cartSavedToLS');
                document.dispatchEvent(cartSavedToLS);
                this._eventDispatched = true;
            }
            if ((window.location.href).includes('erums/store/prebook') || (window.location.href).includes('erums/cart/dnf')
                || (window.location.href).includes('/product')) {
                const cartUpdated = new CustomEvent('cartUpdated', { detail: objCart });
                document.dispatchEvent(cartUpdated);
            }
        }
        else {
            this._abCart = objCartJSONstr;
        }
        // trigger cartObjSource observer and loadCartPrice only if preference not J4U
        if (this._userInfoService.getPreference().toLowerCase() !== 'j4u') {
            this._commonService._cartObjSource.next(objCart);
            this._loadCartPrice();
            if ((window.location.href).includes('view=instantCart')) {
                this._commonService._updateBiaAddAllBtn.next(true);
            }
        }
    }
    _get(serviceType) {
        let objCart = {};
        let strCart = '';
        if ((serviceType ?? this._userInfoService.getPreference().toLowerCase()) !== 'j4u') {
            if (this._aemService.isLSCompatible()) {
                strCart = localStorage.getItem('abCart');
            }
            else {
                strCart = this._abCart;
            }
            try {
                if (strCart) {
                    try {
                        objCart = JSON.parse(strCart);
                    }
                    catch (e) {
                        objCart = {};
                    }
                }
            }
            catch (e) {
                console.error('ERROR: COUPON - GETTING FROM LOCAL STORAGE');
                console.error(e);
            }
        }
        return objCart;
    }
    _lsValidErumsData(objCart) {
        let response = false;
        if (!this._commonService.isEmpty(objCart)) {
            const isGuestAddToCart = !this._aemService.getFeatureFlagByNameDisable('isGuestAddToCartDisabled') && !this._userInfoService.isAuthorized() && (!this.configObj.programType || this.configObj.programType === 'abs');
            if (this._commonService.checkPendingOrder()) {
                response = objCart['branchId'] === this._aemService.getOrderStoredIdCookie();
                response = objCart['orderNumber'] === this._aemService.getOrderNumberCookie();
            }
            else {
                response = objCart['branchId'] === this._userInfoService.getShopStoreId();
                response = objCart['channel'] === this._userInfoService.getUserChannel();
            }
            if (response && !this._commonService.checkPendingOrder()) {
                if (objCart['updatedTime'] !== undefined) {
                    const updatedTime = Date.parse(JSON.parse(objCart['updatedTime']));
                    const currentTime = Date.parse(JSON.parse(JSON.stringify(new Date())));
                    const timeDiff = (currentTime - updatedTime) / 60000;
                    const validAmountOfMinutesTillExpires = this.isGuestAddToCart ? 14400 : 15;
                    response = timeDiff < validAmountOfMinutesTillExpires ? true : false;
                }
                else {
                    response = false;
                }
            }
        }
        return response;
    }
    _lsHasValidErumsData(objCart) {
        let response = false;
        if (this._lsValidErumsData(objCart)) {
            // TODO: We should clean this up after checking with cart team
            // Check if store is from ERUMS or not
            if (objCart['erumsStore']) {
                response = true;
            }
            else if (this._aemService.authorize() && this._aemService.checkAuthorizedCookie()) {
                response = true;
            }
        }
        return response;
    }
    /**
     * Method to updated store id for existing cart using cart v2 API
     * @param storeId current user storeId
     * @param serviceType current user preference
     * @param offbanner pass true if user changing banner
     * @param callback callback function
     * @param zipcode user current zipcode
     */
    processStoreUpdateV2(storeId, serviceType, offbanner, callback, zipcode) {
        const objCart = this._get(serviceType);
        if ((this.isGuestAddToCart && objCart?.['guestCartId']) || !this.isGuestAddToCart) {
            const dataObs = this._cartV2Service.updateStoreForExistingCartV2(storeId, serviceType, zipcode, this.isGuestAddToCart);
            this.processObsResponse(dataObs, offbanner, callback);
        }
        else {
            if (typeof callback === 'function') {
                callback({
                    ack: true
                });
            }
        }
    }
    /**
     * Method which will take Observable as an input
     * If response is successful, then it will set abCart with whatever received and update cart price in the header.
     * If response is not successful, then it will set abCart with empty default values and update cart price in the header.
     */
    processObsResponse(obs, offbanner, callback) {
        obs.subscribe((objResponse) => {
            if (objResponse && !offbanner) {
                this._set(objResponse);
                this._loadCartPrice();
            }
            if (typeof callback === 'function') {
                callback(objResponse);
            }
        }, (err) => {
            console.warn('========= CART API FAILED ========', err);
            // TODO: Do the analysis to move this into angular code
            // update cartId local storage
            this._aemService.invalidateCartId();
            // set empty cart obj
            this._set(this._cartV2Service.getV2EmptyCartsLSObj());
            this._loadCartPrice();
            if (typeof callback === 'function') {
                callback({
                    ack: true
                });
            }
        });
    }
    setAriaLiveCart(idAriaMsg, objCart) {
        const elem = $(`#${idAriaMsg}`);
        if (objCart.cartPrice && objCart.cartQty) {
            const strCartMessage = `Cart updated. ${objCart.cartQty} total items in cart. Estimated Subtotal $${objCart.cartPrice}.`;
            elem.html(strCartMessage);
        }
        // clear cart message after 3 seconds
        setTimeout(() => {
            elem.html('');
        }, 3000);
    }
    processOfferComplete(objCart, couponList, product) {
        const isWYSIWYGEnabled = objCart && objCart['isWYSIWYGEnabled'] ? objCart['isWYSIWYGEnabled'] : false;
        if (isWYSIWYGEnabled && objCart['cartItems']) {
            const cartItemsList = objCart['cartItems'];
            let cartProduct;
            if (product.id) {
                cartProduct = cartItemsList.find((item) => item.itemId.toString() === product.id.toString());
            }
            else if (product.itemId) {
                cartProduct = cartItemsList.find((item) => item.itemId.toString() === product.itemId.toString());
            }
            if (cartProduct && cartProduct.savings && cartProduct.savings.length > 0) {
                couponList.forEach((coupon) => {
                    const couponOfferComplete = cartProduct.savings.find((savingCoupon) => savingCoupon.omsOfferId === coupon.offerId);
                    coupon['offerComplete'] = couponOfferComplete && couponOfferComplete.display ? true : false;
                });
            }
            else {
                couponList.forEach((coupon) => coupon['offerComplete'] = false);
            }
        }
        else {
            couponList.forEach((coupon) => coupon['offerComplete'] = false);
        }
        return couponList;
    }
    processBOGOComplete(objCart, product) {
        const isWYSIWYGEnabled = objCart && objCart['isWYSIWYGEnabled'] ? objCart['isWYSIWYGEnabled'] : false;
        if (isWYSIWYGEnabled) {
            if (objCart && objCart['cartItems']) {
                const cartItemsList = objCart['cartItems'];
                let cartProduct;
                if ((product.promoType === 'M' || product.promoType === 'B')
                    && this._commonService.isProductPromoActive(product)) {
                    if (product.id) {
                        cartProduct = cartItemsList.find((item) => item.itemId.toString() === product.id.toString());
                    }
                    else if (product.itemId) {
                        cartProduct = cartItemsList.find((item) => item.itemId.toString() === product.itemId.toString());
                    }
                }
                if (cartProduct) {
                    const couponBOGO = cartProduct.savings && cartProduct.savings.length > 0
                        ? cartProduct.savings.find((savingCoupon) => savingCoupon.source === 'CMS' && savingCoupon.linkPluNumber)
                        : {};
                    product['offerComplete'] = couponBOGO && couponBOGO.display ? true : false;
                }
                else {
                    product['offerComplete'] = false;
                }
            }
        }
        else {
            product['offerComplete'] = false;
        }
    }
    /**
     * Method generating the image url.
     *
     * @param product current product info
     * @param viewport user browser window size
     */
    getImageUrl(product, viewport) {
        let imageUrl = '';
        if (this._commonService.checkPendingOrder()
            && this._aemService.getDMTMiniCart()
            && product
            && product.id) {
            imageUrl = this._aemService.getDMTMiniCart().replace('${product.id}', product.id);
            imageUrl = imageUrl.replace('${viewport}', viewport);
        }
        else if (this._aemService.getDMTMiniCart()
            && product
            && product.itemId) {
            imageUrl = this._aemService.getDMTMiniCart().replace('${product.id}', product.itemId);
            imageUrl = imageUrl.replace('${viewport}', viewport);
        }
        return imageUrl;
    }
    loadPendingOrderData() {
        this._commonService._cartObjSource.next(this._get());
        this._loadCartPrice();
    }
    static { this.ɵfac = function CartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CartService)(i0.ɵɵinject('configObj'), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(AemService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(CartV2Service), i0.ɵɵinject(i0.NgZone)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CartService, factory: CartService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartService, [{
        type: Injectable
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: ['configObj']
            }] }, { type: i1.HttpClient }, { type: CommonService }, { type: AemService }, { type: UserInfoService }, { type: CartV2Service }, { type: i0.NgZone }], null); })();

class ProductCouponService {
    constructor(http, _commonService, _userInfoService, _http, _utilService) {
        this.http = http;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._http = _http;
        this._utilService = _utilService;
        this.couponUpdated = new Subject();
        this.currentEnv = '';
        this.clipDigitalCouponSubject = new Subject();
        this.clipDigitalCouponEvent$ = this.clipDigitalCouponSubject.asObservable();
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        //this.disableNDC = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].featureToggleConfig && window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableNDC ? true : false;
        this.disableNDC = false;
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }
    /**
     * Get numbers of clipped offers.
     *
     * @param {CouponModel[]} coupons Product coupons object.
     */
    getOffersClipped(coupons) {
        let count = 0;
        coupons.forEach(c => {
            if ((c.status === 'C' && c.deleted === false) || c.isClippable === false) {
                count++;
            }
        });
        return count;
    }
    /**
     * Get numbers of clipped offers.
     *
     * @param {CouponModel[]} coupons Product coupons object.
     */
    getCouponsCompletedCounter(coupons) {
        let count = 0;
        coupons.forEach(coupon => {
            if ((coupon.isClippable === false && coupon.offerComplete === true) || (coupon.status === 'C' && coupon.deleted === false && coupon.offerComplete === true)) {
                count++;
            }
        });
        return count;
    }
    /**
     * Check if localstorage is available on user's device.
     */
    _checkLocalStorage() {
        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            return true;
        }
        catch (e) {
            return false;
        }
    }
    /**
    * Check if coupon is expired or not
    */
    isCouponExpired(coupon) {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const dateString = `${month}/${day}/${year}`;
        const finalDate = new Date(dateString);
        const endDateMilliSeconds = parseInt(coupon.endDate);
        const endDate = new Date(endDateMilliSeconds);
        const endDay = endDate.getDate();
        const endMonth = endDate.getMonth() + 1;
        const endYear = endDate.getFullYear();
        const couponendDateString = `${endMonth}/${endDay}/${endYear}`;
        const couponEndDate = new Date(couponendDateString);
        return couponEndDate < finalDate;
    }
    /**
     * Emit Observable to clip digital and single coupon
     */
    clipDigitalCoupon(productUpc) {
        this.clipDigitalCouponSubject.next(productUpc);
    }
    clipCoupon(coupon, storeId, configObj, analyticsData) {
        // DFTA integration @@TODO - need to un hardcode bannner , 
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'SWY_SSO_TOKEN': this._userInfoService.getSWY_SHOP_TOKEN(),
                "X-IBM-Client-Id": this.config[this.currentEnv].j4uAPIDetails['X-IBM-Client-Id'],
                "X-IBM-Client-Secret": this.config[this.currentEnv].j4uAPIDetails['X-IBM-Client-Secret'],
                "X-SWY_API_KEY": "emjou",
                "X-SWY_BANNER": "safeway",
                "X-SWY_VERSION": "1.0",
                "X-swyConsumerDirectoryPro": this._userInfoService.getSWY_SHOP_TOKEN(),
                "x-swy-correlation-id": this._commonService.generateUUID()
            })
        };
        // DFTA integration @@TODO - need to remove host , how to handle local env ?
        let clipUrl = this.config[this.currentEnv].j4uAPIDetails['clipPath'] + '?storeId=' + this._userInfoService.getShopStoreId();
        if (configObj && configObj.bannerDomain) {
            clipUrl = configObj.bannerDomain + clipUrl;
        }
        let result = defer(() => of({}));
        let reqBody = {};
        if (coupon.deleted) {
            reqBody = {
                items: [
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }
        else {
            reqBody = {
                items: [
                    {
                        clipType: 'C',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    },
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }
        result = this.http.post(clipUrl, reqBody, httpOptions).pipe(map((response) => {
            console.warn('clip response', response);
            if (response && response['items']) {
                if (response['items'][0]['status'] == 1) {
                    coupon.status = 'C';
                    coupon.deleted = false;
                    // Local Storage implementation
                    // if(this._commonService.isLSCompatible() && localStorage.abJ4uCoupons != undefined ) {
                    //     let abJ4uCoupons = JSON.parse(localStorage.abJ4uCoupons);
                    //     if (abJ4uCoupons) {
                    //         let objCoupons = abJ4uCoupons['objCoupons'];
                    //         if(objCoupons && objCoupons[coupon.offerId] != undefined){
                    //             let tempCoupon = objCoupons[coupon.offerId];
                    //             tempCoupon.status = 'C';
                    //             tempCoupon.deleted = false;
                    //             /* custom code for instant allocation
                    //              * can be deleted once campaign is completed */
                    //             if (tempCoupon.instantAllocation == true) {
                    //                  abJ4uCoupons['instantAllocOffer'] = [];
                    //                  tempCoupon.instantAllocation = undefined;
                    //             }
                    //         }
                    //         abJ4uCoupons['arrClippedCoupons'] = [...abJ4uCoupons['arrClippedCoupons'], coupon.offerId];
                    //         localStorage.abJ4uCoupons = JSON.stringify(abJ4uCoupons);
                    //     }
                    // }
                    this.couponUpdated.next({ id: coupon.offerId, deleted: false, status: 'C' });
                    this._commonService.clipEcomGalleryCoupon(coupon.offerId);
                    // update analytics data layer
                    var _coupon = {
                        "brand": coupon['instantAllocation'] ? 'welcome-offer-clip' : coupon.brand,
                        "offerType": coupon.offerPgm,
                        "offerId": coupon.offerId,
                        "offerPrice": coupon.offerPrice,
                        "carouselSection": window && window['digitalData'] && window['digitalData']['productInfo'] && window['digitalData']['productInfo'].carouselSection || ''
                    };
                    if (window && window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].clipCoupon(_coupon, analyticsData);
                    }
                }
                else if (response['items'][0]['status'] == 0) {
                    // DFTA - do we need this modal ?? currently lives in AEM footers
                    $('#errorModal').modal({ 'show': true });
                    let strError = "200: Coupon Expired";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }
                else {
                    $('#errorModal').modal({ 'show': true });
                    let strError = "200: Coupon Clip failed - status is not either 0 or 1";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }
            }
            else {
                $('#errorModal').modal({ 'show': true });
                let strError = "200: Coupon Clip failed - items is not defined ";
                if (response['errorCd'] && response['errorMsg']) {
                    strError += " " + response['errorCd'] + " " + response['errorMsg'];
                }
                //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
            }
            return response;
        }), catchError((err) => {
            console.error('clip error', err);
            let strError = err.status + ": Coupon Clip failed";
            if (typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }
            //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
            return null;
        }));
        return result;
    }
    unclipCoupon(offer) {
        let httpOptions = { headers: new HttpHeaders(window['AB'].j4uHttpOptions) };
        let unClipUrl = window['AB']['couponUnclipPath'];
        let result = defer(() => of({}));
        const body = { items: [{ id: offer.id }] };
        result = this.http.post(unClipUrl, body, httpOptions).pipe(map((response) => {
            // if(this.appConfigService.isLSCompatible() && localStorage.abJ4uCoupons != undefined ) {
            //     let abJ4uCoupons = JSON.parse(localStorage.abJ4uCoupons);
            //     if (abJ4uCoupons) {
            //         let objCoupons = abJ4uCoupons['objCoupons']
            //         if(objCoupons && objCoupons[offer.referenceId] != undefined ){
            //             let tempCoupon = objCoupons[offer.referenceId];
            //             tempCoupon.deleted = true;
            //             tempCoupon.status = 'U';
            //             if(tempCoupon.events.includes("Welcome Offers")) {
            //                 tempCoupon.instantAllocation = true;
            //                 abJ4uCoupons['instantAllocOffer'] = [tempCoupon];
            //             }
            //         }
            //         abJ4uCoupons['arrClippedCoupons'] = abJ4uCoupons['arrClippedCoupons'].filter(id => id != offer.referenceId);
            //         localStorage.abJ4uCoupons = JSON.stringify(abJ4uCoupons);
            //     }
            // }
            this.couponUpdated.next({ id: offer.referenceId, deleted: true, status: 'U' });
            this._commonService.unclipEcomGalleryCoupon(offer.referenceId);
            var _coupon = {
                "brand": offer.title,
                "offerType": offer.itemType,
                "offerId": offer.referenceId,
                "offerPrice": offer.savingsValue
            };
            window['AB']['DATALAYER'].unClipCoupon(_coupon);
            //add 'ecoupon' flag in cookie to show shop coupon has been unclipped
            window['SWY'].ENFORCEMENTUTILS.updateReInitSite('ecoupon');
            return response;
        }), catchError((err) => {
            console.error('Unclip error', err);
            let strError = err.status + ": Coupon UnClip failed";
            if (typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }
            //window['AB']['DATALAYER'].setError(offer.id.toString(), 'coupon clipping', strError);
            return null;
        }));
        return result;
    }
    static { this.ɵfac = function ProductCouponService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductCouponService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(UtilService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductCouponService, factory: ProductCouponService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCouponService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: UserInfoService }, { type: i1.HttpClient }, { type: UtilService }], null); })();

/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- Contains the methods used for handling actions for getting offer-details info to show in
    the right drawer

*/
class OfferDetailService {
    constructor(http, _commonService, _userInfoService, _http, _utilService, _aemService) {
        this.http = http;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._http = _http;
        this._utilService = _utilService;
        this._aemService = _aemService;
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        this.currentEnv = '';
        this.couponUpdated = new BehaviorSubject({});
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }
    /**
     * Get data from API Endpoint.
     *
     * @param {any} offerId
     * @param {any} offerts
     * @param {any} offerType
     */
    getOfferDetailData(offerId, offerType, configObj) {
        const storeId = this._userInfoService.getShopStoreId();
        let apiUrl = this.config[this.currentEnv].offerDetailAPIDetails['offerDetailPath'] + `?offerId=${offerId}&storeId=${storeId}&offerPgm=${offerType}&includeUpc=y`;
        const httpHeaders = {
            "Content-Type": "application/json",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "2.1"
        };
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            const wireMockSubscriptionKey = wiremockAPIDetails?.subscriptionKey;
            if (mode === 'playback') {
                apiUrl = wiremockAPIDetails?.playbackBaseUrl + apiUrl;
                httpHeaders['Ocp-Apim-Subscription-Key'] = wireMockSubscriptionKey;
            }
            else if (mode === 'record') {
                apiUrl = wiremockAPIDetails?.recorderBaseUrl + apiUrl;
                httpHeaders['Ocp-Apim-Subscription-Key'] = wireMockSubscriptionKey;
            }
        }
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        if (configObj && configObj.bannerDomain) {
            apiUrl = configObj.bannerDomain + apiUrl;
        }
        return this._http.get(apiUrl, httpOptions).pipe(map((data) => {
            // is BXGY offer eligible and offer is NDC coupon
            const isBXGYEligibleOffer = this._commonService.getIsOfferEligibleBXGY(data) && (this._commonService.isEmpty(configObj?.programType) || configObj?.programType === 'abs');
            if (isBXGYEligibleOffer) {
                this._commonService.bxgyOffer.next({
                    upcList: data['upcList'],
                    eligibleUpcList: data['getEligibleUpcList'],
                    offerDetail: data['offerDetail'],
                    offerProgramType: data['offerProgramType'],
                    offerProtoType: data['offerProtoType'],
                });
                // if upcList is empty then set upcList as getEligibleUpcList for BXGY
                if (!data['upcList']?.length) {
                    this._commonService.upcs.next(data['getEligibleUpcList']);
                }
                else {
                    this._commonService.upcs.next(data['upcList']);
                }
            }
            else {
                this._commonService.upcs.next(data['upcList']);
            }
            return data;
        }), catchError((error) => {
            this._commonService.upcs.next([]);
            this._commonService.bxgyOffer.next({});
            return of({});
        }));
    }
    getOfferDisclaimerTemplate(offerDisclaimerXpath, configObj) {
        if (configObj && configObj.bannerDomain) {
            offerDisclaimerXpath = configObj.bannerDomain + offerDisclaimerXpath;
        }
        const offerDetailDisclaimerTemplate = this._http.get(offerDisclaimerXpath, { 'responseType': 'text' });
        return offerDetailDisclaimerTemplate;
    }
    getCMSOfferData(offerId, configObj) {
        const storeId = this._userInfoService.getShopStoreId();
        let apiUrl = `${this.config[this.currentEnv].offerDetailAPIDetails['upcsByOfferIds']}?storeId=${storeId}&offerId=${offerId}`;
        if (configObj && configObj.bannerDomain) {
            apiUrl = configObj.bannerDomain + apiUrl;
        }
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_APP_ID": "emjou",
            "X-SWY-BANNER": "safeway",
            "X-SWY_VERSION": "1.0"
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.get(apiUrl, httpOptions).pipe(map((data) => {
            this._commonService.upcs.next(this.transformData(data));
            return data;
        }), catchError((error) => {
            this._commonService.upcs.next([]);
            return of({});
        }));
    }
    getOfferDetailsDataPzn(offerId, storeId, includeUpc, source) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        let apiUrl = `${host}${this.config[this.currentEnv].offerDetailAPIDetails['offerDetailsPzn']}?storeId=${storeId}&offerId=${offerId}&includeUpc=y&source=${source}`;
        // let apiUrl = `https://www-qa1.safeway.com/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail?storeId=${storeId}&offerId=${offerId}&includeUpc=${includeUpc ? 'y' : 'n'}&source=${source}`;
        // let apiUrl = 'https://www-qa1.safeway.com/abs/qapub/dce/offergallery/J4UProgram1/services/gallery/offer/detail?storeId=2856&offerId=2485000973242024010320241231&includeUpc=y&source=cms';
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emju",
            "X-SWY_VERSION": "3.0",
            "Ocp-Apim-Subscription-Key": "xyz"
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.get(apiUrl, httpOptions).pipe(map((data) => {
            if (data && data['upcList']) {
                this._commonService.upcs.next(data['upcList']);
            }
            else {
                this._commonService.upcs.next([]);
            }
            return data;
        }), catchError((error) => {
            this._commonService.upcs.next([]);
            return of({});
        }));
    }
    transformData(data) {
        return data['offerUPCList'].map((a) => a.upcList).join().split(',');
    }
    addToList(payloadData) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        const storeId = this._userInfoService.getShopStoreId();
        let apiUrl = host + this.config[this.currentEnv].j4uAPIDetails.clipPath + "?storeId=" + storeId;
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "2.0",
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['SWY_sso_token'] = `${this._userInfoService.getSWY_SHOP_TOKEN()}`;
            httpHeaders['Swyconsumerdirectorypro'] = `${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(apiUrl, payloadData, httpOptions).pipe(map((data) => data));
    }
    removeFromList(payloadData) {
        let host = this.config[this.currentEnv].baseURL;
        host = host.replace('{banner}', this._userInfoService.getBanner());
        const storeId = this._userInfoService.getShopStoreId();
        let apiUrl = host + this.config[this.currentEnv].j4uAPIDetails.unclipPath;
        const httpHeaders = {
            "Content-Type": "application/json;charset=utf-8",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "1.2",
            "X-SWY_BANNER": "safeway"
        };
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(apiUrl, payloadData, httpOptions).pipe(map((data) => data));
    }
    static { this.ɵfac = function OfferDetailService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OfferDetailService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(UtilService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OfferDetailService, factory: OfferDetailService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OfferDetailService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: UserInfoService }, { type: i1.HttpClient }, { type: UtilService }, { type: AemService }], null); })();

/*
@file-overview

- This service was brougth over from AEM wcax-commons repo

- This service contains methods using by coupon-list component

*/
/**
 * Coupon List Service
 *
 */
class CouponListService {
    constructor(_http, _userInfoService, _aemService, _commonService) {
        this._http = _http;
        this._userInfoService = _userInfoService;
        this._aemService = _aemService;
        this._commonService = _commonService;
        this._config = EnviormentConfig;
        this.currentEnv = '';
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }
    /**
     * Get numbers of completed offers.
     *
     * @param {CouponModel[]} coupons
     * @param {ProductModel[]} product
     */
    getTotalOffersCompleted(coupons, product) {
        let count = 0;
        coupons.forEach(c => {
            if (c.status === 'C' && c.offerComplete == true || c.isClippable === false && c.offerComplete == true) {
                count++;
            }
        });
        if (product.offerComplete == true) {
            count++;
        }
        return count;
    }
    getOffersByUpc(upc) {
        const storeId = this._userInfoService.getShopStoreId();
        const body = [upc];
        const httpHeaders = {
            "Content-Type": "application/json",
            "X-SWY-APPLICATION-TYPE": "web",
            "X-SWY_API_KEY": "emjou",
            "X-SWY_VERSION": "3.0"
        };
        let offersByUpcUrl = this._config[this.currentEnv].baseURL.replace('{banner}', this._userInfoService.getBanner());
        offersByUpcUrl += this._config[this.currentEnv].offerDetailAPIDetails.offersByUpcPath + "?storeId=" + storeId + '&offerPgm=CC-PD';
        if (this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        let httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        return this._http.post(offersByUpcUrl, body, httpOptions).pipe(catchError((error) => {
            return throwError(new Error('Error in getting offers by upc'));
        }));
    }
    static { this.ɵfac = function CouponListService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CouponListService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(AemService), i0.ɵɵinject(CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CouponListService, factory: CouponListService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CouponListService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: UserInfoService }, { type: AemService }, { type: CommonService }], null); })();

const UOM_ABBREVIATIONS = {
    ea: 'Each',
    oz: 'Ounce',
    fz: 'Fluid Ounce',
    lb: 'Pound',
    ct: 'Count',
    ml: 'Milliliter',
    lt: 'Liter',
    in: 'Inch',
    ga: 'Gallon',
    pt: 'Pint',
    qt: 'Quart',
    pr: 'Pair',
    gr: 'Grams',
    st: 'Stem',
    rl: 'Roll',
    hg: 'Half gallon',
    pk: 'Pack',
    pc: 'Piece',
    sf: 'Square Feet',
    cf: 'Cubic Feet',
    yd: 'Yards',
    dz: 'Dozen',
    bg: 'Bag',
    ft: 'Feet',
    bu: 'Bunch',
    kg: 'Kilograms',
    fl: 'Fluid Ounce',
    bx: 'Box',
    ca: 'Centare',
    ci: 'Cigar',
    mr: 'Meter',
    cg: 'Cigarettes',
    cl: 'Centiliter',
    bl: 'Barrell',
    sh: 'Sheets',
    g: 'Grams',
    mg: 'Milligrams',
    mcg: 'Micrograms',
    cal: 'Calories',
    kcal: 'Kilocalories',
    floz: 'fluid ounces',
};

/*
 *
 * Product Util Service
 *
*/
// Window global declaration
function _window() {
    return window;
}
;
class ProductUtilService {
    constructor(aemService) {
        this.aemService = aemService;
    }
    getProductDisplayableElementsByProgramType(programType) {
        const objFeaturesByProgramType = {
            mkp: {
                estimateLabel: false,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: false,
                promoText: true,
                snapEligible: false
            },
            wineshop: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: false
            },
            abs: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: true
            },
            'bia-category-carousel': {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: true
            },
            '1P_B2B': {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible: false
            },
            '1P_B2B_bia-category-carousel': {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible: false
            },
            weeklyAd: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible: false
            },
            'wine-carousel': {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: false,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: false,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: false
            },
            'mkp-carousel': {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: true,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: false,
                promoText: true,
                snapEligible: false
            },
            'light-weight': {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: false,
                nestedFulfillment: false,
                promoText: false,
                snapEligible: false
            },
            '1P_SNS': {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: false,
                coupons: true,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: true
            },
            'light-weight-sponsored': {
                estimateLabel: false,
                sponsoredLabel: true,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: false,
                nestedFulfillment: false,
                promoText: false,
                snapEligible: false
            },
            dnf: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible: true
            }
        };
        return programType ? objFeaturesByProgramType[programType] : objFeaturesByProgramType['abs'];
    }
    /**
   * Get Banner Domain Url
   *
   * @returns bannerDomain
   */
    getBannerDomainUrl(configObj) {
        const { banner } = window['AB']['userInfo'];
        if (configObj?.bannerDomain) {
            return configObj?.bannerDomain?.replace('${banner}', banner);
        }
        return '';
    }
    formatTime24to12(time) {
        const [hour, minute] = time.split(':').map(Number);
        const period = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
        const formattedMinute = minute === 0 ? '' : `:${minute.toString().padStart(2, '0')}`;
        return `${formattedHour}${formattedMinute} ${period}`;
    }
    getAvailabilityTimes(availabilityTimes) {
        const weekdayTimes = {
            start: availabilityTimes?.fulfillmentStartTime,
            end: availabilityTimes?.fulfillmentEndTime
        };
        const weekendTimes = {
            Saturday: { start: availabilityTimes?.fulfillmentStartTimeSaturday, end: availabilityTimes?.fulfillmentEndTimeSaturday },
            Sunday: { start: availabilityTimes?.fulfillmentStartTimeSunday, end: availabilityTimes?.fulfillmentEndTimeSunday }
        };
        const today = new Date().toLocaleString('en-US', { weekday: 'long' });
        let startTime, endTime;
        if (today === 'Saturday' || today === 'Sunday') {
            startTime = weekendTimes[today]?.start;
            endTime = weekendTimes[today]?.end;
        }
        else {
            startTime = weekdayTimes?.start;
            endTime = weekdayTimes?.end;
        }
        if (!startTime || !endTime || (startTime === '00:00' && endTime === '00:00')) {
            return '';
        }
        const formattedStartTime = startTime === '00:00' ? 'Before' : this.formatTime24to12(startTime);
        const formattedEndTime = endTime === '23:59' ? 'After' : this.formatTime24to12(endTime);
        if (startTime === '00:00') {
            return `${formattedStartTime} ${formattedEndTime} only`;
        }
        else if (endTime === '23:59') {
            return `${formattedEndTime} ${formattedStartTime} only`;
        }
        else {
            return `${formattedStartTime}–${formattedEndTime} only`;
        }
    }
    /**
    * This method will return product tags for size, packageqty, preptime and snap for product cards
    * and carosel cards
    * @param product
    * @param displayableElements
    * @param isCarousel
    * @returns array of product size tags
    */
    productTagElements(product, displayableElements, isCarousel) {
        const pcTags = [];
        const { dispItemPackageQty, dispItemPackageUOM, dispItemSizeQty, dispUnitOfMeasure, isMtoProduct, mtoTagText, mtoDisplyableTime, snapEligible, fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday, fulfillmentStartTimeSunday, fulfillmentEndTimeSunday } = product;
        // Package quantity tag
        if (dispItemPackageQty > 1) {
            pcTags.push({
                type: 'packageqty',
                displayableText: `${dispItemPackageQty} ${dispItemPackageUOM ? dispItemPackageUOM.toLocaleLowerCase() : 'ct'}`,
                srOnlyText: `${dispItemPackageQty} count`,
                qaAttribute: 'prd-itm-pqty',
            });
        }
        // Size quantity tag
        if (dispItemSizeQty > 0 && dispUnitOfMeasure) {
            const uom = UOM_ABBREVIATIONS[dispUnitOfMeasure.replace(' ', '').toLocaleLowerCase()];
            pcTags.push({
                type: 'sqty',
                displayableText: `${parseFloat(dispItemSizeQty.toString())} ${dispUnitOfMeasure.toLocaleLowerCase()}`,
                srOnlyText: `${parseFloat(dispItemSizeQty.toString())} ${uom}`,
                qaAttribute: 'prd-itm-sqty',
            });
        }
        // MTO tag
        if (displayableElements?.mto && isMtoProduct && mtoTagText) {
            pcTags.push({
                type: 'mto',
                displayableText: `${mtoTagText} prep`,
                srOnlyText: `${mtoDisplyableTime} preparation time`,
                qaAttribute: 'qty-stppr-mto',
            });
        }
        //Availability tag
        const flagName = isCarousel ? 'isCarouselAvailabilityTagDisabled' : 'isGridAvailabilityTagDisabled';
        if (!this.aemService.getFeatureFlagByNameDisable(flagName)) {
            const availabilityText = this.getAvailabilityTimes({ fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday, fulfillmentStartTimeSunday, fulfillmentEndTimeSunday });
            if (availabilityText) {
                pcTags.push({
                    type: 'availability',
                    displayableText: availabilityText,
                    srOnlyText: `Available ${availabilityText.replace("–", " to ")}`,
                    qaAttribute: 'prd-itm-availability',
                });
            }
        }
        // SNAP tag
        if (displayableElements?.snapEligible && snapEligible && !isCarousel) {
            pcTags.push({
                type: 'snap',
                displayableText: 'SNAP',
                qaAttribute: 'prd-itm-snap',
            });
        }
        return isCarousel ? pcTags.slice(0, 2) : pcTags.slice(0, 3);
    }
    static { this.ɵfac = function ProductUtilService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductUtilService)(i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductUtilService, factory: ProductUtilService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductUtilService, [{
        type: Injectable
    }], () => [{ type: AemService }], null); })();

class ArService {
    constructor(_http, _userInfoService, _commonService, _aemService, _utilService) {
        this._http = _http;
        this._userInfoService = _userInfoService;
        this._commonService = _commonService;
        this._aemService = _aemService;
        this._utilService = _utilService;
        this.arSubscriptionList = {
            isLoaded: false,
            isCheckboxFirstTimeChecked: false,
            showHeaderTooltip: false
        };
        this.isArEnable = false;
        this.subscription = new Subscription();
        this.currentEnv = '';
        this.snsApiBasepath = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arauthorize.basepath'] : '';
        this.snsApiSubKey = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.subkey'] : '';
        this.snsApi = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.all.endpoint'] : '';
        this.snsApiSubKeyHeader = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.subkeyHeader'] : '';
        this.snsApiContentTypeHeader = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['sns.arservice.apim.contentTypeHeader'] : '';
        this.httpOptions = {
            headers: new HttpHeaders({}),
        };
        this.currentEnv = this._commonService.getCurrentEnviorment();
        if (this._aemService.isArFlagLoaded()) {
            this.isArEnable = this._aemService.getArFlag()?.display;
            if (this.isArEnable) {
                this.getSubscriptionsInfo();
            }
            else {
                this._commonService.arSubscriptions.next({});
            }
        }
        else {
            this.subscription.add(fromEvent(document, 'arFlagLoaded').subscribe(event => {
                const objArFlag = event && event['detail'] && event['detail']['arFlag'];
                if (objArFlag) {
                    this.isArEnable = objArFlag['display'];
                }
                if (this.isArEnable) {
                    this.getSubscriptionsInfo();
                }
                else {
                    this._commonService.arSubscriptions.next({});
                }
            }));
        }
    }
    getArSubscriptions() {
        return this.arSubscriptionList;
    }
    getKeyValuePairSubs(subscriptions) {
        const productSubsMap = {};
        for (let i in subscriptions) {
            productSubsMap[subscriptions[i].productId ? subscriptions[i].productId : subscriptions[i].productBpn] = subscriptions[i];
        }
        return productSubsMap;
    }
    setArSubscription(data) {
        if (data != null && typeof data == 'object') {
            this.arSubscriptionList['arSavedTime'] = this.getArSavedTime();
            this.arSubscriptionList['isLoaded'] = true;
            this.arSubscriptionList['isCheckboxFirstTimeChecked'] = false;
            // subscribe to the last value of the boolean to show the header tooltip
            this._commonService.showHeaderTooltip.subscribe((value) => {
                if (value == true) {
                    this.arSubscriptionList['showHeaderTooltip'] = true;
                }
                else {
                    this.arSubscriptionList['showHeaderTooltip'] = false;
                }
            });
            this.arSubscriptionList['customerId'] = data.customerId ? data.customerId : data.customerUUID;
            this.arSubscriptionList['fulfillmentType'] = data.fulfillmentType;
            this.arSubscriptionList['subscribedItems'] = this.getKeyValuePairSubs(data.subscribedItems ? data.subscribedItems : data.itemsSubscribed);
            if (data.hasOwnProperty('snsFrequencies')) {
                this.arSubscriptionList['snsFrequencies'] = data.snsFrequencies;
            }
            if (data.hasOwnProperty('isNewSnSUser')) {
                this.arSubscriptionList['isNewSnSUser'] = data.isNewSnSUser;
            }
            if (data.hasOwnProperty('fulfillment')) {
                this.arSubscriptionList['fulfillment'] = data.fulfillment;
            }
            this._setSubscriptionsToLS(this.arSubscriptionList);
            this._commonService.arSubscriptions.next(this.arSubscriptionList);
        }
        else {
            this._commonService.arSubscriptions.next({});
        }
    }
    ;
    /**
   * This method will return the AR Saved Time value in Milliseconds.
   * **/
    getArSavedTime() {
        const dateInMs = Date.now();
        return dateInMs + 900000;
    }
    fetchArSubscriptions() {
        const custid = this._userInfoService.getUUID();
        const builtHeaders = { ...this.httpOptions };
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiSubKeyHeader, this.snsApiSubKey);
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiContentTypeHeader, 'application/vnd.safeway.v1+json');
        builtHeaders.headers = builtHeaders.headers.set('x-swy-correlation-id', this._userInfoService.getUUID());
        builtHeaders.headers = builtHeaders.headers.set('Authorization', `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-banner', this._userInfoService.getBanner());
        builtHeaders.headers = builtHeaders.headers.set('x-swy-client-name', 'safeway');
        if (custid && this.isArEnable) {
            let apiUrl = `${this.snsApiBasepath}${this.snsApi}${this._userInfoService.getUUID()}/allsubscriptions?banner=${this._userInfoService.getBanner()}`;
            this._http
                .get(apiUrl, builtHeaders)
                .subscribe(data => {
                this.setArSubscription(data);
            }, (err) => {
                this.setArSubscription(null);
            });
        }
    }
    _setSubscriptionsToLS(obj) {
        if (this._utilService.isLSCompatible()) {
            const subsKey = 'abNgSubscriptions';
            localStorage.setItem(subsKey, JSON.stringify(obj));
        }
    }
    // Method that will check whether to get AR subscriptions from the Subscriptions API or use it from local storage if it exists
    getSubscriptionsInfo() {
        if (this._commonService._hasLSArSubscriptions()) {
            const subsKey = 'abNgSubscriptions';
            let obj = localStorage.getItem(subsKey);
            this._commonService.arSubscriptions.next(JSON.parse(obj));
        }
        else {
            this.fetchArSubscriptions();
        }
    }
    buildAndPostAddSubscription(modalPayload) {
        let payload = {};
        let apiUrl = '';
        const builtHeaders = { ...this.httpOptions };
        builtHeaders.headers = builtHeaders.headers.set('x-swy-banner', this._userInfoService.getBanner());
        builtHeaders.headers = builtHeaders.headers.set('Accept', 'application/vnd.safeway.v1+json');
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiContentTypeHeader, 'application/json');
        builtHeaders.headers = builtHeaders.headers.set(this.snsApiSubKeyHeader, this.snsApiSubKey);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-client-name', 'WEB-PORTAL');
        builtHeaders.headers = builtHeaders.headers.set('subscriptionSource', modalPayload.subscriptionSource.toLowerCase() == 'pdp' ? 'pdp' : 'productcard');
        builtHeaders.headers = builtHeaders.headers.set('Authorization', `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`);
        builtHeaders.headers = builtHeaders.headers.set('x-swy-correlation-id', this._userInfoService.getUUID());
        builtHeaders.headers = builtHeaders.headers.set('x-swy-date', new Date().toUTCString());
        payload = {
            "isNewSnSUser": false,
            "originationStoreId": this._userInfoService.getShopStoreId(),
            "subscriptionItems": [
                {
                    "productBpn": modalPayload.bpn,
                    "productUpc": modalPayload.upc,
                    "quantity": Number(modalPayload.quantity),
                    "startDateTime": modalPayload.startDate,
                    "isSubstitutable": true,
                    productDesc: modalPayload?.productTitle,
                    originalPrice: modalPayload?.originalPrice?.toString(),
                    "frequency": {
                        "count": Number(modalPayload.frequency),
                        "unit": "WEEK"
                    }
                }
            ]
        };
        apiUrl = `${this.snsApiBasepath}${this.snsApi}${this._userInfoService.getUUID()}/addsubscription`;
        return this._http.post(apiUrl, payload, builtHeaders);
    }
    getStaticFrequencyList() {
        return [
            {
                "unit": "WEEK",
                "count": 1,
                "isDefault": true,
                "displayFrequency": "week"
            }
        ];
    }
    static { this.ɵfac = function ArService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ArService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(CommonService), i0.ɵɵinject(AemService), i0.ɵɵinject(UtilService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ArService, factory: ArService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: UserInfoService }, { type: CommonService }, { type: AemService }, { type: UtilService }], null); })();

/**
 * Angular App Config Service.
 *
 * @file Main Angular's application service provider.
 */
class AppConfigService {
    setConfig(config) {
        this._config = { ...config };
    }
    isDesignMode() {
        return (this._config && this._config.consumer === "themedesigner");
    }
    constructor() {
    }
    static { this.ɵfac = function AppConfigService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppConfigService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AppConfigService, factory: AppConfigService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppConfigService, [{
        type: Injectable
    }], () => [], null); })();

class BoxtopService {
    constructor(_http, _userInfoService, _commonService, _aemService) {
        this._http = _http;
        this._userInfoService = _userInfoService;
        this._commonService = _commonService;
        this._aemService = _aemService;
        this.config = EnviormentConfig;
        this.currentEnv = '';
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }
    getGeneralMillsId() {
        const httpOptions = { headers: new HttpHeaders(this.getPreUcaHttpOptions()) };
        let loyaltyPartnersPath = this._aemService.getLoyaltyPartnersPath();
        const customerId = this._userInfoService.getCustomerId() ? this._userInfoService.getCustomerId() : '1';
        loyaltyPartnersPath?.replace('{customerId}', customerId);
        return this._http.get(loyaltyPartnersPath, httpOptions);
    }
    getPreUcaHttpOptions() {
        var currentTime = new Date();
        const cncSubscriptionKey = this.config[this.currentEnv]?.datapowerConfig?.cncSubscriptionKey;
        return {
            'Accept': 'application/vnd.safeway.v1+json',
            'X-SWY_BANNER': this._userInfoService.getBanner(),
            'Ocp-Apim-Subscription-Key': cncSubscriptionKey,
            'Content-Type': 'application/vnd.safeway.v1+json',
            'x-swy-client-id': 'web-portal',
            'x-swy-correlation-id': this._commonService.generateUUID(),
            'x-swy-date': currentTime.toString(),
            'Cache-Control': 'no-cache'
        };
    }
    static { this.ɵfac = function BoxtopService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BoxtopService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(CommonService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BoxtopService, factory: BoxtopService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BoxtopService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: UserInfoService }, { type: CommonService }, { type: AemService }], null); })();

class ProductFilterService {
    constructor(_http, _aemService, _userInfoService, _commonService) {
        this._http = _http;
        this._aemService = _aemService;
        this._userInfoService = _userInfoService;
        this._commonService = _commonService;
        this.departmentSource = new BehaviorSubject([]);
        this.currentDepartment = this.departmentSource.asObservable();
        this.brandSource = new BehaviorSubject([]);
        this.currentBrand = this.brandSource.asObservable();
        this.filterAisleParamSource = new BehaviorSubject('');
        this.currentFilterAisle = this.filterAisleParamSource.asObservable();
        this.filterBrandParamSource = new BehaviorSubject('');
        this.currentFilterBrand = this.filterBrandParamSource.asObservable();
        this._departments = [];
        this._brands = [];
        this._dealsCurrentFilter = new BehaviorSubject(null);
        this.dealsCurrentFilter$ = this._dealsCurrentFilter.asObservable();
        this.objDeals = {
            isDeals: '',
            apiKey: ''
        };
        this.config = EnviormentConfig;
        this.currentEnv = '';
    }
    addDepartment(value) {
        let queryString = encodeURIComponent(value);
        let isValid = this.isExist(this._departments, queryString);
        if (isValid.length == 0) {
            var objValue = { 'query': queryString, 'text': value };
            this._departments.push(objValue);
            this.departmentSource.next(this._departments);
        }
    }
    addBrand(brand) {
        var queryString = encodeURIComponent(brand);
        var isValid = this.isExist(this._brands, queryString);
        if (isValid.length == 0) {
            var objValue = { 'query': queryString, 'text': brand };
            this._brands.push(objValue);
            this.brandSource.next(this._brands);
        }
    }
    isExist(arr, value) {
        return arr.filter(function (objValue) {
            return objValue.query.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
    }
    addFilterAisleParam(param) {
        this.filterAisleParamSource.next(param);
    }
    addFilterBrandParam(param) {
        this.filterBrandParamSource.next(param);
    }
    /**
     * Get departments from AEM servlet
     *
     * @param pageType returns (bogo or rewardcard) or (c-bogo or c-club-card)
     */
    getDealsDepartments() {
        this.currentEnv = this._commonService.getCurrentEnviorment();
        if (this.objDeals.isDeals == 'c-bogo' || this.objDeals.isDeals == 'c-club-card') {
            let httpOptions = {
                headers: new HttpHeaders({
                    'ocp-apim-subscription-key': this._aemService.getApimSubscriptionKey()
                })
            };
            let url = this.config[this.currentEnv].catalogConfig['apim.api.catalog.path'] +
                this.config[this.currentEnv].catalogConfig['apim.api.catalog.departments.endpoint'] + '?key=' + this.objDeals.apiKey + '&storeId=' + this._userInfoService.getShopStoreId();
            return this._http.get(url, httpOptions);
        }
        else {
            let url = this._aemService.getDealsFilter() + '?key=' + this._aemService.getProductGridPage() + '&storeId=' + this._userInfoService.getShopStoreId();
            return this._http.get(url);
        }
    }
    /**
     * Emit current filter from 'aisle' param.
     *
     * @param {string} filterName
     */
    setCurrentFilterDeals(filterName) {
        if (filterName) {
            filterName = filterName.replace(/& |,/g, '').replace(/ /g, '-');
            this._dealsCurrentFilter.next(filterName);
        }
    }
    static { this.ɵfac = function ProductFilterService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductFilterService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AemService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductFilterService, factory: ProductFilterService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductFilterService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: AemService }, { type: UserInfoService }, { type: CommonService }], null); })();

class IntersectionObserverService {
    constructor(utilService, _aemService) {
        this.utilService = utilService;
        this._aemService = _aemService;
        this.trackedImpressions = [];
    }
    /**
     *
     * @param ele element to be observed
     * @param product optional parameter for product/banner data
     */
    createObserver(ele, product, products, callback) {
        if (['product-item-al-v1', 'product-carousel-item-al-v1', 'product-item-al-v2', 'product-carousel-item-al-v2'].includes(ele.nodeName.toLowerCase())) {
            // Configuration passed to handle intersection
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // Handle intersection when 50% of product/banner is visible
            };
            let intObs;
            // Observes selector for impression ad tracking
            intObs = new IntersectionObserver((entries) => this.handlePCintersect(entries, product, ele, intObs), options);
            intObs.observe(ele);
        }
        else if (['product-carousel-al-v1'].includes(ele.nodeName.toLowerCase())) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // Handle intersection when 50% of product/banner is visible
            };
            let intObs;
            intObs = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting)
                        callback(ele, products);
                });
            }, options);
            // Observe the inner carousel, not the product-carousel-al-v1 directive.
            intObs.observe(ele.children[0]);
        }
    }
    handlePCintersect(entries, entity, ele, observer) {
        // check for triggering Pacement Beacon once
        let hasFeatureProduct = false;
        entries.forEach(entry => {
            const productTracking = entity['adId'] || entity['eventTracking'];
            if (entry.isIntersecting && productTracking &&
                this.isImpressionTacked(productTracking) &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {
                if (['product-item-al-v1', 'product-carousel-item-al-v1', 'product-item-al-v2', 'product-carousel-item-al-v2'].includes(ele.nodeName.toLowerCase())) {
                    window['citrusAdTracker'](productTracking, 'AD_IMPRESSION');
                    hasFeatureProduct = entity.featured && entity.placementBeacons;
                    console.warn('productCard', 'AD_IMPRESSION', productTracking);
                }
                this.trackedImpressions.push(productTracking);
                observer.unobserve(ele);
            }
        });
        // for triggering impression Placement Beacon
        if (!this._aemService.getFeatureFlagByNameDisable('isUniversalBeaconsDisabled') && hasFeatureProduct && this.trackedImpressions.length < 2) {
            const placementBeacons = entity.placementBeacons;
            window['citrusAdTracker']({
                beacons: placementBeacons
            }, 'AD_IMPRESSION_PLACEMENT');
        }
    }
    /**
     *
     * @param productTracking can be ad ID or event tracking object as per V3 / new structure
     * Checks if impressions are already tracked for given adId/eventracking object
     */
    isImpressionTacked(productTracking) {
        return !this.trackedImpressions.includes(productTracking) ||
            (typeof productTracking === 'object' && this.utilService.nativeFind(this.trackedImpressions, productTracking) === undefined ? true : false);
    }
    static { this.ɵfac = function IntersectionObserverService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntersectionObserverService)(i0.ɵɵinject(UtilService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IntersectionObserverService, factory: IntersectionObserverService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntersectionObserverService, [{
        type: Injectable
    }], () => [{ type: UtilService }, { type: AemService }], null); })();

/**
 * Sort Service
 */
class SortAlV1Service {
    initRules() {
        let results;
        results = {
            'a-z': {
                field: 'name',
                rule: [{ field: 'name', direction: -1, type: 'string' }],
                label: 'Alphabetical A - Z',
                sort_at: 'client'
            },
            'a-z-description': {
                field: 'description',
                rule: [{ field: 'description', direction: -1, type: 'string' }],
                label: 'Alphabetically',
                sort_at: 'client'
            },
            'z-a': {
                field: 'name',
                rule: [{ field: 'name', direction: -1, type: 'string' }],
                label: 'Alphabetical Z - A',
                sort_at: 'client'
            },
            'search-rank': {
                field: 'searchRank',
                rule: [
                    { field: 'searchRank', direction: -1, type: 'number' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Search Ranking',
                sort_at: 'client'
            },
            'most-popular': {
                field: 'salesRank',
                rule: [
                    { field: 'salesRank', direction: 1, type: 'number' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Most Popular',
                sort_at: 'client'
            },
            'price-low-high': {
                field: 'price',
                rule: [
                    { field: 'price', direction: 1, type: 'number' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Price - Low to High',
                sort_at: 'client'
            },
            'purchase-history': {
                field: 'purchaseRank',
                rule: [
                    { field: 'purchaseRank', direction: -1, type: 'string' }
                ],
                label: 'Purchase History',
                sort_at: 'client'
            },
            'new-offers': {
                field: 'arrivalRank',
                rule: [
                    { field: 'arrivalRank', direction: 1, type: 'string' }
                ],
                label: 'New Offers',
                sort_at: 'client'
            },
            'about-to-expire': {
                field: 'expiryRank',
                rule: [
                    { field: 'expiryRank', direction: 1, type: 'string' }
                ],
                label: 'About to Expire',
                sort_at: 'client'
            },
            'category': {
                field: 'categoryId',
                rule: [
                    { field: 'categoryId', direction: 1, type: 'string' }
                ],
                label: 'Category',
                sort_at: 'client'
            },
            'expiry-date': {
                field: 'endDate',
                rule: [
                    { field: 'endDate', direction: 1, type: 'string' }
                ],
                label: 'Expiry Date',
                sort_at: 'client'
            },
            'added-date': {
                field: 'addedDate',
                rule: [
                    { field: 'addedDate', direction: 1, type: 'string' }
                ],
                label: 'Added Date',
                sort_at: 'client'
            },
            'reward-card-specials': {
                field: 'promoDescription',
                rule: [
                    {
                        field: 'promoDescription',
                        direction: -1,
                        type: 'custom',
                        callback: (tempA, sort) => {
                            if (this.isPromoMatch(tempA[sort.field])) {
                                return 'AAA';
                            }
                            else {
                                return 'ZZZ';
                            }
                        }
                    },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: this._commonService.getPromoDescription(),
                sort_at: 'client'
            },
            aisles: {
                // dummy, needs to be here for now for backwards compatibility
                field: 'groupByTemplate',
                rule: [],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_departmentName: {
                field: 'departmentName',
                rule: [
                    { field: 'departmentName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_aisleName: {
                field: 'aisleName',
                rule: [
                    { field: 'aisleName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            aisles_shelfName: {
                field: 'shelfName',
                rule: [
                    { field: 'shelfName', direction: -1, type: 'string' },
                    { field: 'name', direction: -1, type: 'string' }
                ],
                label: 'Aisles',
                sort_at: 'client'
            },
            'bloomreach-top-sellers': {
                field: 'salesRank+asc',
                rule: null,
                label: 'Top sellers',
                sort_at: 'server'
            },
            'bloomreach-price-low-high': {
                field: 'price+asc',
                rule: null,
                label: 'Price low to high',
                sort_at: 'server'
            },
            'bloomreach-best-match': {
                field: '',
                rule: null,
                label: 'Best Match',
                sort_at: 'server'
            },
            'bloomreach-club-card': {
                field: 'promoType+asc',
                rule: null,
                label: this._commonService.getPromoDescription(),
                sort_at: 'server'
            },
            aisles_coupons: {
                // dummy, needs to be here for now for backwards compatibility
                field: 'purchaseInd',
                rule: [{ field: 'purchaseInd', direction: -1, type: 'string' }],
                label: 'Type of Coupons',
                sort_at: 'client'
            },
            FREQUENCY: {
                field: 'FREQUENCY',
                rule: null,
                label: 'Frequently Purchased',
                sort_at: 'server'
            },
            PURCHASE_DATE: {
                field: 'PURCHASE_DATE',
                rule: null,
                label: 'Purchase Date',
                sort_at: 'server'
            },
            RECOMMENDED: {
                field: 'RECOMMENDED',
                rule: null,
                label: 'Recommended',
                sort_at: 'server'
            },
            RECENTLY_PURCHASED: {
                field: 'PURCHASE_DATE',
                rule: null,
                label: 'Recently Purchased',
                sort_at: 'server'
            }
        };
        return results;
    }
    isPromoMatch(label) {
        const promoRules = this._commonService.getPromorulesArray();
        if (!promoRules || promoRules.length === 0) {
            return false;
        }
        let found = false;
        promoRules.forEach(function (promoRule) {
            if (label && label.length > 0) {
                if (label.match(promoRule['rule'])) {
                    found = true;
                }
            }
        });
        return found;
    }
    constructor(_commonService) {
        this._commonService = _commonService;
        this.sorts = new Array();
        this.rules = this.initRules();
        this.available = window['AB']['availableSorts'] || [];
        if (this.hasSort()) {
            this.generate();
        }
    }
    setAvailableSort(sort) {
        this.available = sort;
    }
    getDefaultSort() {
        if (this.default) {
            return this.default;
        }
        if (this.available.filter(rule => rule === 'a-z').length > 0) {
            this.default = this.getSortByName('a-z');
        }
        else {
            this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName('a-z');
        }
        return this.default;
    }
    getDefaultSortForConfigurableSort(defaultRule) {
        if (this.available.filter(rule => rule === defaultRule).length > 0) {
            this.default = this.getSortByName(defaultRule);
        }
        else {
            this.default = this.available[0] ? this.getSortByName(this.available[0]) : this.getSortByName(defaultRule);
        }
        return this.default;
    }
    hasSort() {
        return !!this.available.length;
    }
    getSortByName(name) {
        return this.rules[name];
    }
    /**
    * Given a comma-delimited string of sort names, return the collection of SortModels
    */
    getSortOptions(sortValues) {
        let sortOptions = [];
        if (sortValues) {
            // Break up the comma-delimited collection into an array
            let valueCollection = sortValues.split(',');
            // Iterate over each specified sort name, looking it up in the collection of rule and
            // if found, append it to the returned SortModel collection
            valueCollection.forEach((sortName, index) => {
                const sortRule = this.getSortByName(sortName.trim());
                if (sortRule)
                    sortOptions.push(new SortModel(sortRule));
            });
        }
        return sortOptions;
    }
    getDPGSortOptions(sortValues) {
        const sortOptions = [];
        if (sortValues) {
            sortValues.forEach((sort) => {
                const sortRule = {
                    field: sort.attribute,
                    rule: null,
                    label: sort.name,
                    sort_at: 'server',
                    selected: sort?.defaultValue
                };
                if (sortRule) {
                    sortOptions.push(new SortModel(sortRule));
                }
            });
        }
        return sortOptions;
    }
    getSorts() {
        return this.sorts;
    }
    sort(sort, data) {
        const sortByCriteria = sort && sort.rule ? sort.rule.map(rule => {
            return (a) => {
                const tempA = Object.assign({}, a);
                if (rule.type === 'string') {
                    if (tempA && tempA[rule.field]) {
                        tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
                    }
                }
                if (rule.type === 'number') {
                    tempA[rule.field] = parseFloat(tempA[rule.field]);
                }
                if (rule.type === 'custom') {
                    return rule.callback.call(this, tempA, sort);
                }
                return tempA[rule.field];
            };
        }) : '';
        const sortByDirection = sort && sort.rule ? sort.rule.map(rule => {
            if (rule.direction === 1) {
                return 'asc';
            }
            return 'desc';
        }) : '';
        return _.sortBy(data, sortByCriteria, sortByDirection);
    }
    couponsSort(sort, data) {
        const sortByCriteria = sort.rule.map(rule => {
            return (a) => {
                const tempA = Object.assign({}, a);
                if (rule.type === 'string') {
                    if (tempA && tempA[rule.field]) {
                        tempA[rule.field] = tempA[rule.field].toString().toLowerCase();
                    }
                }
                if (rule.type === 'number') {
                    tempA[rule.field] = parseFloat(tempA[rule.field]);
                }
                if (rule.type === 'custom') {
                    return rule.callback.call(this, tempA, sort);
                }
                return tempA[rule.field];
            };
        });
        const sortByDirection = sort.rule.map(rule => {
            if (rule.direction === 1) {
                return 'asc';
            }
            return 'desc';
        });
        return _.sortBy(data, sortByCriteria, sortByDirection);
    }
    generate() {
        if (this.available.length === 0) {
            return;
        }
        this.sorts = [];
        this.available.forEach((type, index) => {
            const rule = this.rules[type];
            if (!rule) {
                return;
            }
            /* overwrite with custom group by rule based on headerType setting */
            if (rule.field === 'groupByTemplate') {
                const groupByRuleKey = 'aisles' + '_' + window['AB']['headerType'];
                rule.rule = this.rules[groupByRuleKey] ? this.rules[groupByRuleKey].rule : '';
            }
            this.sorts.push(new SortModel(rule));
            if (this.default === undefined && type === window['AB']['defaultSort']) {
                this.default = rule;
            }
        });
    }
    static { this.ɵfac = function SortAlV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SortAlV1Service)(i0.ɵɵinject(CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SortAlV1Service, factory: SortAlV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortAlV1Service, [{
        type: Injectable
    }], () => [{ type: CommonService }], null); })();

class DatasScrollService {
    constructor() {
        this.onLoadFirstPage$ = new BehaviorSubject(1);
        this.pageNumber = 1;
        this.numberOfItems = 6;
        /**
         * Scroll event - Check if loading-spinner is in viewport
         */
        this.pageByScroll$ = fromEvent(window, 'scroll').pipe(map(() => window.scrollTo(0, 0)), filter(function (current) {
            let element = document.querySelector('loading-spinner');
            if (typeof current == 'number' && element && element instanceof HTMLElement) {
                return current >= (element.offsetTop - window.innerHeight);
            }
            else {
                return false;
            }
        }), distinct(), debounceTime(200), map(() => {
            // Should be keep separate like this, returning incremented value doesn't work properly with debounceTime
            this.pageNumber++;
            return this.pageNumber;
        }));
        this.pageToLoad$ = merge(this.onLoadFirstPage$, this.pageByScroll$).pipe(distinct());
        this.backToTopScroll$ = fromEvent(window, 'scroll').pipe(debounceTime(500), map(() => window.scrollY));
    }
    getNumberOfItems() {
        return this.numberOfItems;
    }
    static { this.ɵfac = function DatasScrollService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatasScrollService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DatasScrollService, factory: DatasScrollService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatasScrollService, [{
        type: Injectable
    }], () => [], null); })();

class LoaderService {
    constructor() {
        this.loaderSubject = new Subject();
        this.loaderState = this.loaderSubject.asObservable();
    }
    show() {
        this.loaderSubject.next({ show: true });
    }
    hide() {
        this.loaderSubject.next({ show: false });
    }
    static { this.ɵfac = function LoaderService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoaderService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoaderService, factory: LoaderService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaderService, [{
        type: Injectable
    }], () => [], null); })();

class J4uV1Service {
    constructor(_http, commonService, utilService, _userInfoService, aemService) {
        this._http = _http;
        this.commonService = commonService;
        this.utilService = utilService;
        this._userInfoService = _userInfoService;
        this.aemService = aemService;
        this.config = EnviormentConfig;
        this.currentEnv = '';
        this.GALLERY_API = '';
        this.SUBSCRIPTION_API = '';
        this.HTTP_OPTIONS = {};
        this.p13nApi = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window.location.origin + window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['p13n.loyaltyCarousel.basePath'] : '';
        this.additionalCouponsAmount = 10;
        this.objCoupons = {};
        this.instantEventName = window['AB']['COMMON'].getURLParameterByName("eventName");
        this.instantEventDateTime = window['AB']['COMMON'].getURLParameterByName("eventDateTime");
        this.instantCorrelationId = window['AB']['COMMON'].getURLParameterByName("eventCorrelationId");
        this.isDataCached = false;
        this.rewardProtoTypes = ['REWARDS_FLAT', 'REWARDS_ACCUMULATION'];
        this.instantAllocationReqBody = {};
        this.couponUpdated = new Subject();
        this.defaultModUnitImage = {
            src: null,
            alt: null,
            openNewTab: null,
            dataSrc: null,
            target: null
        };
        this.isBonusPathPage = false;
        this._companionGalleryOfferPOST = new Subject();
        this.listenCompanionGalleryOfferPOST$ = this._companionGalleryOfferPOST.asObservable();
        this.onCouponsAndDealsPageReload = false;
        // TODO: REMOVE WHEN WE NO LONGER NEED TO USE MOCK DATA
        this.isMockP13nCarouselDataEnabled = false;
        this.additionalResponseCount = 0;
        this.mockInitialResponse = [
            {
                "offerId": "44770823",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950273756",
                "description": "Postman $0.66 when you buy 1 Postman Any variety.",
                "startDate": "1645988400000",
                "endDate": "1735585200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
                "limits": "O",
                "name": "ALEN Pinalen",
                "brand": "ALEN Pinalen",
                "offerPgm": "MF",
                "offerPrice": "$0.96 OFF",
                "offerSubPgm": "09",
                "offerTs": "1668557706000",
                "purchaseInd": "L",
                "purchaseRank": "39",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "39",
                "expiryRank": "39",
                "companionOfferIds": [],
                "disclaimer": "Test Legal stuff goes here",
                "deleted": true,
                "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
                "extlOfferId": "22238-27024-20",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "48407035",
                "categoryType": "Personal Care & Health",
                "category": "Personal Care & Health",
                "clipTs": "1705950245604",
                "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
                "startDate": "1685728800000",
                "endDate": "1717178400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
                "limits": "O",
                "name": "Gillete",
                "brand": "Gillete",
                "offerPgm": "MF",
                "offerPrice": "$3.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1687542958000",
                "offerProgramType": "MUST_BUY",
                "offerProtoType": "MUST_BUY",
                "purchaseInd": "L",
                "purchaseRank": "48",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "48",
                "expiryRank": "48",
                "companionOfferIds": [],
                "disclaimer": "Legal Description",
                "deleted": true,
                "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
                "extlOfferId": "00123-47400-19",
                "hierarchies": {
                    "categories": [
                        "Personal Care & Health"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "49237635",
                "categoryType": "Dairy, Eggs & Cheese",
                "category": "Dairy, Eggs & Cheese",
                "clipTs": "1705950329002",
                "description": "P13N-BIA",
                "startDate": "1679940000000",
                "endDate": "1711908000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "O",
                "name": "Buy 1 Get 1",
                "brand": "Buy 1 Get 1",
                "offerPgm": "SC",
                "offerPrice": "Buy 1 Get 1",
                "offerSubPgm": "02",
                "offerTs": "1679958107000",
                "offerProgramType": "BUYX_GETX",
                "offerProtoType": "BUYX_GETX",
                "purchaseInd": "L",
                "purchaseRank": "18",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "18",
                "expiryRank": "18",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "49237635-D",
                "hierarchies": {
                    "categories": [
                        "Dairy, Eggs & Cheese",
                        "Frozen Foods"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "50043380",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950312700",
                "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free Pepsi Drink",
                "offerSubPgm": "09",
                "offerTs": "1656499966000",
                "purchaseInd": "L",
                "purchaseRank": "22",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "22",
                "expiryRank": "22",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-23322-03",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "50043586",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1705950277345",
                "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
                "startDate": "1654106400000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
                "limits": "O",
                "name": "Tostitos",
                "brand": "Tostitos",
                "offerPgm": "MF",
                "offerPrice": "Free Tostitos Salsa",
                "offerSubPgm": "09",
                "offerTs": "1658934698000",
                "purchaseInd": "L",
                "purchaseRank": "35",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "35",
                "expiryRank": "35",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
                "extlOfferId": "00219-23222-01",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "50044189",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950311494",
                "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free Pepsi Drink",
                "offerSubPgm": "09",
                "offerTs": "1656500085000",
                "purchaseInd": "L",
                "purchaseRank": "23",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "23",
                "expiryRank": "23",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-23322-00",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "50044195",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950306020",
                "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free Pepsi Drink",
                "offerSubPgm": "09",
                "offerTs": "1656500214000",
                "purchaseInd": "L",
                "purchaseRank": "24",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "24",
                "expiryRank": "24",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-23322-05",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "50044386",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950304944",
                "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free Pepsi Drink",
                "offerSubPgm": "09",
                "offerTs": "1656500117000",
                "purchaseInd": "L",
                "purchaseRank": "25",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "25",
                "expiryRank": "25",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-23322-06",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "54078384",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950272166",
                "description": "Postman 22 $0.66 when you buy 1 Postman Any variety.",
                "startDate": "1645988400000",
                "endDate": "1735585200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
                "limits": "O",
                "name": "ALEN Pinalen",
                "brand": "ALEN Pinalen",
                "offerPgm": "MF",
                "offerPrice": "$0.96 OFF",
                "offerSubPgm": "09",
                "offerTs": "1669295601000",
                "purchaseInd": "L",
                "purchaseRank": "40",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "40",
                "expiryRank": "40",
                "companionOfferIds": [],
                "disclaimer": "Test Legal stuff goes here",
                "deleted": true,
                "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
                "extlOfferId": "22238-27024-23",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "54682067",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950263927",
                "description": "Test Cancel $2.59 OFF Huggies Baby Wipes 1X when you buy ONE(1) Huggies Little Movers or Little Snugglers Diapers Valid on Giga Pack (44 - 72 ct.).",
                "startDate": "1670007600000",
                "endDate": "1717178400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/a8daa138-26e6-4d17-a054-0220a8892bce.gif",
                "limits": "O",
                "name": "Huggies",
                "brand": "Huggies",
                "offerPgm": "MF",
                "offerPrice": "$2.59 OFF Huggies Baby Wipes 1X",
                "offerSubPgm": "09",
                "offerTs": "1688756795000",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "44",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "44",
                "expiryRank": "44",
                "companionOfferIds": [],
                "disclaimer": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited. Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply. CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified. Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon. Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction. CIC® Member Coupon Integrity Program. RETAILER: K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001. Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions. ® Registered Trademark and TM Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
                "deleted": true,
                "imageId": "a8daa138-26e6-4d17-a054-0220a8892bce",
                "extlOfferId": "17546-201072-15",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "56869509",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1705950276480",
                "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
                "startDate": "1654106400000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
                "limits": "O",
                "name": "Tostitos",
                "brand": "Tostitos",
                "offerPgm": "MF",
                "offerPrice": "Free Tostitos Salsa",
                "offerSubPgm": "09",
                "offerTs": "1662509989000",
                "purchaseInd": "L",
                "purchaseRank": "36",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "36",
                "expiryRank": "36",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
                "extlOfferId": "00219-23222-02",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "57365527",
                "categoryType": "International Cuisine",
                "category": "International Cuisine",
                "clipTs": "1705950281885",
                "description": "Free New Pepsi when you buy TWO(2) New Pepsi Any variety. Items must appear on the same receipt.",
                "startDate": "1669662000000",
                "endDate": "1732820400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free New Pepsi",
                "offerSubPgm": "09",
                "offerTs": "1670260206000",
                "purchaseInd": "L",
                "purchaseRank": "30",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "30",
                "expiryRank": "30",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE OF PRODUCT & QUANTITY STATED. No more than two (2) identical coupons for same product in same day. Do not send this coupon to ColgatePalmolive. Void if transferred, sold, auctioned, reproduced or altered from original. You must pay any sales tax. RETAILER: ColgatePalmolive will reimburse the face value plus up to 10.5¢ handling if submitted in accordance with our Redemption Policy. For policy and/or coupon redemption send to: Colgate-Palmolive 1119, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value 1/100¢. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Coupon may not be bought, reproduced, transferred or sold. Void where prohibited or if transferred to any person, firm or group prior to store redemption. Valid only in the USA (not in Puerto Rico). Redeemable at Food, Drug, Discount & other stores accepting coupons. Colgate-Palmolive participates in the CIC® member Coupon Integrity Program.",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00123-053715-58",
                "hierarchies": {
                    "categories": [
                        "International Cuisine"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "59458603",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1705950275595",
                "description": "$1.00 OFF when you buy ONE(1) Tostitos Chips Any variety.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/chipsSalsa.gif",
                "limits": "O",
                "name": "Tostitos",
                "brand": "Tostitos",
                "offerPgm": "MF",
                "offerPrice": "$1.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1656500010000",
                "purchaseInd": "L",
                "purchaseRank": "37",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "37",
                "expiryRank": "37",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "chipsSalsa",
                "extlOfferId": "00219-22222-00",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "60709623",
                "categoryType": "Paper, Cleaning & Home",
                "category": "Paper, Cleaning & Home",
                "clipTs": "1705950283697",
                "description": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-DFTA - Offer-Test",
                "startDate": "1696010400000",
                "endDate": "1719770400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "U",
                "name": "$ 1.00 OFF",
                "brand": "$ 1.00 OFF",
                "offerPgm": "SC",
                "offerPrice": "$1.00 OFF",
                "offerSubPgm": "02",
                "offerTs": "1696010497324",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "28",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "28",
                "expiryRank": "28",
                "companionOfferIds": [],
                "disclaimer": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-DFTA - Offer-Test",
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "60709623-D",
                "hierarchies": {
                    "categories": [
                        "Paper, Cleaning & Home"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "60844906",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950354722",
                "description": "Offer Request Test Automation NIA",
                "startDate": "1703098800000",
                "endDate": "1736449200000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "OMS Offer Request test Automation HeadLine NIA",
                "brand": "OMS Offer Request test Automation HeadLine NIA",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703112972578",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "14",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "14",
                "expiryRank": "14",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "60844906-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "63129370",
                "categoryType": "Frozen Foods",
                "category": "Frozen Foods",
                "clipTs": "1705950346983",
                "description": "BIA on sale Item discount",
                "startDate": "1687543200000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "U",
                "name": "BIA on Sale",
                "brand": "BIA on Sale",
                "offerPgm": "SC",
                "offerPrice": "$0.49 Off",
                "offerSubPgm": "02",
                "offerTs": "1687557995000",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "17",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "17",
                "expiryRank": "17",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "63129370-D",
                "hierarchies": {
                    "categories": [
                        "Frozen Foods"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "70502927",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1706550940988",
                "description": "Free Pepsi Drink when you buy ONE(1) Pepsi Drink Any variety.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free Pepsi Drink",
                "offerSubPgm": "09",
                "offerTs": "1656500035000",
                "purchaseInd": "L",
                "purchaseRank": "8",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "8",
                "expiryRank": "8",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-221212-01",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "72715826",
                "categoryType": "Fruits & Vegetables",
                "category": "Fruits & Vegetables",
                "clipTs": "1705950279918",
                "description": "flkds",
                "startDate": "1704913200000",
                "endDate": "1746468000000",
                "events": [
                    "$5 Friday"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/7.gif",
                "limits": "U",
                "name": "fljksd",
                "brand": "fljksd",
                "offerPgm": "SC",
                "offerPrice": "fsdlk",
                "offerSubPgm": "02",
                "offerTs": "1702969593129",
                "offerProgramType": "REWARDS_ACCUMULATION",
                "offerProtoType": "REWARDS_ACCUMULATION",
                "purchaseInd": "L",
                "purchaseRank": "32",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "32",
                "expiryRank": "32",
                "companionOfferIds": [],
                "disclaimer": "fljksd",
                "deleted": true,
                "imageId": "7",
                "extlOfferId": "72715826-D",
                "hierarchies": {
                    "categories": [
                        "Fruits & Vegetables"
                    ],
                    "events": [
                        "$5 Friday"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "79319623",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1705950274681",
                "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
                "startDate": "1654106400000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
                "limits": "O",
                "name": "Tostitos",
                "brand": "Tostitos",
                "offerPgm": "MF",
                "offerPrice": "Free Tostitos Salsa",
                "offerSubPgm": "09",
                "offerTs": "1663064210000",
                "purchaseInd": "L",
                "purchaseRank": "38",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "38",
                "expiryRank": "38",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
                "extlOfferId": "00219-23222-04",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "80127773",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1706550930444",
                "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
                "startDate": "1654106400000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
                "limits": "O",
                "name": "Tostitos",
                "brand": "Tostitos",
                "offerPgm": "MF",
                "offerPrice": "Free Tostitos Salsa",
                "offerSubPgm": "09",
                "offerTs": "1665522449000",
                "purchaseInd": "L",
                "purchaseRank": "9",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "9",
                "expiryRank": "9",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
                "extlOfferId": "00219-23222-05",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "80849349",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950352691",
                "description": "erums nonhealth1",
                "startDate": "1703098800000",
                "endDate": "1767726000000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "erums nonhealth1",
                "brand": "erums nonhealth1",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703117130219",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "15",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "15",
                "expiryRank": "15",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "80849349-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "81912468",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950364905",
                "description": "erums nonhealth4",
                "startDate": "1703098800000",
                "endDate": "1720116000000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "erums nonhealth4",
                "brand": "erums nonhealth4",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703116991471",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "11",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "11",
                "expiryRank": "11",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "81912468-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "82302573",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950365920",
                "description": "erums nonhealth2",
                "startDate": "1703098800000",
                "endDate": "1726164000000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "erums nonhealth2",
                "brand": "erums nonhealth2",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703117091589",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "10",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "10",
                "expiryRank": "10",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "82302573-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "84441570",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950268610",
                "description": "test ttl",
                "startDate": "1698775200000",
                "endDate": "1731006000000",
                "events": [
                    "$3.50 off"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "test ttl",
                "brand": "test ttl",
                "offerPgm": "SC",
                "offerPrice": "test ttl",
                "offerSubPgm": "02",
                "offerTs": "1698777925180",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "43",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "43",
                "expiryRank": "43",
                "companionOfferIds": [],
                "disclaimer": "test ttl",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "84441570-D",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": [
                        "$3.50 off"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "84859477",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950271149",
                "description": "Postman 22 $0.66 when you buy 1 Postman Any variety.",
                "startDate": "1645988400000",
                "endDate": "1735585200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
                "limits": "O",
                "name": "ALEN Pinalen",
                "brand": "ALEN Pinalen",
                "offerPgm": "MF",
                "offerPrice": "$0.96 OFF",
                "offerSubPgm": "09",
                "offerTs": "1669213538000",
                "purchaseInd": "L",
                "purchaseRank": "41",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "41",
                "expiryRank": "41",
                "companionOfferIds": [],
                "disclaimer": "Test Legal stuff goes here",
                "deleted": true,
                "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
                "extlOfferId": "22238-27024-22",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "85223932",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950314702",
                "description": "$2.00 OFF when you buy ONE(1) Starbucks Espresso 4-pack Valid on 6.5 fl. oz. 4 pack.",
                "startDate": "1670007600000",
                "endDate": "1717178400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2fbfceb2-0ac9-4ff0-bcc1-4e221b9e469b.gif",
                "limits": "O",
                "name": "Starbucks",
                "brand": "Starbucks",
                "offerPgm": "MF",
                "offerPrice": "$2.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1688756308000",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "21",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "21",
                "expiryRank": "21",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Inmar Brand Solutions Dept. 12000 Mfr Rcv Office 801 UNION PACIFIC BLVD STE 5 LAREDO TX 78045-9475. Coupon expires 12/27/2022.",
                "deleted": true,
                "imageId": "2fbfceb2-0ac9-4ff0-bcc1-4e221b9e469b",
                "extlOfferId": "00219-118570-54",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "86268740",
                "categoryType": "Paper, Cleaning & Home",
                "category": "Paper, Cleaning & Home",
                "clipTs": "1705950282801",
                "description": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-BIA -Offer-Test",
                "startDate": "1696010400000",
                "endDate": "1719770400000",
                "events": [
                    "Flavor Adventure"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "U",
                "name": "SPA-Test",
                "brand": "SPA-Test",
                "offerPgm": "SC",
                "offerPrice": "$1 OFF",
                "offerSubPgm": "02",
                "offerTs": "1696012662977",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "29",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "29",
                "expiryRank": "29",
                "companionOfferIds": [],
                "disclaimer": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-BIA - Offer-Test",
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "86268740-D",
                "hierarchies": {
                    "categories": [
                        "Paper, Cleaning & Home",
                        "Personal Care & Health"
                    ],
                    "events": [
                        "Flavor Adventure"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "87601587",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950262734",
                "description": "$5.00 REBATE via PayPal when you buy TWO(2) Bread & Butter Wine Valid on TWO (2) 750mL bottles of Bread & Butter Wine and ONE (1) bread item. Items must appear on the same receipt.",
                "startDate": "1685728800000",
                "endDate": "1717178400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/814c98f1-c84b-4f98-a000-61324db5b53c.gif",
                "limits": "O",
                "name": "Bread & Butter Wine",
                "brand": "Bread & Butter Wine",
                "offerPgm": "MF",
                "offerPrice": "$5.00 REBATE via PayPal",
                "offerSubPgm": "09",
                "offerTs": "1687556052000",
                "offerProgramType": "CUSTOM",
                "offerProtoType": "CUSTOM",
                "purchaseInd": "L",
                "purchaseRank": "45",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "45",
                "expiryRank": "45",
                "companionOfferIds": [],
                "disclaimer": "Purchase required. Items must appear on the same receipt. Offer expires 12/31/22. Purchase must occur between 11/1/22 - 12/31/22. Limit one rebate per household. VALID ONLY TO LEGAL RESIDENTS OF AR, CA, CO, CT, DC, IA, ID, IL, LA, MA, MD, ME, NE, NY, OR, SD, VA, WY. AGE 21 YEARS OR OLDER. Void where prohibited by law. This rebate may not be combined with any other offer. Proof of purchase must accompany rebate submission. Receipt photo must include retailer name, date & time of purchase, product name or item code for required purchase item. Rebate payment sent via PayPal. If you do not have a PayPal account, you will receive an email notification from PayPal with instructions to create a PayPal account and must accept the payment via PayPal within 30 days or rebate funds will be forfeited. This rebate is void if assigned, sold, transferred, duplicated or reproduced in any way. Tax remains the responsibility of the consumer. Requests from groups, clubs, organizations or any other group purchase will not be honored or returned. REDEMPTION OR HANDLING OF THIS COUPON NOT ACCORDING TO ITS TERMS CONSTITUTES FRAUD. Employees and officers of Winery Exchange, affiliated companies, licensed retailers, distributors and family members residing in the same household as any of the above are not eligible. Winery Exchange reserves the right to require additional information/identification prior to honoring rebate request and to reject non-conforming rebate requests without liability of any kind. \nAdd offers to your loyalty account prior to in-store or online check-out, then redeem in the store where you regularly shop. Offers are personalized to the loyalty account holder and store associated with the holder’s loyalty account. Offers cannot be assigned or transferred and may not be redeemable in other store locations. Offers are limited to one per customer unless otherwise stated and cannot be applied to previous purchases. Using multiple accounts to exceed limits on offers and promotions is not permitted. We reserve the right to terminate accounts if we believe they are used for such activities. Offers do not apply to online orders scheduled for delivery or pickup after the offer expiration dates. Offers cannot be doubled or combined with any other offer, savings, coupon or discount. Internet/digital coupons cannot be doubled except manufacturers’ coupons, where permitted by the issuing manufacturer and accepted by participating store locations. In the event of product return, savings may be deducted from refund. All rebate offers are subject to applicable manufacturer’s additional terms. You pay applicable taxes, bottle/can deposits, and bag fees on purchased and free items. Prices may change and vary among store locations. Prices effective on the date you place an online order may not be the same on your scheduled order delivery or pickup date. Prices for products you order online generally are higher than in our physical store locations and may vary by fulfillment method chosen. Online promotions, discounts and offers may differ from those in our physical store locations. Not all items/varieties available in all store locations. Quantities limited to inventory on hand and subject to availability. Sales in retail quantities only. Some items may be subject to manufacturers’ limitations and other requirements. While supplies last. Transactional limits may apply. No rainchecks. We reserve the right to modify or cancel offers and/or correct typographical, pictorial and other ad or pricing errors. Offer void where prohibited by law and has no cash value. Add Rebate to your Digital Account – Use Your Digital Account at time of purchase – Purchase Required Product(s) – Receive your Rebate Via PayPal in 3 to 5 Business Days. Rebate payment will be made directly to the shopper’s registered email address via PayPal within 3-5 business days. If shoppers do not have a PayPal account, they receive an email at the registered address from PayPal with prompts to set up an account and claim their rebate. In the event that shopper does not claim their funds in PayPal within 30 days of receiving confirmation email, payment will be cancelled. Processing and redemption of rebates is handled by CB Neptune Holdings LLC. For any questions or inquiries regarding redemptions, please contact Albertson’s Support: https://www.albertsons.com/contact-us.html or 1-877-723-3929 or M.S 10501 P.O Box 29093, Phoenix, AZ 85038",
                "deleted": true,
                "imageId": "814c98f1-c84b-4f98-a000-61324db5b53c",
                "extlOfferId": "22275-22638-14",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "89960562",
                "categoryType": "Dairy, Eggs & Cheese",
                "category": "Dairy, Eggs & Cheese",
                "clipTs": "1705950328153",
                "description": "P13N-BIA",
                "startDate": "1680112800000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "U",
                "name": "Buy 1 Get 1",
                "brand": "Buy 1 Get 1",
                "offerPgm": "SC",
                "offerPrice": "Buy 1 Get 1",
                "offerSubPgm": "02",
                "offerTs": "1680117044000",
                "offerProgramType": "BUYX_GETX",
                "offerProtoType": "BUYX_GETX",
                "purchaseInd": "L",
                "purchaseRank": "19",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "19",
                "expiryRank": "19",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "89960562-D",
                "hierarchies": {
                    "categories": [
                        "Dairy, Eggs & Cheese"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "90798093",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950363921",
                "description": "erums nonhealth5",
                "startDate": "1703098800000",
                "endDate": "1720116000000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "erums nonhealth5",
                "brand": "erums nonhealth5",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703116925944",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "12",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "12",
                "expiryRank": "12",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "90798093-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "92687859",
                "categoryType": "International Cuisine",
                "category": "International Cuisine",
                "clipTs": "1705950280912",
                "description": "Free New Pepsi when you buy TWO(2) New Pepsi Any variety. Items must appear on the same receipt.",
                "startDate": "1669662000000",
                "endDate": "1732820400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "Free New Pepsi",
                "offerSubPgm": "09",
                "offerTs": "1669673980000",
                "purchaseInd": "L",
                "purchaseRank": "31",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "31",
                "expiryRank": "31",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE OF PRODUCT & QUANTITY STATED. No more than two (2) identical coupons for same product in same day. Do not send this coupon to ColgatePalmolive. Void if transferred, sold, auctioned, reproduced or altered from original. You must pay any sales tax. RETAILER: ColgatePalmolive will reimburse the face value plus up to 10.5¢ handling if submitted in accordance with our Redemption Policy. For policy and/or coupon redemption send to: Colgate-Palmolive 1119, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value 1/100¢. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Coupon may not be bought, reproduced, transferred or sold. Void where prohibited or if transferred to any person, firm or group prior to store redemption. Valid only in the USA (not in Puerto Rico). Redeemable at Food, Drug, Discount & other stores accepting coupons. Colgate-Palmolive participates in the CIC® member Coupon Integrity Program.",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00123-053715-57",
                "hierarchies": {
                    "categories": [
                        "International Cuisine"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "93443272",
                "categoryType": "Personal Care & Health",
                "category": "Personal Care & Health",
                "clipTs": "1705950251053",
                "description": "$1.50 OFF when you buy ONE(1) ARM & HAMMER™ Toothpaste Valid on single or twin pack.",
                "startDate": "1669662000000",
                "endDate": "1732820400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d71511d6-9ebd-4603-9214-ba48523c88a9.gif",
                "limits": "O",
                "name": "Arm & Hammer",
                "brand": "Arm & Hammer",
                "offerPgm": "MF",
                "offerPrice": "$1.50 OFF",
                "offerSubPgm": "09",
                "offerTs": "1669673689000",
                "purchaseInd": "L",
                "purchaseRank": "46",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "46",
                "expiryRank": "46",
                "companionOfferIds": [],
                "disclaimer": "Legal Description",
                "deleted": true,
                "imageId": "d71511d6-9ebd-4603-9214-ba48523c88a9",
                "extlOfferId": "00123-33200-04",
                "hierarchies": {
                    "categories": [
                        "Personal Care & Health"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "93585785",
                "categoryType": "Wine, Beer & Spirits",
                "category": "Wine, Beer & Spirits",
                "clipTs": "1705950270022",
                "description": "Postman $0.66 when you buy 1 Postman Any variety.",
                "startDate": "1645988400000",
                "endDate": "1735585200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
                "limits": "O",
                "name": "ALEN Pinalen",
                "brand": "ALEN Pinalen",
                "offerPgm": "MF",
                "offerPrice": "$0.96 OFF",
                "offerSubPgm": "09",
                "offerTs": "1669040020000",
                "purchaseInd": "L",
                "purchaseRank": "42",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "42",
                "expiryRank": "42",
                "companionOfferIds": [],
                "disclaimer": "Test Legal stuff goes here",
                "deleted": true,
                "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
                "extlOfferId": "22238-27024-21",
                "hierarchies": {
                    "categories": [
                        "Wine, Beer & Spirits"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "93656047",
                "categoryType": "Deli",
                "category": "Deli",
                "clipTs": "1705950279005",
                "description": "P13N-BIA",
                "startDate": "1679940000000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "O",
                "name": "$ 0.99 Off",
                "brand": "$ 0.99 Off",
                "offerPgm": "SC",
                "offerPrice": "$ 0.99 Off",
                "offerSubPgm": "02",
                "offerTs": "1679957211000",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "33",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "33",
                "expiryRank": "33",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "93656047-D",
                "hierarchies": {
                    "categories": [
                        "Deli"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "93683315",
                "categoryType": "Deli",
                "category": "Deli",
                "clipTs": "1705950278198",
                "description": "P13N-BIA",
                "startDate": "1679940000000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "O",
                "name": "Buy 1 Get 1",
                "brand": "Buy 1 Get 1",
                "offerPgm": "SC",
                "offerPrice": "Buy 1 Get 1",
                "offerSubPgm": "02",
                "offerTs": "1679956930000",
                "offerProgramType": "BUYX_GETX",
                "offerProtoType": "BUYX_GETX",
                "purchaseInd": "L",
                "purchaseRank": "34",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "34",
                "expiryRank": "34",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "93683315-D",
                "hierarchies": {
                    "categories": [
                        "Deli"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "95874947",
                "categoryType": "Pet Care",
                "category": "Pet Care",
                "clipTs": "1705950292757",
                "description": "Automation Testing",
                "startDate": "1706295600000",
                "endDate": "1738090800000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/test.gif",
                "limits": "O",
                "name": "Rukshesh API Auto Test MF Offer J4U API Test offers - MF Scenario",
                "brand": "Rukshesh API Auto Test MF Offer J4U API Test offers - MF Scenario",
                "offerPgm": "SC",
                "offerPrice": "Save $1.00",
                "offerTs": "1675014018000",
                "priceType": "PP",
                "purchaseInd": "L",
                "purchaseRank": "27",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "27",
                "expiryRank": "27",
                "companionOfferIds": [],
                "disclaimer": "Disclaimer",
                "deleted": true,
                "imageId": "test",
                "extlOfferId": "95874947-D",
                "hierarchies": {
                    "categories": [
                        "Bread & Bakery",
                        "Pet Care"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "96016184",
                "categoryType": "Baby Care",
                "category": "Baby Care",
                "clipTs": "1705950356402",
                "description": "erums nonhealth3",
                "startDate": "1703098800000",
                "endDate": "1735066800000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
                "limits": "O",
                "name": "erums nonhealth3",
                "brand": "erums nonhealth3",
                "offerPgm": "SC",
                "offerPrice": "$15 Savings Value",
                "offerSubPgm": "02",
                "offerTs": "1703117045616",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "13",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "13",
                "expiryRank": "13",
                "companionOfferIds": [],
                "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
                "deleted": true,
                "imageId": "9",
                "extlOfferId": "96016184-D",
                "hierarchies": {
                    "categories": [
                        "Baby Care"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "97118533",
                "categoryType": "Personal Care & Health",
                "category": "Personal Care & Health",
                "clipTs": "1705950247794",
                "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
                "startDate": "1669662000000",
                "endDate": "1732820400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
                "limits": "O",
                "name": "Gillete",
                "brand": "Gillete",
                "offerPgm": "MF",
                "offerPrice": "$3.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1670462662000",
                "purchaseInd": "L",
                "purchaseRank": "47",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "47",
                "expiryRank": "47",
                "companionOfferIds": [],
                "disclaimer": "Legal Description",
                "deleted": true,
                "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
                "extlOfferId": "00123-47400-12",
                "hierarchies": {
                    "categories": [
                        "Personal Care & Health"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "97321602",
                "categoryType": "Personal Care & Health",
                "category": "Personal Care & Health",
                "clipTs": "1705950243847",
                "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
                "startDate": "1685728800000",
                "endDate": "1717178400000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
                "limits": "O",
                "name": "Gillete",
                "brand": "Gillete",
                "offerPgm": "MF",
                "offerPrice": "$3.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1688755972000",
                "offerProgramType": "MUST_BUY",
                "offerProtoType": "MUST_BUY",
                "purchaseInd": "L",
                "purchaseRank": "49",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "49",
                "expiryRank": "49",
                "companionOfferIds": [],
                "disclaimer": "Legal Description",
                "deleted": true,
                "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
                "extlOfferId": "00123-47400-20",
                "hierarchies": {
                    "categories": [
                        "Personal Care & Health"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "97689274",
                "categoryType": "Dairy, Eggs & Cheese",
                "category": "Dairy, Eggs & Cheese",
                "clipTs": "1705950327223",
                "description": "P13N-BIA",
                "startDate": "1679940000000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "O",
                "name": "$ 0.99 Off",
                "brand": "$ 0.99 Off",
                "offerPgm": "SC",
                "offerPrice": "$ 0.99 Off",
                "offerSubPgm": "02",
                "offerTs": "1679958546000",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "20",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "20",
                "expiryRank": "20",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "97689274-D",
                "hierarchies": {
                    "categories": [
                        "Bread & Bakery",
                        "Dairy, Eggs & Cheese"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "98272723",
                "categoryType": "Frozen Foods",
                "category": "Frozen Foods",
                "clipTs": "1705950349056",
                "description": "BIA on Sale Buy X Get Y",
                "startDate": "1687543200000",
                "endDate": "1711735200000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
                "limits": "U",
                "name": "BIA on Sale",
                "brand": "BIA on Sale",
                "offerPgm": "SC",
                "offerPrice": "Buy X GET Y",
                "offerSubPgm": "02",
                "offerTs": "1687558385000",
                "offerProgramType": "BUYX_GETY",
                "offerProtoType": "BUYX_GETY",
                "purchaseInd": "L",
                "purchaseRank": "16",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "16",
                "expiryRank": "16",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "2",
                "extlOfferId": "98272723-D",
                "hierarchies": {
                    "categories": [
                        "Frozen Foods"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "99127449",
                "categoryType": "Grains, Pasta & Sides",
                "category": "Grains, Pasta & Sides",
                "clipTs": "1705950240386",
                "description": "$1.00 OFF when you buy ONE(1) Success® Rice or Quinoa Any variety.",
                "startDate": "1685642400000",
                "endDate": "1734634800000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/0cf87a57-53bd-4bbd-8c21-35c4ecc6a972.gif",
                "limits": "O",
                "name": "Success®",
                "brand": "Success®",
                "offerPgm": "MF",
                "offerPrice": "$1.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1687542341000",
                "offerProgramType": "ITEM_DISCOUNT",
                "offerProtoType": "ITEM_DISCOUNT",
                "purchaseInd": "L",
                "purchaseRank": "50",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "50",
                "expiryRank": "50",
                "companionOfferIds": [],
                "disclaimer": "Consumer: Limit one (1) coupon per purchase and quantity stated. No more than one (1) coupon for the same product in the same transaction. Retailer: Coupon will be redeemed for face value plus 8¢ handling if terms of offer have been met. Any other use constitutes fraud. VALID ONLY ON STATED PRODUCT(S). Coupon must be presented at time of purchase and prior to its expiry date. Customer must pay sales tax. No cash back or credit if coupon exceeds selling price. Void if prohibited, altered, transferred, sold, exchanged, taxed, copied or reproduced. Limit one coupon per purchase. Coupons submitted become property of the manufacturer. Reimbursement will be made only to retailer who redeemed the coupon. Cash value 1/20¢. Mail coupons to: Riviana Foods 742, P.O. Box 880001, El Paso, TX 88588-0001.",
                "deleted": true,
                "imageId": "0cf87a57-53bd-4bbd-8c21-35c4ecc6a972",
                "extlOfferId": "00227-047893-14",
                "hierarchies": {
                    "categories": [
                        "Grains, Pasta & Sides"
                    ],
                    "events": []
                },
                "etag": "default"
            },
            {
                "offerId": "375225581",
                "categoryType": "Special Offers",
                "category": "Special Offers",
                "clipTs": "1653320178650",
                "description": "This is a new offer",
                "startDate": "1612292400000",
                "endDate": "1706727600000",
                "events": [
                    "Weekly Ad Coupons"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/99999.gif",
                "limits": "U",
                "name": "New offer Feb 2021",
                "brand": "New offer Feb 2021",
                "offerPgm": "SC",
                "offerPrice": "$2.95 each",
                "offerSubPgm": "02",
                "offerTs": "1613083100000",
                "purchaseInd": "L",
                "purchaseRank": "52",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "52",
                "expiryRank": "52",
                "companionOfferIds": [],
                "disclaimer": "This is a disclaimer",
                "deleted": true,
                "imageId": "99999",
                "extlOfferId": "375225581-D",
                "hierarchies": {
                    "categories": [
                        "Special Offers"
                    ],
                    "events": [
                        "Weekly Ad Coupons"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "624266723",
                "categoryType": "Cookies, Snacks & Candy",
                "category": "Cookies, Snacks & Candy",
                "clipTs": "1692208855153",
                "description": "30-50ct Selected Varieties Lim2",
                "startDate": "1550862000000",
                "endDate": "1924974000000",
                "events": [
                    "2000NewEvent2"
                ],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/999999.gif",
                "limits": "U",
                "name": "Polaris SC offer 41",
                "brand": "Polaris SC offer 41",
                "offerPgm": "SC",
                "offerPrice": "$1.00 each",
                "offerSubPgm": "01",
                "offerTs": "1578091640000",
                "purchaseInd": "L",
                "purchaseRank": "51",
                "status": "C",
                "usageType": "U",
                "arrivalRank": "51",
                "expiryRank": "51",
                "companionOfferIds": [],
                "deleted": true,
                "imageId": "999999.gif",
                "extlOfferId": "OMSPOL00041",
                "hierarchies": {
                    "categories": [
                        "Cookies, Snacks & Candy"
                    ],
                    "events": [
                        "2000NewEvent2"
                    ]
                },
                "etag": "default"
            },
            {
                "offerId": "1096879833",
                "categoryType": "Beverages",
                "category": "Beverages",
                "clipTs": "1705950299308",
                "description": "$1.00 OFF when you buy TWO(2) Pepsi Drink Any variety. Items must appear on the same receipt.",
                "startDate": "1646161200000",
                "endDate": "1714500000000",
                "events": [],
                "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
                "limits": "O",
                "name": "Pepsi",
                "brand": "Pepsi",
                "offerPgm": "MF",
                "offerPrice": "$1.00 OFF",
                "offerSubPgm": "09",
                "offerTs": "1665086964000",
                "purchaseInd": "L",
                "purchaseRank": "26",
                "status": "C",
                "usageType": "O",
                "arrivalRank": "26",
                "expiryRank": "26",
                "companionOfferIds": [],
                "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
                "deleted": true,
                "imageId": "Pepsi",
                "extlOfferId": "00219-23222-00",
                "hierarchies": {
                    "categories": [
                        "Beverages"
                    ],
                    "events": []
                },
                "etag": "default"
            }
        ];
        this.isMockP13nCarouselDataEnabled =
            window && window['SWY'] && ['SWY'] &&
                window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.disableMockP13nCarouselData == false ? true : false;
        this.currentEnv = this.commonService.getCurrentEnviorment();
        this.GALLERY_API = this.config[this.currentEnv].baseURL;
    }
    //----------------------------------------------------------------------------
    /**
     * Current function that does not have limit or flag for the api limit param
     * currently used by j4u gallery which does not need the limit.
     */
    //-----------------------------------------------------------------------------
    getData(carouselLimitItems, isInstantAllocGrid, isBonusPath = false) {
        //instant allocation flow: checking if a user is registering through a bitly link for instant allocation
        //if they are they then will have specific parameters in URL and need to call instantAllocationGallery xapi
        const storeId = this._userInfoService.getJ4uStoreId() ? this._userInfoService.getJ4uStoreId() : this._userInfoService.getShopStoreId();
        const banner = this._userInfoService.getBanner();
        if (!isBonusPath) {
            this.GALLERY_API = this.config[this.currentEnv].baseURL;
            this.GALLERY_API = this.GALLERY_API.replace('{banner}', banner);
        }
        else {
            this.GALLERY_API = 'https://' + this.getLocationHost();
        }
        if (this.instantEventName == "new_registration" && this.instantEventDateTime != null && this.instantCorrelationId != null) {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.instantAllocation;
            this.isInstantBitlyFlow();
        }
        else {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.companionGalleryApi + "?storeId=" + storeId + '&rand=' + (Math.floor((Math.random() * 1000000))) + '&includeRedmBonusPathFPOffers=true';
            if (isBonusPath) {
                this.isBonusPathPage = isBonusPath;
                this.GALLERY_API = `${this.GALLERY_API}&includeOnlyBonusOffer=y`;
            }
        }
        this.HTTP_OPTIONS = { headers: this.aemService.getCompanionOffersxAPIHttpOptions() };
        return this.getDataUsingCache(carouselLimitItems, isInstantAllocGrid);
    }
    /**
     * Fetches coupon data either from local cache or remotely.
     * @param {string} carouselLimitItems - The maximum number of items to display in the carousel.
     * @param {string} modelConfigurationId - The ID of the model configuration to use when fetching data from the remote API.
     * @returns {Observable<any>} An Observable that emits the fetched and processed coupon data.
     */
    getP13nData(carouselLimitItems, modelConfigurationId) {
        let cachedCouponsObj = this.get('p13nCoupons');
        let dealsInfo = cachedCouponsObj?.dealsInfo;
        let clippedAmount = cachedCouponsObj?.arrClippedCoupons?.length;
        const currentTime = new Date().getTime();
        if (!dealsInfo || this.isLocalP13nDataInvalid(cachedCouponsObj, currentTime, carouselLimitItems)) {
            return this.getP13nRemoteData(Number(carouselLimitItems), modelConfigurationId);
        }
        else if (dealsInfo?.length - clippedAmount <= Number(carouselLimitItems)) {
            this.additionalResponseCount++;
            // Next clip will result in seeing clipped coupons. Need to call the API to fetch additional coupons.
            return this.getP13nRemoteData(Number(carouselLimitItems), modelConfigurationId, true);
        }
        return of(this.processAndCacheP13nCoupons(cachedCouponsObj, carouselLimitItems));
    }
    /**
     * Sorts and caches data before returning arary of items.
     * @param p13nCouponsObj Object in the format of p13nCoupons LS object
     * @param carouselLimitItems Number of items to be displayed in carousel.
     * @returns {Array} Array of first carouselLimitItems amount of objects in the array.
     */
    processAndCacheP13nCoupons(p13nCouponsObj, carouselLimitItems) {
        let sortedCouponsObj = this.processP13nCoupons(p13nCouponsObj);
        this.set('p13nCoupons', sortedCouponsObj);
        return sortedCouponsObj.dealsInfo.slice(0, carouselLimitItems);
    }
    //----------------------------------------------------------------------------
    /**
     *  Method initialises when flag offerCarouselApiBased is true for the api limit
     *  param.
     *  Will replace getData when functionality is stable and in place.
     */
    //-----------------------------------------------------------------------------
    getApiData(carouselLimitItems, isInstantAllocGrid) {
        //instant allocation flow: checking if a user is registering through a bitly link for instant allocation
        //if they are they then will have specific parameters in URL and need to call instantAllocationGallery xapi
        const storeId = this._userInfoService.getShopStoreId();
        const banner = this._userInfoService.getBanner();
        this.GALLERY_API = this.GALLERY_API.replace('{banner}', banner);
        if (this.instantEventName == "new_registration" && this.instantEventDateTime != null && this.instantCorrelationId != null) {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.instantAllocation;
            this.isInstantBitlyFlow();
        }
        else {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.companionGalleryApi + "?storeId=" + storeId + '&includeRedmBonusPathFPOffers=true';
            // NS-46825 - Add the hpGuest flag when anonymous
            if (window['AB']['COMMON'].authorize() === false) {
                this.GALLERY_API += '&hpGuest=true';
            }
            else {
                this.GALLERY_API += '&rand=' + (Math.floor((Math.random() * 1000000)));
            }
            // when the limit is set to 99999 don't send it to the backend
            if (carouselLimitItems && carouselLimitItems != 99999) {
                this.GALLERY_API += '&limit=' + carouselLimitItems;
            }
        }
        this.HTTP_OPTIONS = { headers: this.aemService.getCompanionOffersxAPIHttpOptions() };
        return this.getRemoteAPIData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
    }
    isInstantBitlyFlow() {
        //setting request body for the instant allocation xapi post call
        const externalOfferId = window['AB']['COMMON'].getURLParameterByName("externalOfferId");
        const offerId = window['AB']['COMMON'].getURLParameterByName("offerId");
        const division = window['AB']['COMMON'].getURLParameterByName("division");
        const reqBody = {
            "customerId": window['AB']['userInfo'].customerId,
            "householdId": window['AB']['userInfo'].houseId,
            "eventCorrelationId": this.instantCorrelationId,
            "eventDateTime": this.instantEventDateTime,
            "eventName": this.instantEventName,
            "storeId": window['AB']['COMMON'].getURLParameterByName("storeId") ? window['AB']['COMMON'].getURLParameterByName("storeId") : window['AB']['userInfo']['j4u'].storeId,
        };
        if (offerId && externalOfferId) {
            reqBody['offers'] = [{ "externalOfferId": externalOfferId, "offerId": offerId }];
        }
        if (division) {
            reqBody['division'] = window['AB']['COMMON'].getURLParameterByName("division");
        }
        this.instantAllocationReqBody = reqBody;
    }
    getDataUsingCache(carouselLimitItems = 99999, isInstantAllocGrid = false) {
        const abJ4uCoupons = this.get('abJ4uCoupons');
        this.isDataCached = true;
        let currentTime = new Date();
        currentTime = Date.parse(currentTime);
        if (abJ4uCoupons && !abJ4uCoupons.isHiddenEvents && !this.isBonusPathPage) {
            /* Check if LocalStorage is updated */
            if (this.isLocalDataInvalid(abJ4uCoupons, currentTime, carouselLimitItems)) {
                return this.getRemoteData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
            }
            else {
                if (window.location.href.includes('coupons-deals')) {
                    this.onCouponsAndDealsPageReload = true;
                    return this.getRemoteData(`${this.GALLERY_API}&includeOnlyBonusOffer=y`, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
                }
                else {
                    return of(this.returnFromLocalStorage(isInstantAllocGrid, abJ4uCoupons, carouselLimitItems));
                }
            }
        }
        else {
            return this.getRemoteData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
        }
    }
    returnFromLocalStorage(isInstantAllocGrid, abJ4uCoupons, carouselLimitItems) {
        if (isInstantAllocGrid) {
            return (abJ4uCoupons.instantAllocOffer);
        }
        /* Check if there is a limit of coupons */
        else if (carouselLimitItems) {
            return (this.sortMappedCoupons(abJ4uCoupons.objCoupons).splice(0, carouselLimitItems));
        }
        else {
            return (this.sortMappedCoupons(abJ4uCoupons.objCoupons));
            //  return of(abJ4uCoupons.objCoupons);
        }
    }
    getLocationHost() {
        return window.location.host;
    }
    sortMappedCoupons(data) {
        let sorted = Object.values(data).sort((a, b) => a.purchaseRank - b.purchaseRank);
        // single pass thru the array
        let couponsClipped = [];
        let couponsUnclipped = [];
        let unclippedPD = [];
        let unclippedOthers = [];
        sorted.forEach(coupon => {
            if (coupon['status'] === 'C') {
                couponsClipped.push(coupon);
            }
            if (coupon['status'] === 'U') {
                couponsUnclipped.push(coupon);
                if (coupon['offerType'] === 'PD') {
                    unclippedPD.push(coupon);
                }
                else {
                    unclippedOthers.push(coupon);
                }
            }
        });
        return [...unclippedPD, ...unclippedOthers, ...couponsClipped];
    }
    /**
     * Sorts coupons by adding new coupons to end of unclipped coupons, if any exist, and adds clipped coupons to object.
     * Returns data in format ready to use in p13nCoupons LS object.
     * @param savingData In the format of p13nCoupons LS object.
     * @param additionalCouponsResponse The response returned from the API call.
     * @returns Object in format of p13nCoupons LS object.
     */
    processP13nCoupons(savingData, additionalCouponsResponse) {
        const localCoupons = savingData?.dealsInfo ?? [];
        const localClippedCoupons = savingData?.arrClippedCoupons ?? [];
        const localCouponsMap = new Map(localCoupons.map(coupon => [coupon.offerId, coupon]));
        const mappedAdditionalCouponsResponse = this.mapP13nCoupons(additionalCouponsResponse);
        const deduplicatedCouponsResponse = this.removeDuplicates(mappedAdditionalCouponsResponse, localCouponsMap);
        const additionalClippedCoupons = deduplicatedCouponsResponse.clippedCoupons ?? [];
        const allClippedCoupons = [...localClippedCoupons, ...additionalClippedCoupons];
        // Add clipped coupons to array in the order they were clipped.
        const clippedCoupons = [];
        allClippedCoupons.forEach((offerId) => {
            let coupon = localCouponsMap.get(offerId);
            if (coupon) {
                clippedCoupons.push(coupon);
            }
        });
        const unclippedCoupons = localCoupons.filter((coupon) => coupon.status === 'U');
        const allUnclippedCoupons = additionalCouponsResponse ? [...unclippedCoupons, ...deduplicatedCouponsResponse.coupons] : unclippedCoupons;
        const coupons = savingData ?? {};
        coupons.dealsInfo = [...allUnclippedCoupons, ...clippedCoupons];
        return coupons;
    }
    removeDuplicates(mappedCouponsResponse, couponMap) {
        let clippedCoupons = mappedCouponsResponse?.clippedCoupons ?? [];
        let coupons = mappedCouponsResponse?.coupons ?? [];
        clippedCoupons = clippedCoupons.filter((couponId) => !couponMap.has(couponId));
        coupons = coupons.filter((coupon) => !couponMap.has(coupon.offerId));
        return {
            coupons,
            clippedCoupons
        };
    }
    sortByPurchaseRank(data) {
        let sorted = Object.values(data).sort((a, b) => a.purchaseRank - b.purchaseRank);
        return sorted;
    }
    isLocalDataInvalid(abJ4uCoupons, currentTime, carouselLimitItems) {
        let couponsClipped = window['AB']['COMMON'].getURLParameterByName("couponsClipped");
        if (isNaN(parseInt(couponsClipped))) {
            couponsClipped = "0";
        }
        return abJ4uCoupons.objCoupons == undefined
            || abJ4uCoupons.updatedTime == ''
            || (currentTime - Number(abJ4uCoupons.savedTime)) / 1000 / 60 > 120
            || abJ4uCoupons.storeId != window['AB'].userInfo.j4u.storeId
            || parseInt(couponsClipped) > 0
            || abJ4uCoupons.authorize != window['AB']['COMMON'].authorize()
            || abJ4uCoupons.carouselLimitItems < carouselLimitItems;
    }
    isLocalP13nDataInvalid(p13nCoupons, currentTime, carouselLimitItems) {
        let couponsClipped = window['AB']['COMMON'].getURLParameterByName("couponsClipped");
        if (isNaN(parseInt(couponsClipped))) {
            couponsClipped = "0";
        }
        return p13nCoupons.dealsInfo == undefined
            || p13nCoupons.updatedTime == ''
            || (currentTime - Number(p13nCoupons.savedTime)) / 1000 / 60 > 120
            || p13nCoupons.storeId != window['AB'].userInfo.j4u.storeId
            || parseInt(couponsClipped) > 0
            || p13nCoupons.authorize != window['AB']['COMMON'].authorize()
            || p13nCoupons.carouselLimitItems < carouselLimitItems;
    }
    getRemoteData(url, httpHeaders, carouselLimitItems, isInstantAllocGrid, isHiddenEvents) {
        this.isDataCached = false;
        let result = defer(() => of([]));
        let authorize = window['AB']['COMMON'].authorize();
        //checking to see if the instantAllocation request body is populated
        //if it is - then need to make post call to instantAllocationGallery xapi
        if (Object.keys(this.instantAllocationReqBody).length !== 0) {
            result = this._http.post(this.GALLERY_API, this.instantAllocationReqBody, this.HTTP_OPTIONS).pipe(map$1((response) => {
                if (response) {
                    let storeId = this.instantAllocationReqBody['storeId'] ? this.instantAllocationReqBody['storeId'] : window['AB'].userInfo.j4u.storeId;
                    let updatedTime = new Date();
                    updatedTime = Date.parse(updatedTime);
                    // single pass thru mapCoupons
                    let mappedCoupons = this.mapCoupons(response);
                    let objCoupons = mappedCoupons['coupons'];
                    let instantAllocOffer = mappedCoupons['instantAllocOffer'];
                    let arrClippedCoupons = mappedCoupons['couponsClipped'];
                    let savingData = {
                        storeId,
                        updatedTime,
                        objCoupons,
                        arrClippedCoupons,
                        instantAllocOffer,
                        isHiddenEvents,
                        authorize,
                        carouselLimitItems
                    };
                    this.updateabJ4uCoupons(response, savingData);
                    let objSortedCoupons = this.sortMappedCoupons(objCoupons);
                    if (this.onCouponsAndDealsPageReload) {
                        this.onCouponsAndDealsPageReload = false;
                        let abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
                        return this.returnFromLocalStorage(isInstantAllocGrid, abJ4uCoupons, carouselLimitItems);
                    }
                    else {
                        if (isInstantAllocGrid) {
                            return instantAllocOffer;
                        }
                        else if (carouselLimitItems) {
                            return objSortedCoupons.splice(0, carouselLimitItems);
                        }
                        else {
                            return objSortedCoupons;
                        }
                    }
                }
                else {
                    return '';
                }
            }));
        }
        else {
            //if not instant allocation bitly flow, make call to normal companionGalleryOffers xapi
            result = this._http.get(url, httpHeaders).pipe(map$1((response) => {
                if (response) {
                    let storeId = window['AB'].userInfo.j4u.storeId;
                    let updatedTime = new Date();
                    updatedTime = Date.parse(updatedTime);
                    // single pass thru mapCoupons
                    let mappedCoupons = this.mapCoupons(response);
                    let objCoupons = mappedCoupons['coupons'];
                    let instantAllocOffer = mappedCoupons['instantAllocOffer'];
                    let arrClippedCoupons = mappedCoupons['couponsClipped'];
                    let savingData = {
                        storeId,
                        updatedTime,
                        objCoupons,
                        arrClippedCoupons,
                        instantAllocOffer,
                        isHiddenEvents,
                        authorize,
                        carouselLimitItems
                    };
                    this.updateabJ4uCoupons(response, savingData);
                    let objSortedCoupons = this.sortMappedCoupons(objCoupons);
                    if (window['AB']?.DATALAYER) {
                        window['AB']?.DATALAYER.setP13nImpressions(response, 'deals');
                    }
                    if (this.onCouponsAndDealsPageReload) {
                        this.onCouponsAndDealsPageReload = false;
                        let abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
                        return this.returnFromLocalStorage(isInstantAllocGrid, abJ4uCoupons, carouselLimitItems);
                    }
                    else {
                        if (isInstantAllocGrid) {
                            return instantAllocOffer;
                        }
                        else if (carouselLimitItems) {
                            return objSortedCoupons.splice(0, carouselLimitItems);
                        }
                        else {
                            return objSortedCoupons;
                        }
                    }
                }
                else {
                    return '';
                }
            }));
        }
        return result;
    }
    /**
     * Creates object to be saved to LS for p13nCoupons.
     *
     * @param {Object} response API response
     * @param {Number} carouselLimitItems
     * @returns {Object} An object containing the data to be saved, including the store ID, update time, deals info, clipped coupons, authorization status, and carousel limit.
     */
    createP13nSavingData(response, carouselLimitItems) {
        const authorize = window['AB']['COMMON'].authorize();
        const storeId = window['AB'].userInfo.branchId;
        let updatedTime = new Date();
        updatedTime = Date.parse(updatedTime);
        // single pass thru mapCoupons
        let mappedCoupons = this.mapP13nCoupons(response);
        let dealsInfo = mappedCoupons['coupons'];
        let arrClippedCoupons = response?.arrClippedCoupons ? response.arrClippedCoupons : [];
        let dynamicFields = this.handleDynamicP13nFields(response);
        let savingData = {
            storeId,
            updatedTime,
            dealsInfo,
            arrClippedCoupons,
            isHiddenEvents: false,
            authorize,
            carouselLimitItems,
            ...dynamicFields
        };
        return savingData;
    }
    handleDynamicP13nFields(response) {
        let dynamicFields = {};
        this.setDynamicP13nField(dynamicFields, 'carouselTitle', response?.title);
        this.setDynamicP13nField(dynamicFields, 'webCtaText', response?.ctaText);
        this.setDynamicP13nField(dynamicFields, 'webCtaLink', response?.ctaLink);
        return dynamicFields;
    }
    setDynamicP13nField(dynamicFields, key, value) {
        if (value) {
            dynamicFields[key] = value;
        }
    }
    getP13nRemoteData(carouselLimitItems, modelConfigurationId, isAdditionalOffers) {
        let p13nOptions = { headers: new HttpHeaders(window['AB'].p13nxApiHttpOptions) };
        this.isDataCached = false;
        let localCouponObj = this.get('p13nCoupons');
        let numCouponsToFetch = isAdditionalOffers ? this.additionalCouponsAmount : carouselLimitItems + this.additionalCouponsAmount;
        let body = this.createP13nBody(numCouponsToFetch, modelConfigurationId);
        return this._http.post(this.p13nApi, body, p13nOptions).pipe(map$1((response) => {
            // response = {dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount)};
            // response = {dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems)};
            // response = isAdditionalOffers ? undefined : { dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount) };
            // response = undefined
            if (this.isMockP13nCarouselDataEnabled) {
                response = this.getMockP13nCarouselData(isAdditionalOffers, carouselLimitItems);
            }
            if (!this.isValidP13nResponse(response)) {
                return this.handleP13nRemoteDataError(localCouponObj, carouselLimitItems);
            }
            let data = isAdditionalOffers ? localCouponObj : response;
            let savingData = this.createP13nSavingData(data, carouselLimitItems);
            if (isAdditionalOffers) {
                let sortedCoupons = this.processP13nCoupons(savingData, response);
                savingData.dealsInfo = sortedCoupons.dealsInfo;
            }
            this.set('p13nCoupons', savingData);
            if (window['AB']?.DATALAYER) {
                window['AB']?.DATALAYER.setP13nImpressions(response, 'deals');
            }
            return savingData.dealsInfo.slice(0, carouselLimitItems);
        }), catchError$1(error => {
            this.additionalResponseCount--;
            return of(this.handleP13nRemoteDataError(localCouponObj, carouselLimitItems));
        }));
    }
    getMockP13nCarouselData(isAdditionalOffers, carouselLimitItems) {
        return isAdditionalOffers
            ? { dealsInfo: this.mockInitialResponse.slice((carouselLimitItems + this.additionalCouponsAmount * this.additionalResponseCount), carouselLimitItems + (this.additionalCouponsAmount * (1 + this.additionalResponseCount))) }
            : { dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount) };
    }
    isValidP13nResponse(response) {
        return response?.dealsInfo != null && response?.dealsInfo?.length > 0;
    }
    handleP13nRemoteDataError(localCouponObj, carouselLimitItems) {
        // Already have existing LS object. Can just do cache functionality.
        if (localCouponObj?.dealsInfo) {
            return this.processAndCacheP13nCoupons(localCouponObj, carouselLimitItems);
        }
        // Initial API call as no coupon obj already exists. Return empty array and do not render.
        return [];
    }
    createP13nBody(carouselLimitItems, modelConfigurationId) {
        let AB = window['AB'];
        return {
            "modelConfigurationId": modelConfigurationId,
            "assortmentChannel": AB.COMMON.getUserChannel(),
            "banner": AB.userInfo.banner,
            "storeId": AB.userInfo.branchId,
            "householdId": AB.userInfo.houseId,
            "uiPageSize": carouselLimitItems,
            "zipCode": AB.userInfo.zipcode,
            "host": window.location.origin,
            "platform": 'web'
        };
    }
    updateabJ4uCoupons(data, savingData) {
        if (this.isBonusPathPage || (!this.isBonusPathPage && window.location.href.includes('coupons-deals') && JSON.stringify(this.get("abJ4uCoupons")) != '{}')) {
            let abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
            if (abJ4uCoupons && data && data.companionGalleryOffer) {
                for (const behaviorCoupon in data.companionGalleryOffer) {
                    if (abJ4uCoupons.objCoupons[behaviorCoupon] && abJ4uCoupons.objCoupons[behaviorCoupon].offerId === behaviorCoupon) {
                        abJ4uCoupons.objCoupons[behaviorCoupon] = data.companionGalleryOffer[behaviorCoupon];
                    }
                }
                this.set('abJ4uCoupons', abJ4uCoupons);
            }
        }
        else {
            this.set('abJ4uCoupons', savingData);
        }
    }
    //----------------------------------------------------------------------------
    /**
     *  Method initialises when flag offerCarouselApiBased is true for the api limit
     *  param.
     *  Will replace getRemoteData when functionality is stable.
     *  Returns    --> response["companionGalleryOffer"]
     */
    //-----------------------------------------------------------------------------
    getRemoteAPIData(url, httpHeaders, carouselLimitItems, isInstantAllocGrid, isHiddenEvents) {
        this.isDataCached = false;
        let result = defer(() => of([]));
        //checking to see if the instantAllocation request body is populated
        //if it is - then need to make post call to instantAllocationGallery xapi
        //This call needs to be changed once the new API with length, filtering and sorting is done
        if (Object.keys(this.instantAllocationReqBody).length !== 0) {
            result = this._http.post(this.GALLERY_API, this.instantAllocationReqBody, this.HTTP_OPTIONS).pipe(map$1((response) => {
                if (response) {
                    // single pass thru mapCoupons
                    let mappedCoupons = this.mapCoupons(response);
                    let objCoupons;
                    if (window['AB']['COMMON'].authorize()) {
                        objCoupons = this.sortByPurchaseRank(mappedCoupons['coupons']);
                    }
                    else {
                        objCoupons = Object.values(mappedCoupons['coupons']);
                    }
                    let instantAllocOffer = mappedCoupons['instantAllocOffer'];
                    if (isInstantAllocGrid) {
                        return instantAllocOffer;
                    }
                    else if (carouselLimitItems) {
                        return objCoupons.splice(0, carouselLimitItems);
                    }
                    else {
                        return objCoupons;
                    }
                }
                else {
                    return '';
                }
            }));
        }
        else {
            //if not instant allocation bitly flow, make call to normal companionGalleryOffers xapi
            result = this._http.get(url, httpHeaders).pipe(map$1((response) => {
                if (response) {
                    // convert from object of objects to array of objects
                    let objCoupons;
                    // need to do this sorting because mapping the response sorts the response by offerid automatically since the primary value can be converted to numeric value
                    if (window['AB']['COMMON'].authorize()) {
                        objCoupons = this.sortByPurchaseRank(response['companionGalleryOffer']);
                    }
                    else {
                        objCoupons = Object.values(response['companionGalleryOffer']);
                    }
                    return objCoupons;
                }
                else {
                    return '';
                }
            }));
        }
        return result;
    }
    getHiddenEventsMapping(data) {
        let coupons = [];
        let couponsClipped = [];
        if (data && data.offers) {
            data.offers.forEach(coupon => {
                coupon['clipStatus'] = coupon['deleted'] ? 'U' : coupon['clipStatus'];
                if (coupon['clipStatus'] == 'C') {
                    let couponId = (typeof coupon['couponID'] == 'undefined') ? coupon['offerId'] : coupon['couponID'];
                    couponsClipped = [...couponsClipped, couponId];
                }
                var endDate = coupon['offerEndDt'];
                coupon['status'] = coupon['clipStatus'] ? coupon['clipStatus'] : "";
                coupon['category'] = coupon.category ? coupon.category : "";
                coupon['events'] = coupon['events'] ? coupon['events'] : [];
                coupon['brand'] = (coupon['titleDsc1'] ? coupon['titleDsc1'] : "") + (coupon['titleDsc2'] ? " " + coupon['titleDsc2'] : "") + (coupon['titleDsc3'] ? " " + coupon['titleDsc3'] : "");
                coupon['description'] = (coupon['prodDsc1'] ? coupon['prodDsc1'] : "") + (coupon['prodDsc2'] ? " " + coupon['prodDsc2'] : "") + (coupon['prodDsc3'] ? " " + coupon['prodDsc3'] : "");
                //hot fix for having coupons on hidden events page show correct expiration date
                if (endDate.indexOf('-') !== -1) {
                    coupon['endDate'] = endDate.split('-')[1] + '/' + endDate.split('-')[2] + '/' + endDate.split('-')[0];
                }
                else {
                    coupon['endDate'] = endDate ? new Date(endDate).getTime() : "";
                }
                coupon['startDate'] = coupon['offerStartDt'] ? new Date(coupon['offerStartDt']).getTime() : "";
                coupon['offerPrice'] = coupon['savingsValue'] ? coupon['savingsValue'] : "";
                coupon['imageId'] = coupon['imageId'] ? coupon['imageId'] : "";
                coupon['image'] = window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon['imageId'];
            });
            coupons = data.offers;
        }
        return coupons;
    }
    mapCoupons(data) {
        let couponsClipped = [];
        let coupons = [];
        let instantAllocOffer = [];
        let companionCoupons = data.companionGalleryOffer;
        if (companionCoupons != null) {
            for (var index in companionCoupons) {
                var coupon = companionCoupons[index];
                if (coupon != undefined) {
                    coupon.status = coupon.deleted ? 'U' : coupon.status;
                    coupon.offerType = (coupon.offerPgm == "PD") ? "PD" : "CC";
                    coupon.category = coupon.category ? coupon.category : coupon.categoryType;
                    coupon.brand = coupon.brand ? coupon.brand : coupon.name;
                    coupon.events = coupon.events ? coupon.events : [];
                    coupon.image = coupon.image ? coupon.image : window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon.imageId;
                    if (coupon.status == 'C') {
                        couponsClipped = [...couponsClipped, coupon.offerId];
                    }
                    else {
                        for (var event of coupon.events) {
                            if (event == 'Welcome Offers') {
                                instantAllocOffer.push(coupon);
                                coupon.instantAllocation = true;
                            }
                        }
                    }
                }
            }
            coupons = companionCoupons;
        }
        else if (data && data.offers != null) {
            coupons = this.getHiddenEventsMapping(data);
        }
        let response = {
            coupons,
            instantAllocOffer,
            couponsClipped
        };
        return response;
    }
    /**
     * Maps the p13n deals api response to an object containing two arrays for coupons and clippedCoupons.
     * @param data - API response.
     */
    mapP13nCoupons(data) {
        const fetchedCoupons = data?.dealsInfo;
        const clippedCoupons = [];
        const coupons = [];
        fetchedCoupons?.forEach((coupon) => {
            if (coupon) {
                let newCoupon = {
                    ...coupon,
                    status: coupon.deleted ? 'U' : coupon.status,
                    offerType: coupon.offerPgm == "PD" ? "PD" : "CC",
                    category: coupon.category ?? coupon.categoryType,
                    brand: coupon.brand ?? coupon.name,
                    events: coupon.events ?? [],
                    image: coupon.image ?? window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon.imageId,
                };
                if (newCoupon.status == 'C') {
                    clippedCoupons.push(newCoupon.offerId);
                }
                coupons.push(newCoupon);
            }
        });
        return { coupons, clippedCoupons };
    }
    getSubscriptionApiData() {
        const banner = this._userInfoService.getBanner();
        this.SUBSCRIPTION_API = this.config[this.currentEnv].baseURL;
        this.SUBSCRIPTION_API = this.SUBSCRIPTION_API.replace('{banner}', banner);
        this.SUBSCRIPTION_API += this.config[this.currentEnv].subscriptionAPIDetails.subscriptionApi;
        this.SUBSCRIPTION_API = this.SUBSCRIPTION_API.replace('{gid}', window['AB'].userInfo.UUID);
        const http_options = {
            'Authorization': 'Bearer ' + window['AB'].userInfo.SWY_SHOP_TOKEN,
            'Accept': 'application/vnd.safeway.v2+json',
            'banner': window['SWY'].CONFIGSERVICE.getResolvedBanner(),
            'ocp-apim-subscription-key': this.config[this.currentEnv].subscriptionAPIDetails.subscriptionKey.value,
            'Content-Type': 'application/json',
            'x-swy-client-id': 'web-portal',
            'X-SWY_BANNER': window['SWY'].CONFIGSERVICE.getResolvedBanner(),
            'cache-control': 'no-cache'
        };
        return this._http.get(this.SUBSCRIPTION_API, { headers: http_options });
    }
    set(key, data) {
        if (this.utilService.isLSCompatible()) {
            try {
                localStorage.setItem(key, JSON.stringify(data));
            }
            catch (e) {
                console.error('ERROR: WWW COUPON - SETTING IN LOCAL STORAGE', e);
            }
        }
        else {
            this.objCoupons = data;
        }
    }
    get(key) {
        this.objCoupons = {};
        if (this.utilService.isLSCompatible() && Object.keys(this.objCoupons).length === 0) {
            let strCoupons = localStorage.getItem(key);
            try {
                if (strCoupons) {
                    this.objCoupons = JSON.parse(strCoupons);
                }
            }
            catch (e) {
                console.error("ERROR: WWW COUPON - GETTING FROM LOCAL STORAGE", e);
            }
        }
        return this.objCoupons;
    }
    changeBannerOnFilter(event, modUnitParam) {
        let categoryMapping = {};
        try {
            categoryMapping = JSON.parse($('.just-for-you-category-mapping-json').text().trim());
        }
        catch (e) {
            categoryMapping = {};
        }
        // find first category or event key that matches a selected checkbox
        let selected = [];
        $("#filter_by_coupon_category :checked").each((index, elem) => { selected.push($(elem).attr('id')); });
        $("#filter_by_coupon_events :checked").each((index, elem) => { selected.push($(elem).attr('id')); });
        let categoryKey = null;
        for (let item of selected) {
            let exists = Object.keys(categoryMapping['categoryMapping']).includes(item);
            if (exists) {
                categoryKey = item;
                break;
            }
        }
        ;
        if (this.defaultModUnitImage.src == null) {
            this.defaultModUnitImage.src = $('.mod-unit img').attr('src');
            this.defaultModUnitImage.alt = $('.mod-unit img').attr('alt');
            this.defaultModUnitImage.openNewTab = $('.mod-unit img').attr('openNewTab');
            this.defaultModUnitImage.dataSrc = $('.mod-unit img').attr('data-src');
            this.defaultModUnitImage.target = $('.mod-unit a').first().attr('href');
        }
        const imagePath = 'https://images.albertsons-media.com/is/image/ABS/';
        if (categoryKey) {
            $('.mod-unit img').attr({
                src: imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam,
                alt: categoryMapping['categoryMapping'][categoryKey]['imageAltText'],
                openNewTab: categoryMapping['categoryMapping'][categoryKey]['openNewTab']
            });
            $('.mod-unit img').attr('data-src', imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam);
            $('.mod-unit a').first().attr({
                href: categoryMapping['categoryMapping'][categoryKey]['targetURL'],
            });
            $('.text-plate-container').hide();
            $('.mod-unit__card').hide();
        }
        else {
            if (this.defaultModUnitImage.src != null) {
                $('.mod-unit img').attr({
                    src: this.defaultModUnitImage.src,
                    alt: this.defaultModUnitImage.alt,
                    openNewTab: this.defaultModUnitImage.openNewTab
                });
                $('.mod-unit img').attr('data-src', this.defaultModUnitImage.dataSrc);
                $('.mod-unit a').first().attr({
                    href: this.defaultModUnitImage.target
                });
            }
            $('.text-plate-container').show();
            $('.mod-unit__card').show();
        }
    }
    initialBannerChange(filterParam, modUnitParam) {
        const filterInURL = window['AB']['COMMON'].getURLParameterByName(filterParam)
            ? window['AB']['COMMON'].getURLParameterByName(filterParam).split(',')
            : '';
        const categoryMapping = JSON.parse($('.just-for-you-category-mapping').text().trim());
        const categoryKey = Object.keys(categoryMapping.categoryMapping).find(category => category === filterInURL.toString());
        const imagePath = 'https://images.albertsons-media.com/is/image/ABS/';
        if (categoryKey && this.getURLParameter()) {
            $('.mod-unit img').attr({
                src: imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam,
                alt: categoryMapping['categoryMapping'][categoryKey]['imageAltText'],
                openNewTab: categoryMapping['categoryMapping'][categoryKey]['openNewTab']
            });
            $('.mod-unit img').attr('data-src', imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam);
            $('.mod-unit a').first().attr({
                href: categoryMapping['categoryMapping'][categoryKey]['targetURL'],
            });
            $('.text-plate-container').hide();
        }
    }
    getURLParameter() {
        const categories = window['AB']['COMMON'].getURLParameterByName('category')
            ? window['AB']['COMMON'].getURLParameterByName('category')
            : '';
        const events = window['AB']['COMMON'].getURLParameterByName('event')
            ? window['AB']['COMMON'].getURLParameterByName('event')
            : '';
        const offerType = window['AB']['COMMON'].getURLParameterByName('offerPgm')
            ? window['AB']['COMMON'].getURLParameterByName('offerPgm')
            : '';
        const filter = [];
        if (categories) {
            filter.push(categories);
        }
        if (events) {
            filter.push(events);
        }
        if (offerType) {
            filter.push(offerType);
        }
        return (filter.length < 2);
    }
    clipCoupon(coupon, storeId, configObj, isP13nCoupon, analyticsData) {
        let httpOptions = { headers: new HttpHeaders(this.aemService.getJ4uHttpOptions()) };
        const banner = this._userInfoService.getBanner();
        let clipUrl = this.config[this.currentEnv].baseURL.replace('{banner}', banner);
        clipUrl += this.config[this.currentEnv].j4uAPIDetails.clipPath + "?storeId=" + storeId;
        // if (configObj && configObj.bannerDomain) {
        //     clipUrl = configObj.bannerDomain + clipUrl;
        // }
        let result = defer(() => of({}));
        let reqBody = {};
        if (coupon.deleted) {
            reqBody = {
                items: [
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }
        else {
            reqBody = {
                items: [
                    {
                        clipType: 'C',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    },
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }
        result = this._http.post(clipUrl, reqBody, httpOptions).pipe(map$1((response) => {
            console.warn('clip response', response);
            if (response && response['items']) {
                if (response['items'][0]['status'] == 1) {
                    coupon.status = 'C';
                    coupon.deleted = false;
                    // Local Storage implementation
                    if (isP13nCoupon) {
                        this.updateP13nLocalStorage(true, coupon);
                    }
                    else {
                        this.updateLocalStorage('abJ4uCoupons', true, coupon);
                    }
                    this.couponUpdated.next({ id: coupon.offerId, deleted: false, status: 'C' });
                    this.commonService.clipEcomGalleryCoupon(coupon.offerId);
                    // update analytics data layer
                    var _coupon = {
                        "brand": coupon['instantAllocation'] ? 'welcome-offer-clip' : coupon.brand,
                        "offerType": coupon.offerPgm,
                        "offerId": coupon.offerId,
                        "offerPrice": coupon.offerPrice,
                        "carouselSection": window && window['digitalData'] && window['digitalData']['productInfo'] && window['digitalData']['productInfo'].carouselSection || ''
                    };
                    if (window && window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].clipCoupon(_coupon, analyticsData);
                    }
                }
                else if (response['items'][0]['status'] == 0) {
                    $('#errorModal').modal({ 'show': true });
                    let strError = "200: Coupon Expired";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }
                else {
                    $('#errorModal').modal({ 'show': true });
                    let strError = "200: Coupon Clip failed - status is not either 0 or 1";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }
            }
            else {
                $('#errorModal').modal({ 'show': true });
                let strError = "200: Coupon Clip failed - items is not defined ";
                if (response['errorCd'] && response['errorMsg']) {
                    strError += " " + response['errorCd'] + " " + response['errorMsg'];
                }
                window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
            }
            return response;
        }), catchError$1((err) => {
            console.error('clip error', err);
            let strError = err.status + ": Coupon Clip failed";
            if (typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }
            window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
            return null;
        }));
        //entrance point for progressive profiling
        if (window['AB'].userInfo.profileEmail === '' || window['AB'].userInfo.profilePhone === '') {
            this.triggerProgressiveProfile(isP13nCoupon);
        }
        return result;
    }
    unclipCoupon(offer) {
        let httpOptions = { headers: new HttpHeaders(this.aemService.getJ4uHttpOptions()) };
        const banner = this._userInfoService.getBanner();
        let unClipUrl = this.config[this.currentEnv].baseURL.replace('{banner}', banner);
        unClipUrl += this.config[this.currentEnv].j4uAPIDetails.unclipPath;
        let result = defer(() => of({}));
        const body = { items: [{ id: offer.id }] };
        result = this._http.post(unClipUrl, body, httpOptions).pipe(map$1((response) => {
            this.updateLocalStorage('abJ4uCoupons', false, offer);
            this.couponUpdated.next({ id: offer.referenceId, deleted: true, status: 'U' });
            this.commonService.unclipEcomGalleryCoupon(offer.referenceId);
            var _coupon = {
                "brand": offer.title,
                "offerType": offer.itemType,
                "offerId": offer.referenceId,
                "offerPrice": offer.savingsValue
            };
            window['AB']['DATALAYER'].unClipCoupon(_coupon);
            //add 'ecoupon' flag in cookie to show shop coupon has been unclipped
            window['SWY'].ENFORCEMENTUTILS.updateReInitSite('ecoupon');
            return response;
        }), catchError$1((err) => {
            console.error('Unclip error', err);
            let strError = err.status + ": Coupon UnClip failed";
            if (typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }
            window['AB']['DATALAYER'].setError(offer.id.toString(), 'coupon clipping', strError);
            return null;
        }));
        return result;
    }
    updateLocalStorage(localStorageItem, isClipped, coupon) {
        if (this.utilService.isLSCompatible() && localStorage[localStorageItem] != undefined) {
            let couponsData = JSON.parse(localStorage[localStorageItem]);
            if (couponsData) {
                couponsData['updatedOn'] = new Date().toLocaleString();
                let objCoupons = couponsData['objCoupons'];
                if (objCoupons && objCoupons[isClipped ? coupon.offerId : coupon.referenceId] != undefined) {
                    let tempCoupon = objCoupons[isClipped ? coupon.offerId : coupon.referenceId];
                    tempCoupon.status = isClipped ? 'C' : 'U';
                    tempCoupon.deleted = !isClipped;
                    /* custom code for instant allocation
                        * can be deleted once campaign is completed */
                    if (tempCoupon.instantAllocation == true && isClipped) {
                        couponsData['instantAllocOffer'] = [];
                        tempCoupon.instantAllocation = undefined;
                    }
                    else if (tempCoupon.events.includes("Welcome Offers") && !isClipped) {
                        tempCoupon.instantAllocation = true;
                        couponsData['instantAllocOffer'] = [tempCoupon];
                    }
                }
                couponsData['arrClippedCoupons'] = isClipped ? [...couponsData['arrClippedCoupons'], coupon.offerId] : couponsData['arrClippedCoupons'].filter(id => id != coupon.referenceId);
                localStorage[localStorageItem] = JSON.stringify(couponsData);
            }
        }
    }
    updateP13nLocalStorage(isClipped, coupon) {
        let key = 'p13nCoupons';
        if (this.utilService.isLSCompatible() && localStorage[key] != undefined) {
            let couponsData = JSON.parse(localStorage[key]);
            if (couponsData) {
                couponsData['updatedOn'] = new Date().toLocaleString();
                let dealsInfo = couponsData['dealsInfo'];
                let updatedCoupon = dealsInfo.find((localCoupon) => localCoupon.offerId === coupon.offerId);
                updatedCoupon.status = isClipped ? 'C' : 'U';
                updatedCoupon.deleted = !isClipped;
                couponsData['arrClippedCoupons'] = isClipped ? [...couponsData['arrClippedCoupons'], coupon.offerId] : couponsData['arrClippedCoupons'].filter(id => id != coupon.referenceId);
                localStorage[key] = JSON.stringify(couponsData);
            }
        }
    }
    broadcastCompanionGalleryOfferPOST(data) {
        this._companionGalleryOfferPOST.next(data);
    }
    /**
    * convert JSON from AEM eg. {Emilie Thanksgiving},{Weekly Ad Coupons}
    * into String array ["emilie thanksgiving", "weekly ad coupons"] for easier comparison
    */
    convertJsonArrayToStringArray(_jsonArray) {
        let _resultArray = _jsonArray.split(/[{}]/);
        let _filtered = _resultArray.map(v => v.toLowerCase()).filter(n => n).filter(item => item !== ",");
        return _filtered;
    }
    /**
    * determine the correct icon to display base on freshPass, UDC, enableDefault or default
    *        let that = {
    *            "iconImage":                           when '', will default to DEFAULT image which is SVG in HTML
    *                                                   when "LastBeforeDefaultIconImage", will display image configured in /etc/design
    *                                                   when "FreshPassIconImage", will display freshpass image
    *            "logoSVGCouponItemImageEnable" :       flag to replace DEFAULT image
    *            "logoSVGCouponItemImage" :             image to replace DEFAULT image
    *            "freshPassEnable":                     flag to enable FreshPass image (Freshpass image is base on events)
    *            "freshPassCouponEventListener":        event which Freshpass listens to
    *            "events" :                             coupon events which is use to match Freshpass event
    *            "UDCDealsEnable":                      Flag to enable UDC
    *        };
    */
    findIconToDisplay(that) {
        if (!that.iconImage) {
            that.iconImage = '';
        }
        if (that.logoSVGCouponItemImageEnable) {
            that.iconImage = "LastBeforeDefaultIconImage";
        }
        if (that.freshPassEnable && that.freshPassCouponEventListener && that.freshPassCouponEventListener.length > 0) {
            if (Array.isArray(that.events)) {
                let freshPassExist = false;
                for (let i in that.events) {
                    if ((that.freshPassCouponEventListener.map(e => e.toLowerCase())).indexOf(that.events[i].toLowerCase()) !== -1) {
                        freshPassExist = true;
                    }
                    else {
                        freshPassExist = false;
                        break;
                    }
                }
                if (freshPassExist) {
                    that.iconImage = "FreshPassIconImage"; //only display freshpass logo if ALL events are freshpass event
                }
            }
        }
        if (that.UDCDealsEnable) { //this will override freshpass event
            that.iconImage = "UDCDealIconImage";
        }
    }
    /** PROGRESSIVE PROFILING
     * user gets sent to this checkpoint if they're missing email
     * func calls mylist - if mylist is empty then progressive profiling flow will initiate
     * TODO: Add flow for when user is missing phone number when UCA API is ready
     */
    triggerProgressiveProfile(isP13nCoupon) {
        //check coupons since email is empty
        let coupons;
        let key = isP13nCoupon ? 'p13nCoupons' : 'abJ4uCoupons';
        try {
            coupons = JSON.parse(localStorage.getItem(key));
        }
        catch (e) {
            coupons = "";
        }
        // check if behaviorCoupons is available in LS
        if (coupons != null && coupons != '') {
            // check if abJ4uCoupons is available in LS
            if (coupons.arrClippedCoupons && coupons.arrClippedCoupons.length == 0) {
                this.showProgressiveProfile();
            }
        }
        else {
            //if clipped coupons not available in LS , make myList call
            this.getMyListData()
                .subscribe(data => {
                if (data) {
                    let clippedCoupons = data.shoppingLists && data.shoppingLists[0] && data.shoppingLists[0].items ? data.shoppingLists[0].items : "";
                    if (clippedCoupons == "") {
                        this.showProgressiveProfile();
                    }
                }
            }, err => {
                console.log(err);
            });
        }
    }
    /**
     * For Progressive Profiling Flow:
     * @returns data from my list API
     */
    getMyListData() {
        let currentTimeInMilliseconds = Date.now();
        let httpOptions = { headers: new HttpHeaders(this.aemService.getJ4uHttpOptions11()) };
        return this._http.get(window['AB'].myListPath + '?storeId=' + window['AB'].userInfo.j4u.storeId + '&_ws_as_ff=y&' + currentTimeInMilliseconds, httpOptions);
    }
    /**
     * For Progressive Profiling Flow:
     * shows the modal
     */
    showProgressiveProfile() {
        $('#modalProfile').modal({ 'show': true });
        window['AB'].DIVISIONAL.modalTrapKeyboard('#modalProfile');
        setTimeout(function () {
            document.getElementById('ppUsername').focus();
        }, 500);
        if (window['AB'].DATALAYER) {
            const analyticsFlow = window['AB'].userInfo.profilePhone === '' ? 'enter-mobile' : 'enter-email';
            window['AB'].DATALAYER.progressiveProfilingTracking('progressive-profile', analyticsFlow);
        }
    }
    isRewardCoupon(coupon) {
        return ((coupon.offerProgramType && this.rewardProtoTypes.includes(coupon.offerProgramType)) || (coupon.offerProtoType && this.rewardProtoTypes.includes(coupon.offerProtoType)));
    }
    getLogoList() {
        let url = `${window.location.origin}/content/experience-fragments/xf/foru/logos/master.caas.json`;
        if (window.location.href.includes('local')) {
            url = `https://www-qa1.${window['AB']['userInfo']['banner']}.com/content/experience-fragments/xf/foru/logos/master.caas.json`;
        }
        return this._http.get(url).pipe(map$1((data) => {
            const logos = data.root.responsivegrid.j4u_logos;
            const logoProps = {
                'FreshPassIconImage': {
                    logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.freshPassLogo}` : logos.freshPassLogo,
                    altText: 'Just 4 U Freshpass logo'
                },
                'LastBeforeDefaultIconImage': {
                    logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.forULogo}` : logos.forULogo,
                    altText: 'For U logo'
                },
                'RewardsIconImage': {
                    logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.rewardsLogo}` : logos.rewardsLogo,
                    altText: 'Rewards logo'
                },
                'defaultIconImage': {
                    logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.forULogo}` : logos.forULogo,
                    altText: 'Just 4 U logo'
                }
            };
            return logoProps;
        }), catchError$1(this.handleError));
    }
    handleError(errorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) &&
            errorResponse.error) {
            return throwError("error");
        }
    }
    static { this.ɵfac = function J4uV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || J4uV1Service)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(UtilService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: J4uV1Service, factory: J4uV1Service.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(J4uV1Service, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: UtilService }, { type: UserInfoService }, { type: AemService }], null); })();

/**
 * Product Carousel Service - Get all required data
 *
 * @memberof CouponCarousel
 */
class LoyaltyCarouselService {
    constructor(_http, _commonService, _j4uV1Service) {
        this._http = _http;
        this._commonService = _commonService;
        this._j4uV1Service = _j4uV1Service;
        this.AB = window["AB"];
        this.coupons = [];
        this.offersData = new BehaviorSubject({});
        this.offersDataSource = this.offersData.asObservable();
        this.slickChanges = new Subject();
        this.slickChanges$ = this.slickChanges.asObservable();
    }
    getData(couponsCarousel) {
        let arrCoupon;
        switch (couponsCarousel.carouselFilter) {
            case "pdp":
                if (this._commonService._hasLSCoupons()) {
                    arrCoupon = this._commonService.getCouponByUpc(couponsCarousel.upc);
                }
                break;
            case "aisle":
                if (this._commonService._hasLSCoupons()) {
                    arrCoupon = this._commonService.getCouponByAisleName(couponsCarousel.includePageName);
                }
                break;
            case "qualifyingoffers":
                return this._j4uV1Service.getData();
            case "j4uGallery":
                couponsCarousel.carouselOfferLimit = couponsCarousel.carouselOfferLimit
                    ? Number(couponsCarousel.carouselOfferLimit)
                    : 12;
                if (couponsCarousel.offerCarouselApiBased) {
                    return this._j4uV1Service.getApiData(couponsCarousel.carouselOfferLimit);
                }
                else {
                    return this._j4uV1Service.getData(couponsCarousel.carouselOfferLimit);
                }
            case 'p13n':
                return this._j4uV1Service.getP13nData(couponsCarousel.carouselOfferLimit, couponsCarousel.modelConfigurationId);
        }
        return of(arrCoupon);
    }
    getQualifyingOffers(data, offerId) {
        const arrCoupons = [];
        let offerCategory = data.find(function (value) {
            const offerid = value.offerId == null ? value.couponID : value.offerId;
            return offerid === offerId;
        });
        if (offerCategory !== undefined) {
            offerCategory = offerCategory.category;
            for (let index in data) {
                let objOffer = data[index];
                if (objOffer.category === offerCategory &&
                    (objOffer.offerId === null ? objOffer.couponID : objOffer.offerId) !==
                        offerId) {
                    if (objOffer.purchaseInd === "B") {
                        arrCoupons.unshift(objOffer);
                    }
                    else {
                        arrCoupons.push(objOffer);
                    }
                }
            }
        }
        return arrCoupons.splice(0, 12);
    }
    setAriaLabelForCouponCarousel(elemRef, carouselTitle) {
        let Carousel_next_button = elemRef.querySelector(".slick-next");
        let Carousel_prev_button = elemRef.querySelector(".slick-prev");
        let next_aria_label = "Next " + carouselTitle;
        let prev_aria_label = "Previous " + carouselTitle;
        if (Carousel_next_button != null) {
            Carousel_next_button.setAttribute("aria-label", next_aria_label);
            Carousel_prev_button.setAttribute("aria-label", prev_aria_label);
        }
    }
    setOffersData(data) {
        this.offersData.next(data);
    }
    static { this.ɵfac = function LoyaltyCarouselService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoyaltyCarouselService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(J4uV1Service)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoyaltyCarouselService, factory: LoyaltyCarouselService.ɵfac, providedIn: "root" }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoyaltyCarouselService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: J4uV1Service }], null); })();

class QuickAddBasketV1Service {
    static { this.QUICK_ADD_BANNER_CONST = 'quickAddBasket'; }
    constructor() {
        this._instantGroceryBasketQty = new Subject();
        this.instantGroceryBasketQty$ = this._instantGroceryBasketQty.asObservable();
        this._selectAllItems = new Subject();
        this.selectAllItems$ = this._selectAllItems.asObservable();
        this._redirectToLandingPage = new Subject();
        this.redirectToLandingPage$ = this._redirectToLandingPage.asObservable();
        this._isUserInGroup = new Subject();
        this.isUserInGroup$ = this._isUserInGroup.asObservable();
    }
    /**
     * Initializes the quick add basket with the provided products.
     * Each product is transformed into a basket item with a default quantity of 1 and selected state.
     * If a product is sold by weight and has a specific display type, a selected weight is also set.
     *
     * @param products The array of products to initialize the basket with.
     * @returns An object representing the initialized quick add basket.
     */
    initializeQuickAddBasket(products) {
        let quickAddBasket = products.map((x) => {
            let item = {
                itemId: x.id,
                qty: 1,
                selected: true
            };
            if (x?.sellByWeight === 'W' && x?.displayType === '3') {
                item.selectedWeight = Number(x.minWeight).toFixed(2);
            }
            return item;
        });
        return { cartItemsList: quickAddBasket };
    }
    /**
    * Processes the quick add basket by either initializing it with the provided products
    * if it doesn't exist or updating the existing basket. It ensures that the basket
    * contains only items present in the provided products list and adds any new items
    * from the products list that are not already in the basket.
    *
    * @param products The array of products to process against the quick add basket.
    */
    processQuickAddBasket(products) {
        let quickAddBasket = JSON.parse(localStorage.getItem(QuickAddBasketV1Service.QUICK_ADD_BANNER_CONST));
        // Create new basket if one doesn't exist.
        if (!quickAddBasket || quickAddBasket == '') {
            quickAddBasket = this.initializeQuickAddBasket(products);
        }
        else {
            // Remove any item in quick add basket not found in /smartbasket API response.
            quickAddBasket.cartItemsList = quickAddBasket.cartItemsList.filter(cartItem => (products.some(x => cartItem.itemId == x.id)));
            products.forEach((smartBasketResponseItem) => {
                let curItemId = smartBasketResponseItem.id;
                let curItemMinWeight = smartBasketResponseItem?.minWeight;
                // Item is in API response but not in quick add basket
                if (quickAddBasket.cartItemsList.filter(item => item.itemId == smartBasketResponseItem.id).length == 0) {
                    // Add the item to local storage.
                    smartBasketResponseItem?.sellByWeight === 'W' && smartBasketResponseItem?.displayType === '3' ?
                        quickAddBasket.cartItemsList.push({ itemId: curItemId, qty: 1, selectedWeight: Number(curItemMinWeight).toFixed(2), selected: true }) :
                        quickAddBasket.cartItemsList.push({ itemId: curItemId, qty: 1, selected: true });
                }
            });
        }
        this.setQuickAddBasket(quickAddBasket);
    }
    /**
     * Retrieves all selected products from the quick add basket.
     * If a product has a selected weight, it returns the item ID and selected weight;
     * otherwise, it returns the item ID and quantity.
     *
     * @returns An array of selected products from the quick add basket.
     */
    getAllSelectedProducts() {
        let products = this.quickAddBasketObject.cartItemsList.filter((item) => (item.selected)).map((item) => {
            if (item?.selectedWeight) {
                return {
                    itemId: item.itemId,
                    selectedWeight: item.selectedWeight
                };
            }
            return {
                itemId: item.itemId,
                qty: item.qty
            };
        });
        return products;
    }
    /**
     * Checks if all products in the quick add basket are selected.
     *
     * @returns A boolean indicating whether all products are selected.
     */
    areAllProductsSelected() {
        return this.quickAddBasketObject.cartItemsList.every((item) => item.selected);
    }
    /**
     * Clears the quick add basket from local storage.
     */
    clearQuickAddBasket() {
        localStorage.removeItem(QuickAddBasketV1Service.QUICK_ADD_BANNER_CONST);
        this.quickAddBasketObject = null;
    }
    /**
     * Checks if a product is selected in the quick add basket.
     *
     * @param productId The ID of the product to check.
     * @returns A boolean indicating whether the product is selected.
     */
    isProductSelected(productId) {
        return this.quickAddBasketObject.cartItemsList.find((item) => (item.itemId == productId))?.selected == true;
    }
    /**
    * Sets the selected state of a product in the quick add basket.
    *
    * @param id The ID of the product to update.
    * @param state The new selected state of the product.
    */
    setQuickAddBasketSelectedProperty(id, state) {
        this.quickAddBasketObject.cartItemsList.find((item) => (item.itemId == id)).selected = state;
        this.setQuickAddBasket(this.quickAddBasketObject);
    }
    /**
     * Updates the selected state of a product in the quick add basket and notifies subscribers.
     *
     * @param id The ID of the product to update.
     * @param state The new selected state of the product.
     */
    updateQuickAddBasketSelectedProperty(id, state) {
        this.setQuickAddBasketSelectedProperty(id, state);
    }
    /**
     * Sets the quantity of a product in the quick add basket.
     *
     * @param id The ID of the product to update.
     * @param qty The new quantity of the product.
     */
    setQuickAddBasketItemQuantity(id, qty) {
        this.quickAddBasketObject.cartItemsList.find((item) => (item.itemId == id)).qty = qty;
        this.setQuickAddBasket(this.quickAddBasketObject);
    }
    /**
     * Sets the weight of a product in the quick add basket.
     *
     * @param id The ID of the product to update.
     * @param weight The new weight of the product.
     */
    setQuickAddBasketItemWeight(id, weight) {
        let item = this.quickAddBasketObject.cartItemsList.find((item) => (item.itemId == id));
        item.selectedWeight = weight.toFixed(2);
        this.setQuickAddBasket(this.quickAddBasketObject);
    }
    /**
     * Gets the weight of a product in the quick add basket.
     *
     * @param id The ID of the product.
     * @returns The weight of the product.
     */
    getQuickAddBasketItemWeight(id) {
        return this.quickAddBasketObject.cartItemsList.find((item) => (item.itemId == id)).selectedWeight;
    }
    /**
     * Returns total amount of unique items in the quick add basket.
     */
    getAmountOfQuickAddItems() {
        return this.quickAddBasketObject.cartItemsList.length;
    }
    /**
     * Unselects all items in the quick add basket and notifies subscribers.
     */
    unselectAllItems() {
        this.quickAddBasketObject.cartItemsList = this.quickAddBasketObject.cartItemsList.map(item => ({
            ...item,
            selected: false
        }));
        this.setQuickAddBasket(this.quickAddBasketObject);
        this._selectAllItems.next(false);
    }
    /**
     * Selects all items in the quick add basket and notifies subscribers.
     */
    selectAllItems() {
        this.quickAddBasketObject.cartItemsList = this.quickAddBasketObject.cartItemsList.map(item => ({
            ...item,
            selected: true
        }));
        this.setQuickAddBasket(this.quickAddBasketObject);
        this._selectAllItems.next(true);
    }
    redirectToLandingPage() {
        this._redirectToLandingPage.next(true);
    }
    /**
       * Sets the quick add basket object and updates local storage.
       *
       * @param basket The quick add basket object to set.
       */
    setQuickAddBasket(basket) {
        this.quickAddBasketObject = basket;
        this.setQuickAddBasketLocalStorageObject(basket);
        this._instantGroceryBasketQty.next(this.calculateTotalQuickAddBasketQty(basket));
    }
    /**
     * Updates the quick add basket object in local storage.
     *
     * @param basket The quick add basket object to store.
     */
    setQuickAddBasketLocalStorageObject(basket) {
        localStorage.setItem(QuickAddBasketV1Service.QUICK_ADD_BANNER_CONST, JSON.stringify(basket));
    }
    /**
     * Calculates the total quantity of selected items in the quick add basket.
     *
     * @param basket The quick add basket object.
     * @returns The total quantity of selected items.
     */
    calculateTotalQuickAddBasketQty(basket) {
        let qscItems = basket.cartItemsList;
        return qscItems.filter((item) => (item.selected)).reduce((sum, item) => sum + item.qty, 0);
    }
    notifyUserInGroup(isUserInGroup) {
        this._isUserInGroup.next(isUserInGroup);
    }
    static { this.ɵfac = function QuickAddBasketV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuickAddBasketV1Service)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuickAddBasketV1Service, factory: QuickAddBasketV1Service.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuickAddBasketV1Service, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

// TODO: GENERATE MODEL FOR THE RESPONSE
class P13nEndpointService {
    constructor(_http, _commonService, _userInfoService, _aemService) {
        this._http = _http;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._aemService = _aemService;
    }
    getP13nProductsRecommendation(payload) {
        let httpOptions = this.generateProductRecommendationsRequestOptions();
        const url = window.location.origin + window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['p13n.genericCarousel.basePath'];
        return this._http.post(url, payload, httpOptions);
    }
    // Generates dynamic fields for the p13n request payload
    generateProductsRequestPayload(dynamicFields) {
        const payload = {
            ...dynamicFields,
            bruid: this._aemService.getCookie('_br_uid_2'),
            assortmentChannel: dynamicFields?.assortmentChannel ?? this._userInfoService.getUserChannel(),
            banner: dynamicFields?.banner ?? this._userInfoService.getBanner(),
            storeId: dynamicFields?.storeId ?? this._userInfoService.getShopStoreId(),
            host: dynamicFields?.host ?? 'www.' + this._userInfoService.getBanner() + '.com',
            pageURL: dynamicFields.pageURL ?? 'https://www.' + this._userInfoService.getBanner() + '.com' + window.location.pathname
        };
        if (this._commonService.checkAnalyticsSwyObject()) {
            let adobeIds = window['analyticsSwy'].storedData.ids;
            payload['sessionId'] = adobeIds.sessionId ? adobeIds.sessionId : '';
            payload['tntId'] = adobeIds.tntId ? adobeIds.tntId : '';
            payload['marketingCloudVisitorId'] = adobeIds.marketingCloudVisitorId ? adobeIds.marketingCloudVisitorId : '';
            payload['mboxMCSDID'] = adobeIds.mboxMCSDID ? adobeIds.mboxMCSDID : '';
            payload['edgeHost'] = adobeIds.edgeHost ? adobeIds.edgeHost : '';
        }
        // check to add cartItems to payload
        let cartItemsArr = [];
        if (this._aemService.authorize()
            && !window['SWY']?.['CONFIGSERVICE']?.featureToggleConfig?.isBPNArrayP13nDisabled) {
            cartItemsArr = this.getProductBPNFromCartObj();
            if (cartItemsArr.length > 0) {
                payload.cartItems = cartItemsArr;
            }
        }
        return payload;
    }
    addAmvcCookieInfo(payload) {
        if (!payload?.marketingCloudVisitorId) {
            // check AMVC cookie for adobe value - for when adobe analyticsSwy is not loaded yet
            let adobeCookie_AMVC = this._aemService.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg');
            if (adobeCookie_AMVC) {
                let cookie_MCMID = adobeCookie_AMVC.split('|');
                if (cookie_MCMID && cookie_MCMID?.indexOf('MCMID') > 0) {
                    payload.marketingCloudVisitorId = cookie_MCMID[cookie_MCMID?.indexOf('MCMID') + 1];
                }
            }
        }
    }
    generateProductRecommendationsRequestOptions() {
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/vnd.safeway.v2+json',
                'Ocp-Apim-Subscription-Key': window['SWY']['CONFIGSERVICE'].searchConfig['apimP13nSubscriptionKey'],
                'platform': 'web'
            })
        };
        if (this._aemService.authorize()) {
            httpOptions.headers = httpOptions.headers.set('X-access-token', window['AB']['userInfo']['SWY_SHOP_TOKEN']);
        }
        // check if on B2B site - pass http header "pgm" = "1P_B2B"
        if (window['AB']?.COMMON.isB2BSite()) {
            httpOptions.headers = httpOptions.headers.set('pgm', '1P_B2B');
        }
        return httpOptions;
    }
    // get cartitems
    getProductBPNFromCartObj() {
        let abCartString = localStorage.getItem('abCart');
        let bpnListFromCartObj = [];
        if (abCartString) {
            let abCartObj = JSON.parse(abCartString);
            if (abCartObj['cartItems']?.length > 0 && abCartObj.cartSource == 'ABS'
                && abCartObj.cartCategory == '1P') {
                abCartObj['cartItems'].forEach(item => {
                    if (item['itemId']) {
                        let itemObj = { 'bpn': item['itemId'].toString() };
                        bpnListFromCartObj.push(itemObj);
                    }
                });
            }
        }
        return bpnListFromCartObj;
    }
    static { this.ɵfac = function P13nEndpointService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || P13nEndpointService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: P13nEndpointService, factory: P13nEndpointService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(P13nEndpointService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: UserInfoService }, { type: AemService }], null); })();

class MylistService {
    constructor(http, aemService, userInfoService, _commonService) {
        this.http = http;
        this.aemService = aemService;
        this.userInfoService = userInfoService;
        this._commonService = _commonService;
        this.myListHttpHeaders = {};
        this.config = EnviormentConfig;
        this.currentEnv = '';
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }
    getMyList(storeId, isWeeklyAdPznActive) {
        const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        this.myListHttpHeaders = { ...{}, ...this.aemService.getJ4uHttpOptions11() };
        if (this.userInfoService.getSWY_SHOP_TOKEN()) {
            this.myListHttpHeaders['SWY_sso_token'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
            this.myListHttpHeaders['Swyconsumerdirectorypro'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        if (isWeeklyAdPznActive) {
            delete this.myListHttpHeaders['X-SWY_VERSION'];
            this.myListHttpHeaders['X-Swy_version'] = '4.0';
        }
        const options = {
            headers: {
                ...this.myListHttpHeaders,
            },
            params: {
                storeId: storeId,
                rand: rand,
            },
            withCredentials: true,
        };
        const banner = this.userInfoService.getBanner() || window['AB']['userInfo']['banner'];
        this.url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + banner] + window['AB'].myListPath;
        return this.http.get(this.url, options);
    }
    getMyListSync(storeId, isWeeklyAdPznActive) {
        const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        this.myListHttpHeaders = { ...{}, ...window['AB'].j4uHttpOptions11 };
        if (this.userInfoService.getSWY_SHOP_TOKEN()) {
            this.myListHttpHeaders['SWY_sso_token'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
            this.myListHttpHeaders['Swyconsumerdirectorypro'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        if (isWeeklyAdPznActive) {
            delete this.myListHttpHeaders['X-SWY_VERSION'];
            this.myListHttpHeaders['X-Swy_version'] = '4.0';
        }
        const banner = this.userInfoService.getBanner() || window['AB']['userInfo']['banner'];
        this.url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + banner] + window['AB'].myListPath + '?storeId=' + storeId + '&rand=' + rand;
        const request = new XMLHttpRequest();
        request.open('GET', this.url, false); // `false` makes the request synchronous
        Object.keys(this.myListHttpHeaders).forEach(key => {
            console.warn(key + ' : ' + this.myListHttpHeaders[key]);
            request.setRequestHeader(key, this.myListHttpHeaders[key]);
        });
        request.withCredentials = true;
        request.send(null);
        if (request.status == 200) {
            return request.responseText;
        }
        else {
            return '{}';
        }
    }
    static { this.ɵfac = function MylistService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MylistService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AemService), i0.ɵɵinject(UserInfoService), i0.ɵɵinject(CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MylistService, factory: MylistService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MylistService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1.HttpClient }, { type: AemService }, { type: UserInfoService }, { type: CommonService }], null); })();

class ZoneService {
    constructor(_http, _commonService, _aemService) {
        this._http = _http;
        this._commonService = _commonService;
        this._aemService = _aemService;
        this.setEndpoints();
        this.setSubscriptionKeys();
    }
    setEndpoints() {
        this.endpoints = { landingPageEndpoint: window?.['AB']?.targetedContentLandingEndpoint };
    }
    setSubscriptionKeys() {
        this.subscriptionKeys = { landingPageSubscriptionKey: window?.['AB']?.targetedContentLandingEndpointSubkey };
    }
    generateHttpOptions(payload) {
        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': this.subscriptionKeys.landingPageSubscriptionKey,
                'zone': payload?.zone,
                'storeId': payload?.storeId,
                'banner': payload?.banner,
                'x-swy-correlation-id': this._commonService.generateUUID()
            })
        };
        return httpOptions;
    }
    getLandingPageZoneContent(payload) {
        payload.screenName = 'landing-pages';
        let httpOptions = this.generateHttpOptions(payload);
        return this._http.post(this.endpoints.landingPageEndpoint, payload, httpOptions);
    }
    static { this.ɵfac = function ZoneService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ZoneService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService), i0.ɵɵinject(AemService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ZoneService, factory: ZoneService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZoneService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }, { type: AemService }], null); })();

class PurchasesEndpointService {
    constructor(_httpClient, _commonService) {
        this._httpClient = _httpClient;
        this._commonService = _commonService;
        this.endpointPaths = {
            smartbasket: '/purchasehistory/smartbasket/'
        };
    }
    fetchSmartBasketResponse(data) {
        const httpOptions = this.createHttpOptions(data?.headers);
        const params = this.createSmartBasketParams(data?.filterParams);
        const baseUrl = this.createBaseSmartBasketUrl(data?.basePath, data?.hhid, params);
        const finalUrl = this._commonService.generateCBAUrl(baseUrl);
        return this._httpClient.get(finalUrl, httpOptions);
    }
    createHttpOptions(headers) {
        let httpHeaders = new HttpHeaders({
            'ocp-apim-subscription-key': headers.apimKey,
            'Authorization': `Bearer ${headers.bearerToken}`,
            'accept': 'application/json'
        });
        if (headers.pgm !== undefined) {
            httpHeaders = httpHeaders.set('pgm', headers.pgm);
        }
        return { headers: httpHeaders };
    }
    createSmartBasketParams(filterParams) {
        return `availabilityCheck=true&storeId=${filterParams.branchId}&pageNo=${filterParams.pageNumber}&pageSize=50&excludeCartItems=true&placement=webquickadd`;
    }
    createBaseSmartBasketUrl(basePath, hhid, params) {
        return `${basePath}${this.endpointPaths.smartbasket}${hhid}?${params}`;
    }
    static { this.ɵfac = function PurchasesEndpointService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PurchasesEndpointService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CommonService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PurchasesEndpointService, factory: PurchasesEndpointService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PurchasesEndpointService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: CommonService }], null); })();

class CoreModule {
    static forRoot(configObj) {
        return {
            ngModule: CoreModule,
            providers: [CartService, { provide: 'configObj', useValue: configObj }]
        };
    }
    static { this.ɵfac = function CoreModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CoreModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CoreModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ABTestService,
            AemService,
            CartService,
            CartV2Service,
            CommonService,
            ConfigService,
            DatalayerService,
            UtilService,
            UserInfoService,
            ProductCouponService,
            OfferDetailService,
            CouponListService,
            ProductUtilService,
            AppConfigService,
            ArService,
            BoxtopService,
            ProductFilterService,
            IntersectionObserverService,
            SortAlV1Service,
            DatasScrollService,
            LoaderService,
            J4uV1Service,
            QuickAddBasketV1Service,
            P13nEndpointService,
            ZoneService,
            LoyaltyCarouselService,
            MylistService,
            PurchasesEndpointService,
            { provide: 'EnviormentConfig', useValue: EnviormentConfig }
        ], imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule
                ],
                providers: [
                    ABTestService,
                    AemService,
                    CartService,
                    CartV2Service,
                    CommonService,
                    ConfigService,
                    DatalayerService,
                    UtilService,
                    UserInfoService,
                    ProductCouponService,
                    OfferDetailService,
                    CouponListService,
                    ProductUtilService,
                    AppConfigService,
                    ArService,
                    BoxtopService,
                    ProductFilterService,
                    IntersectionObserverService,
                    SortAlV1Service,
                    DatasScrollService,
                    LoaderService,
                    J4uV1Service,
                    QuickAddBasketV1Service,
                    P13nEndpointService,
                    ZoneService,
                    LoyaltyCarouselService,
                    MylistService,
                    PurchasesEndpointService,
                    { provide: 'EnviormentConfig', useValue: EnviormentConfig }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CoreModule, { imports: [CommonModule] }); })();

// Data Model Export

/**
 * Generated bundle index. Do not edit.
 */

export { ABTestService, AemService, AisleCategoryModel, AppConfigService, ArService, BoxtopService, CarouselModel, CartService, CartV2Service, CommonService, ConfigService, CoreModule, CouponCarouselModel, CouponListService, CouponModel, DatalayerService, DatasScrollService, DealCarouselModel, DealModel, DealUpdateModel, EnviormentConfig, IntersectionObserverService, J4uV1Service, LoaderService, LoyaltyCarouselService, MylistService, OfferDetailService, P13nEndpointService, ProductCouponService, ProductFilterService, ProductModel, ProductUpdateModel, ProductUtilService, PurchasesEndpointService, QuickAddBasketV1Service, SortAlV1Service, SortModel, UserInfoService, UtilService, ZoneService };
